<template>
  <div>
    <div
      class="d-flex flex-column shadow-sm bg-white"
      v-if="!$runtimeEnvironment.isMobile"
    >
      <GlobalEvents
        @keyup.esc="$router.push({ name: 'home' })"
        @keyup.ctrl.90="
          () => {
            $store.commit('resetPartsList');
            configuratorStep = 0;
            clearFilters();
          }
        "
        @keyup.meta.90="
          () => {
            $store.commit('resetPartsList');
            configuratorStep = 0;
            clearFilters();
          }
        "
      />

      <portal to="progression-steps">
        <stepped-progress
          :steps="displaySteps"
          :plug-side="configuratorStep === 1 ? 'A' : 'B'"
          class="justify-content-end"
        />
      </portal>

      <portal to="side-b-modal">
        <div
          v-if="browser.browser.name !== 'Safari'"
          ref="side-b-modal"
          class="d-none side-b-modal side-b-modal-backgrop w-100 h-100 position-fixed"
          style="
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.3);
            z-index: 98;
            pointer-events: none;
          "
        >
          <div
            class="d-block bg-white rounded position-absolute side-b-modal-container"
            :style="{
              top: `${modalPosition.top}px`,
              left: `${modalPosition.right - 300}px`,
              width: `300px`,
              'z-index': 99,
              opacity: 1,
              'pointer-events': 'auto',
            }"
          >
            <div
              class="d-flex h-100 flex-column align-items-end pt-2 pb-4 px-4 justify-content-between"
            >
              <side-block :caption="$t('side')" label="B" />
              <div class="d-flex flex-column justify-content-start h-100 w-100">
                <div>
                  <img
                    :src="duplicatePic"
                    width="240"
                    @click="sideBPick = 'duplicate'"
                  />
                  <div class="custom-control custom-radio">
                    <input
                      type="radio"
                      class="custom-control-input"
                      id="duplicate"
                      :value="`duplicate`"
                      v-model="sideBPick"
                      :key="`duplicate`"
                    />
                    <label class="custom-control-label" for="duplicate">{{
                      $t("side-b-setup.duplicate-settings")
                    }}</label>
                  </div>
                </div>
                <div>
                  <img
                    :src="individualPic"
                    width="240"
                    @click="sideBPick = 'individual'"
                  />
                  <div class="custom-control custom-radio">
                    <input
                      type="radio"
                      class="custom-control-input"
                      id="individual"
                      :value="`individual`"
                      v-model="sideBPick"
                      :key="`individual`"
                    />
                    <label class="custom-control-label" for="individual">{{
                      $t("side-b-setup.individual")
                    }}</label>
                  </div>
                </div>
                <div>
                  <img
                    :src="pigtailPic"
                    width="240"
                    @click="sideBPick = 'pigtail'"
                  />
                  <div class="custom-control custom-radio">
                    <input
                      type="radio"
                      class="custom-control-input"
                      id="pigtail"
                      :value="`pigtail`"
                      v-model="sideBPick"
                      :key="`pigtail`"
                    />
                    <label class="custom-control-label" for="pigtail">{{
                      $t("side-b-setup.pigtail")
                    }}</label>
                  </div>
                </div>
              </div>
              <div class="flex">
                <button
                  class="bg-transparent border border-secondary text-secondary px-4 py-2 rounded-pill mr-2 flex-grow-1"
                  @click.prevent="
                    () => {
                      $refs['side-b-modal'].classList.remove('d-block');
                      $refs['side-b-modal'].classList.add('d-none');
                      configuratorStep -= 1;
                    }
                  "
                >
                  {{ $t("step-back") }}
                </button>
                <button
                  class="px-4 py-2 bg-saka-orange border-saka-orange border text-light rounded-pill"
                  @click.prevent="handleSideBSetup()"
                >
                  {{ $t("apply") }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <v-dialog v-else :click-to-close="false" />
      </portal>

      <modal name="save-to-project" height="auto">
        <form>
          <div class="modal-header">
            <h5 class="modal-title">{{ $t("project-modal.header") }}</h5>
            <button
              type="button"
              class="close"
              @click="$modal.hide('save-to-project')"
              aria-label="Schließen"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="artnr"
                >{{ $t("project-modal.productNumber") }}:</label
              >
              <input
                type="text"
                class="form-control form-control-sm"
                name="artnr"
                id="artnr"
                v-model="customProductNumber"
              />
            </div>

            <div class="form-group" v-if="$store.state.userData.id != 1">
              <label for="artnr">{{ $t("project-modal.project") }}:*</label>
              <select
                class="form-control form-control-sm"
                v-model="currentProjectId"
                ref="projectSelect"
              >
                <option
                  v-for="project in projects"
                  :key="parseInt(project.id)"
                  :value="parseInt(project.id)"
                >
                  {{ project.name }}
                </option>
                <option :value="-1">
                  ➕ {{ $t("project-modal.addNewProject") }}
                </option>
              </select>
            </div>

            <div v-else class="form-group">
              <label for="artnr">{{ $t("project-modal.project") }}:*</label>
              <treeselect
                v-model="currentProjectId"
                :options="projects"
                :normalizer="projectsNormalizer"
                value-format="object"
                :multiple="true"
                flat
              />
            </div>

            <div class="custom-control custom-checkbox form-group">
              <input
                id="length-independent"
                type="checkbox"
                class="custom-control-input"
                v-model="lengthIndependent"
              />
              <label class="custom-control-label" for="length-independent"
                >{{ $t("project-modal.saveLengthIndipendent") }}?</label
              >
              <small class="form-text text-muted">{{
                $t("lengthIndipendentDescription", [cableLength])
              }}</small>
            </div>

            <div class="form-group">
              <label for="name">{{ $t("project-modal.name") }}:*</label>
              <input
                type="text"
                class="form-control form-control-sm"
                name="name"
                id="name"
                disabled
                :value="
                  isPigtail
                    ? $t('title.pigtail')
                    : selectedValue('cables', 'fiberCount') === '1'
                    ? $t('title.simplexPatchCord')
                    : $t('title.duplexPatchCord')
                "
              />
            </div>

            <div class="form-group">
              <label for="description">{{ $t("project-modal.name") }}:</label>
              <textarea
                class="form-control form-control-sm"
                name="description"
                id="description"
                v-model="summary"
                disabled
                rows="6"
              ></textarea>
            </div>

            <span class="message"></span>

            <p>{{ $t("project-modal.mandatoryFields") }}</p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="px-4 py-2 rounded-pill mr-2 bg-transparent border border-secondary text-secondary"
              @click="$modal.hide('save-to-project')"
            >
              {{ $t("close") }}
            </button>
            <button
              type="submit"
              class="px-4 py-2 bg-saka-green border-0 text-light rounded-pill"
              @click.prevent="addToProject"
            >
              <i class="fas fa-check"></i> {{ $t("save") }}
            </button>
          </div>
        </form>
      </modal>

      <modal name="add-new-project" height="auto">
        <form>
          <div class="modal-header">
            <h5 class="modal-title">{{ $t("new-project-modal.header") }}</h5>
            <button
              type="button"
              class="close"
              @click="$modal.hide('add-new-project')"
              aria-label="Schließen"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="project-name"
                >{{ $t("new-project-modal.name") }}:*</label
              >
              <input
                type="text"
                class="form-control form-control-sm"
                name="project-name"
                id="project-name"
                v-model="newProjectName"
                :class="{ 'is-invalid': this.newProjectName === '' }"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="px-4 py-2 rounded-pill mr-2 bg-transparent border border-secondary text-secondary"
              @click="$modal.hide('add-new-project')"
            >
              {{ $t("close") }}
            </button>
            <button
              type="submit"
              class="px-4 py-2 bg-saka-green border-0 text-light rounded-pill"
              @click.prevent="addNewProject"
            >
              <i class="fas fa-check"></i> {{ $t("save") }}
            </button>
          </div>
        </form>
      </modal>

      <modal name="save-to-catalog" height="auto">
        <form>
          <div class="modal-header">
            <h5 class="modal-title">Konfiguriertes Kabel speichern</h5>
            <button
              type="button"
              class="close"
              @click="$modal.hide('save-to-catalog')"
              aria-label="Schließen"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="artnr">Artikelnummer:*</label>
              <input
                type="text"
                class="form-control form-control-sm"
                name="artnr"
                id="artnr"
                v-model="customProductNumber"
              />
            </div>

            <div class="custom-control custom-checkbox form-group">
              <input
                id="length-independent"
                type="checkbox"
                class="custom-control-input"
                v-model="lengthIndependent"
              />
              <label class="custom-control-label" for="length-independent"
                >Längenunabhängig speichern?</label
              >
              <small class="form-text text-muted"
                >Das Produkt wird ohne die feste Länge von {{ cableLength }}m in
                Ihren Katalog abgelgt und kann so in verschiedenen Längen
                nachbestellt werden.</small
              >
            </div>

            <div class="form-group">
              <label for="name">Bezeichnung:*</label>
              <input
                type="text"
                class="form-control form-control-sm"
                name="name"
                id="name"
                disabled
                :value="
                  isPigtail
                    ? $t('title.pigtail')
                    : selectedValue('cables', 'fiberCount') === '1'
                    ? $t('title.simplexPatchCord')
                    : $t('title.duplexPatchCord')
                "
              />
            </div>

            <div class="form-group">
              <label for="description">Beschreibung:</label>
              <textarea
                class="form-control form-control-sm"
                name="description"
                id="description"
                v-model="summary"
                disabled
                rows="6"
              ></textarea>
            </div>

            <span class="message"></span>

            <p>* gekennzeichnete Felder sind Pflichtfelder</p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="px-4 py-2 rounded-pill mr-2 bg-transparent border border-secondary text-secondary"
              @click="$modal.hide('save-to-catalog')"
            >
              {{ $t("close") }}
            </button>
            <button
              type="submit"
              class="px-4 py-2 bg-saka-green border-0 text-light rounded-pill"
              @click.prevent="addToMyCatalog"
            >
              <i class="fas fa-check"></i> {{ $t("save") }}
            </button>
          </div>
        </form>
      </modal>

      <!-- for cable face preview -->
      <v-dialog />

      <portal to="summary">
        <div class="preview-data-sheet mt-4" v-if="$store.state.summaryVisible">
          <span class="font-bold text-secondary">{{ $t("summary") }}</span>
          <p v-html="$options.filters.breakify(summary)" />
          <details v-if="$store.state.features.displayConfiguration">
            <summary>Shop-Daten</summary>
            <pre>{{ shopCable }}</pre>
          </details>
        </div>
      </portal>

      <transition mode="out-in" name="fade" tag="div">
        <configurator-step
          v-if="configuratorStep === 0"
          class="d-block px-4 py-2"
          layout="2-columns"
          key="cable-step"
          :is-pigtail="isPigtail"
          :thickness="thickness"
          :configuratorStep="configuratorStep"
        >
          <template v-slot:first-column>
            <div class="d-flex flex-wrap ml-n3">
              <custom-select
                class="w-50"
                :dropdown-color="selectedCableDropdownColor"
                :label="$t('fiber-count')"
                :items="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'cables',
                    propertyName: 'fiberCount',
                    sort: fiberCountSorting,
                  })
                "
                :disabledItems="
                  disabledItemsForScope({
                    scope: 'getters',
                    key: 'cables',
                    propertyName: 'fiberCount',
                  })
                "
                filter-key="cables"
                filter-property-name="fiberCount"
                :value="selectedValue('cables', 'fiberCount')"
                :show-unselected="
                  missingSelectionIncludes({
                    step: 0,
                    filterKey: 'cables',
                    propertyName: 'fiberCount',
                  })
                "
              />

              <custom-select
                class="w-50"
                :dropdown-color="selectedCableDropdownColor"
                :label="$t('fiber-class')"
                :items="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'cables',
                    propertyName: 'fiberClass',
                  })
                "
                :disabledItems="
                  disabledItemsForScope({
                    scope: 'getters',
                    key: 'cables',
                    propertyName: 'fiberClass',
                  })
                "
                filter-key="cables"
                filter-property-name="fiberClass"
                :value="selectedValue('cables', 'fiberClass')"
                :show-unselected="
                  missingSelectionIncludes({
                    step: 0,
                    filterKey: 'cables',
                    propertyName: 'fiberClass',
                  })
                "
              />

              <custom-select
                class="w-50"
                :dropdown-color="selectedCableDropdownColor"
                :label="`${$t('cable-manufacturer')} ${$t('cable')}`"
                :items="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'cables',
                    propertyName: 'manufacturer',
                  })
                "
                :disabledItems="
                  disabledItemsForScope({
                    scope: 'getters',
                    key: 'cables',
                    propertyName: 'manufacturer',
                  })
                "
                filter-key="cables"
                filter-property-name="manufacturer"
                :value="selectedValue('cables', 'manufacturer')"
                :show-unselected="
                  missingSelectionIncludes({
                    step: 0,
                    filterKey: 'cables',
                    propertyName: 'manufacturer',
                  })
                "
              />

              <color-select
                class="w-50"
                :label="$t('cable-color')"
                :items="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'remainingCables',
                    propertyName: 'cableColor',
                  })
                "
                :disabledItems="[] /*disabledItemsForScope({ scope: 'getters', key: 'cables', propertyName: 'cableColor'}) */"
                filter-key="cables"
                filter-property-name="cableColor"
                :value="selectedValue('cables', 'cableColor')"
                :show-unselected="
                  missingSelectionIncludes({
                    step: 0,
                    filterKey: 'cables',
                    propertyName: 'cableColor',
                  })
                "
              />

              <custom-select
                v-if="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'cables',
                    propertyName: 'cpr',
                  }).length >= 1 &&
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'cables',
                    propertyName: 'cpr',
                  })[0] !== 'undefined'
                "
                class="w-50"
                :dropdown-color="selectedCableDropdownColor"
                :label="$t('cable-cpr')"
                :items="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'cables',
                    propertyName: 'cpr',
                  })
                "
                :disabledItems="
                  disabledItemsForScope({
                    scope: 'getters',
                    key: 'cables',
                    propertyName: 'cpr',
                  })
                "
                :displayItems="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'cables',
                    propertyName: 'cpr',
                  }).map((i) => (i === 'null' ? $t('ohne') : i))
                "
                filter-key="cables"
                filter-property-name="cpr"
                :value="selectedValue('cables', 'cpr')"
                is-optional
                :show-unselected="
                  false /* missingSelectionIncludes({ step: 0, filterKey: 'cables', propertyName: 'cpr'}) */
                "
              />
            </div>
          </template>
          <template v-slot:second-column>
            <div class="d-flex flex-wrap w-100">
              <carousel-scroll-select
                :value="selectedValue('cables', 'cableType')"
                class="w-100"
                :color="selectedCableDropdownColor"
                :label="$t('cable-type')"
                type="CarouselScrollSelectCableType"
                filter-property-name="cableType"
                filter-key="cables"
                :fiber-count="selectedValue('cables', 'fiberCount')"
                :disabledItems="
                  disabledItemsForScope({
                    scope: 'getters',
                    key: 'cables',
                    propertyName: 'cableType',
                  })
                "
                :items="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'cables',
                    propertyName: 'cableType',
                  })
                "
                :show-unselected="
                  missingSelectionIncludes({
                    step: 0,
                    filterKey: 'cables',
                    propertyName: 'cableType',
                  })
                "
                :key="remountKey"
              />
            </div>
          </template>
          <portal to="configuration-navigation">
            <configuration-navigation
              @backward-click="$router.push('/')"
              :backward-active="true"
              :forward-active="true"
              @forward-click="validateAllSelectionsMade"
            />
          </portal>
        </configurator-step>
        <configurator-step
          v-else-if="configuratorStep === 1"
          class="d-block px-4 py-2"
          layout="2-columns"
          key="plug-step1"
          :is-pigtail="isPigtail"
          :overlay="'sideB'"
          :configuratorStep="configuratorStep"
        >
          <template v-slot:first-column>
            <div class="d-flex flex-wrap ml-n3">
              <custom-select
                class="w-50"
                :dropdown-color="selectedCableDropdownColor"
                :label="$t('plug-plex')"
                :items="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'plugsA',
                    propertyName: 'plex',
                  })
                "
                :disabledItems="
                  disabledItemsForScope({
                    scope: 'getters',
                    key: 'plugsA',
                    propertyName: 'plex',
                  })
                "
                :displayItems="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'plugsA',
                    propertyName: 'plex',
                  })
                    .map((item) =>
                      $i18n.locale !== 'de' ? item.replace('mit', 'with') : item
                    )
                    .map((item) =>
                      item === 'sx'
                        ? 'Simplex'
                        : item === 'dx'
                        ? 'Duplex'
                        : item
                    )
                "
                filter-key="plugsA"
                filter-property-name="plex"
                :value="selectedValue('plugsA', 'plex')"
                :show-unselected="
                  missingSelectionIncludes({
                    step: 1,
                    filterKey: 'plugsA',
                    propertyName: 'plex',
                  })
                "
              />

              <custom-select
                class="w-50"
                :dropdown-color="selectedCableDropdownColor"
                :label="$t('plug-polish')"
                :items="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'plugsA',
                    propertyName: 'polish',
                  })
                "
                :disabledItems="
                  disabledItemsForScope({
                    scope: 'getters',
                    key: 'plugsA',
                    propertyName: 'polish',
                  })
                "
                :displayItems="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'plugsA',
                    propertyName: 'polish',
                  }).map((item) => item.replace('/', ''))
                "
                filter-key="plugsA"
                filter-property-name="polish"
                :value="selectedValue('plugsA', 'polish')"
                :show-unselected="
                  missingSelectionIncludes({
                    step: 1,
                    filterKey: 'plugsA',
                    propertyName: 'polish',
                  })
                "
              />

              <custom-select
                class="w-50"
                :dropdown-color="selectedCableDropdownColor"
                :label="`${$t('plug-manufacturer')} A`"
                :items="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'plugsA',
                    propertyName: 'manufacturer',
                  })
                "
                :disabledItems="
                  disabledItemsForScope({
                    scope: 'getters',
                    key: 'plugsA',
                    propertyName: 'manufacturer',
                  })
                "
                :displayItems="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'plugsA',
                    propertyName: 'manufacturer',
                  }).map((item) =>
                    item === 'EM'
                      ? 'Euromicron'
                      : item === 'H+S'
                      ? 'Huber+Suhner'
                      : item
                  )
                "
                filter-key="plugsA"
                filter-property-name="manufacturer"
                :value="selectedValue('plugsA', 'manufacturer')"
                :show-unselected="
                  missingSelectionIncludes({
                    step: 1,
                    filterKey: 'plugsA',
                    propertyName: 'manufacturer',
                  })
                "
              />

              <custom-select
                class="w-50"
                :label="$t('plug-clip')"
                :items="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'plugsA',
                    propertyName: 'clip',
                  })
                "
                :displayItems="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'plugsA',
                    propertyName: 'clip',
                  })
                    .map((item) =>
                      $i18n.locale !== 'de' ? item.replace('mit', 'with') : item
                    )
                    .map((item) =>
                      $i18n.locale !== 'de'
                        ? item.replace('ohne', 'none')
                        : item
                    )
                "
                :disabledItems="
                  disabledItemsForScope({
                    scope: 'getters',
                    key: 'plugsA',
                    propertyName: 'clip',
                  })
                "
                filter-key="plugsA"
                filter-property-name="clip"
                :value="selectedValue('plugsA', 'clip')"
                :show-unselected="
                  missingSelectionIncludes({
                    step: 1,
                    filterKey: 'plugsA',
                    propertyName: 'clip',
                  })
                "
              />

              <color-select
                class="w-50"
                :label="$t('plug-color')"
                :items="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'remainingPlugsA',
                    propertyName: 'plugColor',
                  })
                "
                :disabledItems="[] /* disabledItemsForScope({scope: 'getters', key: 'plugsA', propertyName: 'plugColor'}) */"
                filter-key="plugsA"
                filter-property-name="plugColor"
                :value="selectedValue('plugsA', 'plugColor')"
                :show-unselected="
                  missingSelectionIncludes({
                    step: 1,
                    filterKey: 'plugsA',
                    propertyName: 'plugColor',
                  })
                "
              />
            </div>
          </template>

          <template v-slot:second-column>
            <div class="d-flex flex-column flex-wrap w-100">
              <carousel-scroll-select
                class="w-100"
                :label="$t('plug-type')"
                :items="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'plugsA',
                    propertyName: 'plugType',
                  })
                "
                :disabledItems="
                  disabledItemsForScope({
                    scope: 'getters',
                    key: 'plugsA',
                    propertyName: 'plugType',
                  })
                "
                :color="selectedValue('plugsA', 'plugColor')"
                :cable-color="selectedCableDropdownColor"
                :fiber-count="selectedValue('cables', 'fiberCount')"
                :plex="selectedValue('plugsA', 'plex')"
                type="CarouselScrollSelectPlugType"
                filter-property-name="plugType"
                filter-key="plugsA"
                :value="selectedValue('plugsA', 'plugType')"
                :mode="
                  selectedValue('cables', 'fiberClass').indexOf('OS') === 0
                    ? 'sm'
                    : 'mm'
                "
                :plug-id="
                  remainingPlugsA.length === 1 ? remainingPlugsA[0].id : null
                "
                :show-unselected="
                  missingSelectionIncludes({
                    step: 1,
                    filterKey: 'plugsA',
                    propertyName: 'plugType',
                  })
                "
              />
              <multi-color-select
                :visible="remainingPlugsA.length === 1"
                :items="bendProtectionsA"
                :label="$t('bend-protection')"
                class="mt-3 mr-4 w-50"
                :value="selectedValue('bendProtectionsA', 'id')"
                filter-key="bendProtectionsA"
                filter-property-name="id"
                :show-unselected="
                  missingSelectionIncludes({
                    step: 1,
                    filterKey: 'bendProtectionsA',
                    propertyName: 'id',
                  })
                "
              />
            </div>
          </template>

          <portal to="configuration-navigation">
            <configuration-navigation
              :forward-active="true"
              :backward-active="true"
              @backward-click="configuratorStep = 0"
              @forward-click="validateAllSelectionsMade"
            />
          </portal>
        </configurator-step>
        <configurator-step
          v-else-if="configuratorStep === 2"
          class="d-block px-4 py-2"
          layout="2-columns"
          key="plug-step2"
          :is-pigtail="isPigtail"
          :overlay="'sideA'"
          :load="showSideBSetupModal"
          :configuratorStep="configuratorStep"
        >
          <template v-slot:first-column>
            <div class="d-flex flex-wrap ml-n3">
              <custom-select
                class="w-50"
                :dropdown-color="selectedCableDropdownColor"
                :label="$t('plug-plex')"
                :items="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'plugsB',
                    propertyName: 'plex',
                  })
                "
                :disabledItems="
                  disabledItemsForScope({
                    scope: 'getters',
                    key: 'plugsB',
                    propertyName: 'plex',
                  })
                "
                :displayItems="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'plugsB',
                    propertyName: 'plex',
                  })
                    .map((item) =>
                      $i18n.locale !== 'de' ? item.replace('mit', 'with') : item
                    )
                    .map((item) =>
                      item === 'sx'
                        ? 'Simplex'
                        : item === 'dx'
                        ? 'Duplex'
                        : item
                    )
                "
                filter-key="plugsB"
                filter-property-name="plex"
                :value="selectedValue('plugsB', 'plex')"
                :show-unselected="
                  missingSelectionIncludes({
                    step: 2,
                    filterKey: 'plugsB',
                    propertyName: 'plex',
                  })
                "
              />

              <custom-select
                class="w-50"
                :dropdown-color="selectedCableDropdownColor"
                :label="$t('plug-polish')"
                :items="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'plugsB',
                    propertyName: 'polish',
                  })
                "
                :disabledItems="
                  disabledItemsForScope({
                    scope: 'getters',
                    key: 'plugsB',
                    propertyName: 'polish',
                  })
                "
                :displayItems="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'plugsB',
                    propertyName: 'polish',
                  }).map((item) => item.replace('/', ''))
                "
                filter-key="plugsB"
                filter-property-name="polish"
                :value="selectedValue('plugsB', 'polish')"
                :show-unselected="
                  missingSelectionIncludes({
                    step: 2,
                    filterKey: 'plugsB',
                    propertyName: 'polish',
                  })
                "
              />

              <custom-select
                class="w-50"
                :dropdown-color="selectedCableDropdownColor"
                :label="`${$t('plug-manufacturer')} B`"
                :items="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'plugsB',
                    propertyName: 'manufacturer',
                  })
                "
                :disabledItems="
                  disabledItemsForScope({
                    scope: 'getters',
                    key: 'plugsB',
                    propertyName: 'manufacturer',
                  })
                "
                :displayItems="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'plugsB',
                    propertyName: 'manufacturer',
                  }).map((item) =>
                    item === 'EM'
                      ? 'Euromicron'
                      : item === 'H+S'
                      ? 'Huber+Suhner'
                      : item
                  )
                "
                filter-key="plugsB"
                filter-property-name="manufacturer"
                :value="selectedValue('plugsB', 'manufacturer')"
                :show-unselected="
                  missingSelectionIncludes({
                    step: 2,
                    filterKey: 'plugsB',
                    propertyName: 'manufacturer',
                  })
                "
              />

              <custom-select
                class="w-50"
                :dropdown-color="selectedCableDropdownColor"
                :label="$t('plug-clip')"
                :items="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'plugsB',
                    propertyName: 'clip',
                  })
                "
                :displayItems="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'plugsB',
                    propertyName: 'clip',
                  })
                    .map((item) =>
                      $i18n.locale !== 'de' ? item.replace('mit', 'with') : item
                    )
                    .map((item) =>
                      $i18n.locale !== 'de'
                        ? item.replace('ohne', 'none')
                        : item
                    )
                "
                :disabledItems="
                  disabledItemsForScope({
                    scope: 'getters',
                    key: 'plugsB',
                    propertyName: 'clip',
                  })
                "
                filter-key="plugsB"
                filter-property-name="clip"
                :value="selectedValue('plugsB', 'clip')"
                :show-unselected="
                  missingSelectionIncludes({
                    step: 2,
                    filterKey: 'plugsB',
                    propertyName: 'clip',
                  })
                "
              />

              <color-select
                class="w-50"
                :label="$t('plug-color')"
                :items="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'remainingPlugsB',
                    propertyName: 'plugColor',
                  })
                "
                :disabledItems="[] /* disabledItemsForScope({scope: 'getters', key: 'plugsB', propertyName: 'plugColor'}) */"
                filter-key="plugsB"
                filter-property-name="plugColor"
                :value="selectedValue('plugsB', 'plugColor')"
                :show-unselected="
                  missingSelectionIncludes({
                    step: 2,
                    filterKey: 'plugsB',
                    propertyName: 'plugColor',
                  })
                "
              />
            </div>
          </template>
          <template v-slot:second-column>
            <div class="d-flex flex-column flex-wrap w-100">
              <carousel-scroll-select
                class="w-100"
                :label="$t('plug-type')"
                :items="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'plugsB',
                    propertyName: 'plugType',
                  })
                "
                :disabledItems="
                  disabledItemsForScope({
                    scope: 'getters',
                    key: 'plugsB',
                    propertyName: 'plugType',
                  })
                "
                :color="selectedValue('plugsB', 'plugColor')"
                :cable-color="selectedCableDropdownColor"
                :fiber-count="selectedValue('cables', 'fiberCount')"
                :plex="selectedValue('plugsB', 'plex')"
                type="CarouselScrollSelectPlugType"
                filter-property-name="plugType"
                filter-key="plugsB"
                :value="selectedValue('plugsB', 'plugType')"
                :mode="
                  selectedValue('cables', 'fiberClass').indexOf('OS') === 0
                    ? 'sm'
                    : 'mm'
                "
                :plug-id="
                  remainingPlugsB.length === 1 ? remainingPlugsB[0].id : null
                "
                :show-unselected="
                  missingSelectionIncludes({
                    step: 2,
                    filterKey: 'plugsB',
                    propertyName: 'plugType',
                  })
                "
              />
              <multi-color-select
                :visible="remainingPlugsB.length === 1"
                :items="bendProtectionsB"
                :label="$t('bend-protection')"
                class="mt-3 mr-4 w-50"
                :value="selectedValue('bendProtectionsB', 'id')"
                filter-key="bendProtectionsB"
                filter-property-name="id"
                :show-unselected="
                  missingSelectionIncludes({
                    step: 2,
                    filterKey: 'bendProtectionsB',
                    propertyName: 'id',
                  })
                "
                is-optional
              />
            </div>
          </template>

          <portal to="configuration-navigation">
            <configuration-navigation
              :forward-active="true"
              :backward-active="true"
              @backward-click="configuratorStep = 1"
              @forward-click="validateAllSelectionsMade"
            />
          </portal>
        </configurator-step>
        <configurator-step
          v-else-if="configuratorStep === 3"
          class="d-block px-4 py-2"
          layout="4-columns"
          key="options"
          :is-pigtail="isPigtail"
          :configuratorStep="configuratorStep"
        >
          <div class="d-flex w-100 obligatory-parts flex-wrap ml-n3">
            <custom-select
              class="w-25"
              :label="$t('whip-side-a')"
              :items="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'trunkWhipsA',
                  propertyName: 'id',
                  sort: whipSorting,
                })
              "
              :displayItems="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'trunkWhipsA',
                  propertyName: 'id',
                  sort: whipSorting,
                }).map(
                  (item) =>
                    $store.state.whips.filter((whip) => whip.id === item)[0]
                      .length
                )
              "
              filter-key="whipsA"
              filter-property-name="id"
              :value="selectedValue('whipsA', 'id')"
              :disabledItems="disabledWhipsA"
              :show-unselected="
                missingSelectionIncludes({
                  step: 3,
                  filterKey: 'whipsA',
                  propertyName: 'id',
                })
              "
            />

            <custom-select
              class="w-25"
              :label="$t('spreader-a')"
              v-if="
                !needsSpreader({
                  cableType: selectedValue('cables', 'cableType'),
                  plugType: selectedValue('plugsA', 'plugType'),
                })
              "
              :items="[$t('shrinking-tube')]"
              disabled
              filter-key="spreadersA"
              filter-property-name="id"
              :value="$t('shrinking-tube')"
            />
            <custom-select
              class="w-25"
              :label="$t('spreader-a')"
              reset-disabled
              v-else
              filter-key="spreadersA"
              filter-property-name="id"
              :items="
                $store.getters.spreadersA
                  .filter(
                    (spreader) =>
                      spreader.times ==
                      $store.state.partsList.plugsA.length *
                        parseInt(
                          selectedValue('plugsA', 'plex') === 'dx' ? 2 : 1
                        )
                  )
                  .map((spreader) => spreader.id)
              "
              :displayItems="
                $store.getters.spreadersA
                  .filter(
                    (spreader) =>
                      spreader.times ==
                      $store.state.partsList.plugsA.length *
                        parseInt(
                          selectedValue('plugsA', 'plex') === 'dx' ? 2 : 1
                        )
                  )
                  .map(
                    (spreader) =>
                      `${spreader.times}${
                        $i18n.locale === 'de'
                          ? '-fach Aufteiler'
                          : ' times Dividing element'
                      } ${$t(spreader.material)}`
                  )
              "
              :value="
                $store.getters.spreadersA.filter(
                  (spreader) =>
                    spreader.times ==
                    $store.state.partsList.plugsA.length *
                      parseInt(selectedValue('plugsA', 'plex') === 'dx' ? 2 : 1)
                )[0]
                  ? $store.state.spreaders.filter(
                      (spreader) =>
                        spreader.times ==
                        $store.state.partsList.plugsA.length *
                          parseInt(
                            selectedValue('plugsA', 'plex') === 'dx' ? 2 : 1
                          )
                    )[0].id
                  : null
              "
            />

            <custom-select
              class="w-25"
              :label="$t('spreader-b')"
              v-if="
                !isPigtail &&
                !needsSpreader({
                  cableType: selectedValue('cables', 'cableType'),
                  plugType: selectedValue('plugsB', 'plugType'),
                })
              "
              :items="[$t('shrinking-tube')]"
              disabled
              filter-key="spreadersB"
              filter-property-name="id"
              :value="$t('shrinking-tube')"
            />
            <custom-select
              class="w-25"
              :label="$t('spreader-b')"
              v-else-if="
                !isPigtail &&
                needsSpreader({
                  cableType: selectedValue('cables', 'cableType'),
                  plugType: selectedValue('plugsB', 'plugType'),
                })
              "
              reset-disabled
              filter-key="spreadersB"
              filter-property-name="id"
              :items="
                $store.getters.spreadersB
                  .filter(
                    (spreader) =>
                      spreader.times ==
                      $store.state.partsList.plugsB.length *
                        parseInt(
                          selectedValue('plugsB', 'plex') === 'dx' ? 2 : 1
                        )
                  )
                  .map((spreader) => spreader.id)
              "
              :displayItems="
                $store.getters.spreadersB
                  .filter(
                    (spreader) =>
                      spreader.times ==
                      $store.state.partsList.plugsB.length *
                        parseInt(
                          selectedValue('plugsB', 'plex') === 'dx' ? 2 : 1
                        )
                  )
                  .map(
                    (spreader) =>
                      `${spreader.times}${
                        $i18n.locale === 'de'
                          ? '-fach Aufteiler'
                          : ' times Dividing element'
                      } ${$t(spreader.material)}`
                  )
              "
              :value="
                $store.getters.spreadersB.filter(
                  (spreader) =>
                    spreader.times ==
                    $store.state.partsList.plugsB.length *
                      parseInt(selectedValue('plugsB', 'plex') === 'dx' ? 2 : 1)
                )[0]
                  ? $store.state.spreaders.filter(
                      (spreader) =>
                        spreader.times ==
                        $store.state.partsList.plugsB.length *
                          parseInt(
                            selectedValue('plugsB', 'plex') === 'dx' ? 2 : 1
                          )
                    )[0].id
                  : null
              "
            />
            <custom-select
              class="w-25"
              v-if="!isPigtail"
              :label="$t('whip-side-b')"
              :items="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'trunkWhipsB',
                  propertyName: 'id',
                  sort: whipSorting,
                })
              "
              :displayItems="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'trunkWhipsB',
                  propertyName: 'id',
                  sort: whipSorting,
                }).map(
                  (item) =>
                    $store.state.whips.filter((whip) => whip.id === item)[0]
                      .length
                )
              "
              filter-key="whipsB"
              filter-property-name="id"
              :value="selectedValue('whipsB', 'id')"
              :show-unselected="
                missingSelectionIncludes({
                  step: 3,
                  filterKey: 'whipsB',
                  propertyName: 'id',
                })
              "
              :disabledItems="disabledWhipsB"
            />
          </div>
          <hr />
          <div class="d-flex w-100 optional-parts flex-wrap ml-n3">
            <custom-select
              class="w-25"
              :dropdown-color="selectedCableDropdownColor"
              :label="$t('protection-side-a')"
              :items="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'protectionsA',
                  propertyName: 'id',
                })
              "
              :displayItems="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'protectionsA',
                  propertyName: 'id',
                }).map((item) =>
                  $t(
                    $store.state.protections.filter(
                      (protection) => protection.id === item
                    )[0].description
                  )
                )
              "
              filter-key="protectionsA"
              filter-property-name="id"
              :value="selectedValue('protectionsA', 'id')"
              :show-unselected="
                missingSelectionIncludes({
                  step: 3,
                  filterKey: 'protectionsA',
                  propertyName: 'id',
                })
              "
              is-optional
              :disabled-items="disabledProtectionsA"
            />
            <custom-select
              class="w-25"
              :dropdown-color="selectedCableDropdownColor"
              :label="$t('fixation-side-a')"
              :items="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'fixationsA',
                  propertyName: 'id',
                })
              "
              :displayItems="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'fixationsA',
                  propertyName: 'id',
                }).map(
                  (item) =>
                    `${
                      $store.state.fixations.filter(
                        (fixation) => fixation.id === item
                      )[0].size
                    } ${$t('inkl. Gegenmutter')}`
                )
              "
              filter-key="fixationsA"
              filter-property-name="id"
              :value="selectedValue('fixationsA', 'id')"
              :show-unselected="
                missingSelectionIncludes({
                  step: 3,
                  filterKey: 'fixationsA',
                  propertyName: 'id',
                })
              "
              is-optional
            />
            <custom-select
              class="w-25"
              v-if="!isPigtail"
              :dropdown-color="selectedCableDropdownColor"
              :label="$t('fixation-side-b')"
              :items="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'fixationsB',
                  propertyName: 'id',
                })
              "
              :displayItems="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'fixationsB',
                  propertyName: 'id',
                }).map(
                  (item) =>
                    `${
                      $store.state.fixations.filter(
                        (fixation) => fixation.id === item
                      )[0].size
                    } ${$t('inkl. Gegenmutter')}`
                )
              "
              filter-key="fixationsB"
              filter-property-name="id"
              :value="selectedValue('fixationsB', 'id')"
              :show-unselected="
                missingSelectionIncludes({
                  step: 3,
                  filterKey: 'fixationsB',
                  propertyName: 'id',
                })
              "
              is-optional
            />
            <div class="w-25" v-else />
            <custom-select
              class="w-25"
              v-if="!isPigtail"
              :dropdown-color="selectedCableDropdownColor"
              :label="$t('protection-side-b')"
              :items="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'protectionsB',
                  propertyName: 'id',
                })
              "
              :displayItems="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'protectionsB',
                  propertyName: 'id',
                }).map((item) =>
                  $t(
                    $store.state.protections.filter(
                      (protection) => protection.id === item
                    )[0].description
                  )
                )
              "
              filter-key="protectionsB"
              filter-property-name="id"
              :value="selectedValue('protectionsB', 'id')"
              :show-unselected="
                missingSelectionIncludes({
                  step: 3,
                  filterKey: 'protectionsB',
                  propertyName: 'id',
                })
              "
              is-optional
              :disabled-items="disabledProtectionsB"
            />
            <div class="w-25" v-else />

            <div class="w-25" />
            <custom-select
              class="w-25"
              is-optional
              :label="$t('options-label')"
              :items="$store.state.labels.map((label) => label.id)"
              :displayItems="
                $store.state.labels.map((label) =>
                  $t('labels.' + label.longDescription)
                )
              "
              filter-key="labelsA"
              filter-property-name="id"
              :value="selectedValue('labelsA', 'id')"
            />
            <custom-select
              class="w-25"
              v-if="!isPigtail"
              is-optional
              :label="$t('options-label')"
              :items="$store.state.labels.map((label) => label.id)"
              :displayItems="
                $store.state.labels.map((label) =>
                  $t('labels.' + label.longDescription)
                )
              "
              filter-key="labelsB"
              filter-property-name="id"
              :value="selectedValue('labelsB', 'id')"
            />
            <div class="w-25" v-else />
            <div class="w-25" />
            <!-- <div class="d-flex flex-wrap pl-4 w-100">
                <div class="d-flex flex-column w-100">
                  <label class="text-secondary"><small>{{ $t('options-custom-serial-side-a') }}</small></label>
                  <input type="text" class="border border-bottom-0" v-model="$store.state.customLabelSideA.line1" maxlength="15"/>
                  <input type="text" class="border border-top-0" v-model="$store.state.customLabelSideA.line2" maxlength="15"/>
                </div>
              </div> -->
            <!-- <div class="d-flex flex-wrap pl-4 align-self-end w-100" v-if="!isPigtail">
                <div class="d-flex flex-column w-100">
                  <label class="text-secondary"><small>{{ $t('options-custom-serial-side-b') }}</small></label>
                  <input type="text" class="border border-bottom-0" v-model="$store.state.customLabelSideB.line1" maxlength="15"/>
                  <input type="text" class="border border-top-0" v-model="$store.state.customLabelSideB.line2" maxlength="15"/>
                </div>
              </div> -->
          </div>

          <portal to="configuration-navigation">
            <configuration-navigation
              :forward-active="true"
              @forward-click="
                () => {
                  this.fetchDataSheetAndMoveForward();
                  this.setOptions();
                }
              "
              :backward-active="true"
              @backward-click="configuratorStep = 2"
            />
          </portal>
        </configurator-step>
        <configurator-step
          v-else-if="configuratorStep === 4"
          class="d-block px-4 py-2"
          layout="2-columns"
          key="done"
          :is-pigtail="isPigtail"
          :configuratorStep="configuratorStep"
          :load="
            () => {
              $store.state.features.fetchProductNumberEnabled
                ? setupAndResolveProductNumber()
                : () => {};
              triggerLastStep();
            }
          "
        >
          <fetch-price :cable-length="parseFloat($store.state.cableLength)">
            <div slot-scope="{ price, loading }">
              <p
                class="w-full bg-saka-grey text-light text-center h6 py-3 font-weight-bolder mb-0"
              >
                <i class="fas fa-check"></i> {{ $t("configuration-done") }}
              </p>

              <table class="table mb-0">
                <tbody>
                  <tr class="text-secondary">
                    <td class="pl-0 pb-0 pt-3 w-25">
                      <small>{{ $t("quantity") }}</small>
                    </td>
                    <td class="pl-0 pb-0 pt-3 w-25">
                      <small>{{ $t("delivery-time") }}</small>
                    </td>
                    <td class="pl-0 pb-0 pt-3 w-25">
                      <small
                        v-if="$store.state.loggedIn && $store.state.showPrice"
                        >{{ $t("price") }}</small
                      >
                    </td>
                    <td class="pl-0 pb-0 pt-3 w-25">
                      <small
                        v-if="$store.state.loggedIn && $store.state.showPrice"
                        >{{ $t("total") }}</small
                      >
                    </td>
                  </tr>
                  <tr class="font-weight-bolder bg-light">
                    <td class="pl-0 py-2 w-25">
                      <input
                        type="number"
                        min="1"
                        max="999"
                        step="1"
                        v-if="$store.state.showPrice"
                        :value="quantity"
                        @change="
                          ($event) => {
                            quantity = Math.floor(
                              $event.target.value
                            ); /* whole numbers only */
                          }
                        "
                        class="w-50 text-right border border-saka-grey rounded ml-1 font-weight-bolder"
                      />
                      <span v-else class="text-right ml-1 font-weight-bolder"
                        >-</span
                      >
                    </td>
                    <td class="pl-0 py-2 w-25">{{ $t("days", ["7-14"]) }}</td>
                    <div v-if="!showDigikey" style="display: contents">
                      <td class="pl-0 py-2 w-25">
                        <span
                          v-if="$store.state.loggedIn && $store.state.showPrice"
                        >
                          {{
                            new Intl.NumberFormat("de-DE", {
                              style: "currency",
                              currency: "EUR",
                            }).format(
                              price +
                                (price / 100) *
                                  $store.state.pricingRequestData.surcharge
                            )
                          }}
                        </span>
                      </td>
                      <td class="pl-0 py-2 w-25">
                        <span
                          v-if="$store.state.loggedIn && $store.state.showPrice"
                        >
                          {{
                            new Intl.NumberFormat("de-DE", {
                              style: "currency",
                              currency: "EUR",
                            }).format(
                              (parseFloat(price.toFixed(2)) +
                                (parseFloat(price.toFixed(2)) / 100) *
                                  $store.state.pricingRequestData.surcharge) *
                                quantity
                            )
                          }}
                        </span>
                      </td>
                    </div>
                    <div v-else style="display: contents">
                      <td class="pl-0 py-2 w-25">
                        <span
                          v-if="$store.state.loggedIn && $store.state.showPrice"
                        >
                          <span
                            v-if="
                              $store.state.loggedIn && $store.state.showPrice
                            "
                          >
                            {{
                              new Intl.NumberFormat("de-DE", {
                                style: "currency",
                                currency: "EUR",
                              }).format(
                                parseFloat(price.toFixed(2)) *
                                  (1 + surchargeDigikey / 100) *
                                  (1 + currency_adjustment_percent / 100)
                              )
                            }}
                          </span>
                        </span>
                      </td>
                      <td class="pl-0 py-2 w-25">
                        <span
                          v-if="$store.state.loggedIn && $store.state.showPrice"
                        >
                          {{
                            new Intl.NumberFormat("de-DE", {
                              style: "currency",
                              currency: "EUR",
                            }).format(
                              parseFloat(price.toFixed(2)) *
                                (1 + surchargeDigikey / 100) *
                                (1 + currency_adjustment_percent / 100) *
                                quantity
                            )
                          }}
                        </span>
                      </td>
                    </div>
                  </tr>
                </tbody>
              </table>

              <div class="d-flex mt-5" v-if="!$store.state.getsNewCatalog">
                <div class="w-25 pl-1">
                  <a
                    v-if="
                      $store.state.loggedIn &&
                      !$store.state.respecifyId &&
                      $store.state.showPrice
                    "
                    href="#"
                    :disabled="loading"
                    ref="addToMyCatalog"
                    @click.prevent="$modal.show('save-to-catalog')"
                    class="text-secondary d-inline-flex align-items-center"
                    v-html="$t('saveToMyCatalogue')"
                  >
                  </a>
                  <a
                    v-else-if="
                      $store.state.loggedIn &&
                      $store.state.respecifyId &&
                      $store.state.showPrice
                    "
                    href="#"
                    ref="saveRespcification"
                    @click.prevent="saveRespecification"
                    class="text-secondary d-inline-flex align-items-center"
                    v-html="
                      `<i class='fas fa-sync mr-1 text-saka-orange'></i><u>Als Kabel ${$store.state.respecifyId} überschreiben</u>`
                    "
                  >
                  </a>
                </div>
                <div class="w-25">
                  <a
                    v-if="browser.browser.name === 'Safari' /* Safari */"
                    class="text-secondary d-inline-flex align-items-center"
                    disabled
                    v-html="$t('datasheet-safari-incompatible')"
                  >
                  </a>
                  <a
                    v-else-if="
                      browser.browser.name === 'Internet Explorer' ||
                      (browser.browser.name === 'Microsoft Edge' &&
                        browser.engine.name === 'EdgeHTML') /* IE, alter Edge */
                    "
                    @click="IEDataSheetDownload"
                    href="#"
                    class="text-secondary d-inline-flex align-items-center"
                    v-html="
                      dataSheetIsLoading
                        ? $t('generating-datasheet')
                        : $t('download-datasheet')
                    "
                  >
                  </a>
                  <a
                    v-else
                    href="#"
                    ref="downloadDataSheetButton"
                    @click="triggerClickedDownloadDataSheet"
                    class="datasheet-button text-secondary d-inline-flex align-items-center"
                    v-html="
                      dataSheetIsLoading
                        ? $t('generating-datasheet')
                        : $t('download-datasheet')
                    "
                  >
                  </a>
                </div>
                <div class="w-25">
                  <a
                    href="#"
                    ref="addToFavorites"
                    :disabled="loading"
                    v-if="
                      $store.state.loggedIn &&
                      !$store.state.respecifyId &&
                      $store.state.showPrice
                    "
                    @click.prevent="addToFavorites"
                    class="text-secondary d-inline-flex align-items-center"
                    v-html="$t('addToFavorites')"
                  >
                  </a>
                </div>
                <div class="w-25">
                  <button
                    v-if="
                      $store.state.loggedIn &&
                      !$store.state.respecifyId &&
                      $store.state.showPrice
                    "
                    href="#"
                    :disabled="loading"
                    v-html="$t('addToCart')"
                    @click.prevent="addToCart"
                    class="w-100 mt-n2 px-4 py-2 bg-saka-green border-0 text-light rounded-pill"
                  ></button>

                  <a
                    v-else-if="!$store.state.loggedIn"
                    :href="createOfferRequest"
                    v-html="$t('requestOfferButton')"
                    @click="triggerClickedOfferRequest"
                    class="w-100 mt-n2 px-4 py-2 bg-saka-green border-0 text-light rounded-pill"
                  ></a>
                </div>
              </div>

              <div class="d-flex mt-5" v-else>
                <div class="w-25 pl-1">
                  <a
                    v-if="
                      $store.state.loggedIn &&
                      $store.state.respecifyId &&
                      $store.state.showPrice
                    "
                    href="#"
                    ref="saveRespcification"
                    @click.prevent="saveRespecification"
                    class="text-secondary d-inline-flex align-items-center"
                    v-html="
                      `<i class='fas fa-sync mr-1 text-saka-orange'></i><u>Als Kabel ${$store.state.respecifyId} überschreiben</u>`
                    "
                  >
                  </a>
                </div>
                <div class="w-25">
                  <a
                    v-if="browser.browser.name === 'Safari' /* Safari */"
                    class="text-secondary d-inline-flex align-items-center"
                    disabled
                    v-html="$t('datasheet-safari-incompatible')"
                  >
                  </a>
                  <a
                    v-else-if="
                      browser.browser.name === 'Internet Explorer' ||
                      (browser.browser.name === 'Microsoft Edge' &&
                        browser.engine.name === 'EdgeHTML') /* IE, alter Edge */
                    "
                    @click="IEDataSheetDownload"
                    href="#"
                    class="text-secondary d-inline-flex align-items-center"
                    v-html="
                      dataSheetIsLoading
                        ? $t('generating-datasheet')
                        : $t('download-datasheet')
                    "
                  >
                  </a>
                  <a
                    v-else
                    href="#"
                    ref="downloadDataSheetButton"
                    @click="triggerClickedDownloadDataSheet"
                    class="datasheet-button text-secondary d-inline-flex align-items-center"
                    v-html="
                      dataSheetIsLoading
                        ? $t('generating-datasheet')
                        : $t('download-datasheet')
                    "
                  >
                  </a>
                </div>
                <div class="w-25">
                  <a
                    v-if="
                      $store.state.loggedIn &&
                      !$store.state.respecifyId &&
                      $store.state.projectAddProduct &&
                      $store.state.showPrice
                    "
                    href="#"
                    :disabled="loading"
                    v-html="$t('saveProduct')"
                    @click.prevent="addToCart"
                    class="text-secondary d-inline-flex align-items-center"
                  >
                  </a>
                  <a
                    v-else-if="
                      $store.state.loggedIn &&
                      !$store.state.respecifyId &&
                      !$store.state.projectAddProduct &&
                      $store.state.showPrice
                    "
                    href="#"
                    :disabled="loading"
                    v-html="$t('addToProject2')"
                    @click.prevent="loadProjectsAndShowProjectModal"
                    class="d-inline-flex align-items-center text-secondary"
                  >
                  </a>
                  <a
                    v-else-if="
                      $store.state.loggedIn &&
                      !$store.state.respecifyId &&
                      !$store.state.projectAddProduct &&
                      !$store.state.showPrice
                    "
                    href="#"
                    disabled
                    v-html="$t('addToProject3')"
                    class="d-flex-col align-items-start text-muted"
                  >
                  </a>
                </div>
                <div class="w-25">
                  <button
                    v-if="
                      $store.state.loggedIn &&
                      !$store.state.respecifyId &&
                      !$store.state.projectAddProduct &&
                      $store.state.showPrice
                    "
                    href="#"
                    :disabled="loading"
                    v-html="$t('addToCart')"
                    @click.prevent="addToCart"
                    class="w-100 mt-n2 px-4 py-2 bg-saka-green border-0 text-light rounded-pill"
                  ></button>
                  <button
                    v-if="
                      $store.state.loggedIn &&
                      !$store.state.respecifyId &&
                      !$store.state.projectAddProduct &&
                      !$store.state.showPrice
                    "
                    v-html="$t('addToCart')"
                    class="w-100 mt-n2 px-4 py-2 darker-eee border-0 text-muted rounded-pill"
                  ></button>
                  <button
                    v-else-if="
                      $store.state.loggedIn &&
                      !$store.state.respecifyId &&
                      $store.state.projectAddProduct &&
                      $store.state.showPrice
                    "
                    href="#"
                    :disabled="loading"
                    v-html="$t('addToProject')"
                    @click.prevent="loadProjectsAndShowProjectModal"
                    class="w-100 mt-n2 px-4 py-2 bg-saka-green border-0 text-light rounded-pill"
                  ></button>
                  <a
                    v-else-if="!$store.state.loggedIn"
                    :href="createOfferRequest"
                    v-html="$t('requestOfferButton')"
                    @click.prevent="triggerClickedOfferRequest"
                    class="w-100 mt-n2 px-4 py-2 bg-saka-green border-0 text-light rounded-pill"
                  ></a>
                </div>
              </div>
              <div class="w-100" v-if="showDigikey">
                <InquiryForm
                  :product-detail="summary"
                  :price="price"
                  :quantity="quantity"
                  :currency_adjustment_percent="currency_adjustment_percent"
                  :surchargeDigikey="surchargeDigikey"
                  :language="offerRequestParams.language"
                  :product_description="offerRequestParams.productDescription"
                  :cableLength="cableLength"
                />
              </div>
              <div
                class="d-flex mt-3 w-100 flex-row-reverse"
                v-if="!$store.state.loggedIn"
              >
                <register-hint
                  class="w-25"
                  @openregistration="openRegistration"
                />
              </div>
            </div>
          </fetch-price>

          <portal to="configuration-navigation">
            <configuration-navigation
              :forward-visible="false"
              :backward-active="true"
              @backward-click="
                () => {
                  resolvedProductNumber = null;
                  customProductNumber = null;
                  configuratorStep = 3;
                }
              "
            />
          </portal>
        </configurator-step>
      </transition>
      <div
        class="d-flex justify-content-end mt-1 mb-3 px-4"
        :class="{ invisible: configuratorStep >= 3 }"
      >
        <div
          class="custom-control custom-checkbox ios mr-3 px-3 py-1"
          v-if="$store.state.autoFillVisible"
        >
          <input
            type="checkbox"
            class="custom-control-input clickable"
            id="auto-fill-switch"
            v-model="$store.state.autoFill"
          />
          <label
            class="custom-control-label clickable text-secondary"
            for="auto-fill-switch"
            >{{ $t("auto-fill") }}</label
          >
        </div>
        <a
          class="px-3 py-1 decoration-none configurator-nav text-secondary rounded clickable"
          @click.prevent="clearFilters()"
        >
          {{ $t("clear-filters") }}&nbsp;<span
            class="text-danger font-weight-bold"
            ><i class="fas fa-times"></i
          ></span>
        </a>
      </div>
      <hr class="my-1 border-top w-100 border-configurator" />
      <footer-bar :active-page="activePage" :additional-hints="additionalHints">
        <div
          class="btn-group btn-group-toggle"
          data-toggle="buttons"
          v-if="isDataCenterToggleVisible"
        >
          <label
            class="btn btn-secondary"
            :class="{ active: isDataCenterMode === false }"
          >
            <input
              type="radio"
              name="options"
              id="option1"
              :value="false"
              autocomplete="off"
              v-model="$store.state.getsDataCenterProducts"
              @click="loadDefaultData"
            />
            Sachsenkabel Standard
          </label>
          <label
            class="btn btn-secondary"
            :class="{ active: isDataCenterMode }"
          >
            <input
              type="radio"
              name="options"
              id="option2"
              :value="true"
              autocomplete="off"
              v-model="$store.state.getsDataCenterProducts"
              @click="loadDataCenterData"
            />
            RZ Standard
          </label>
        </div>
      </footer-bar>
    </div>
    <!-- mobile layout -->
    <div class="mobile-layout d-flex d-lg-none flex-column w-auto min-vh-100">
      <portal to="side-b-modal" v-if="$runtimeEnvironment.isMobile">
        <div
          v-if="true /*browser.browser.name !== 'Safari' */"
          ref="side-b-modal"
          class="mobile-side-b-modal d-none side-b-modal side-b-modal-backgrop vw-100 vh-100 position-fixed"
          style="top: 0; left: 0; z-index: 1031; pointer-events: none;"
        >
          <div
            class="d-block vw-100 vh-100 bg-white rounded position-fixed side-b-modal-container"
            style="pointer-events: auto;"
          >
            <div class="d-flex w-100 h-100 flex-column p-3">
              <side-block
                :caption="$t('side')"
                label="B"
                class="align-self-end"
              />
              <div
                class="d-flex flex-column h-100 w-100 px-4 align-items-center"
              >
                <div
                  class="d-flex flex-column w-auto align-items-start"
                  style="max-width: 250px"
                >
                  <img
                    :src="duplicatePic"
                    width="240"
                    @click="sideBPick = 'duplicate'"
                  />
                  <div class="custom-control custom-radio">
                    <input
                      type="radio"
                      class="custom-control-input"
                      id="duplicate"
                      value="duplicate"
                      v-model="sideBPick"
                      :key="`duplicate`"
                    />
                    <label class="custom-control-label" for="duplicate">{{
                      $t("side-b-setup.duplicate-settings")
                    }}</label>
                  </div>
                </div>
                <div
                  class="d-flex flex-column w-auto align-items-start"
                  style="max-width: 250px"
                >
                  <img
                    :src="individualPic"
                    width="240"
                    @click="sideBPick = 'individual'"
                  />
                  <div class="custom-control custom-radio">
                    <input
                      type="radio"
                      class="custom-control-input"
                      id="individual"
                      value="individual"
                      v-model="sideBPick"
                      :key="`individual`"
                    />
                    <label class="custom-control-label" for="individual">{{
                      $t("side-b-setup.individual")
                    }}</label>
                  </div>
                </div>
                <div
                  class="d-flex flex-column w-auto align-items-start"
                  style="max-width: 250px"
                >
                  <img
                    :src="pigtailPic"
                    width="240"
                    @click="sideBPick = 'pigtail'"
                  />
                  <div class="custom-control custom-radio">
                    <input
                      type="radio"
                      class="custom-control-input"
                      id="pigtail"
                      value="pigtail"
                      v-model="sideBPick"
                      :key="`pigtail`"
                    />
                    <label class="custom-control-label" for="pigtail">{{
                      $t("side-b-setup.pigtail")
                    }}</label>
                  </div>
                </div>
              </div>
              <div
                class="fixed-bottom d-flex border-top border-configurator justify-content-between w-100 align-self-start py-3 px-1"
                :class="{ 'mb-4': mobileSurvicateLoaded }"
              >
                <button
                  class="bg-transparent border border-secondary text-secondary px-4 py-2 rounded-pill mr-2 w-25"
                  @click.prevent="
                    () => {
                      $refs['side-b-modal'].classList.remove('d-block');
                      $refs['side-b-modal'].classList.add('d-none');
                      configuratorStep -= 1;
                    }
                  "
                >
                  {{ $t("step-back") }}
                </button>
                <button
                  class="px-4 py-2 bg-saka-orange border-saka-orange border text-light rounded-pill ml-2 w-25"
                  @click.prevent="handleSideBSetup()"
                >
                  {{ $t("step-forward") }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <v-dialog style="z-index: 1031" v-else :click-to-close="false" />
      </portal>

      <modal
        name="save-to-catalog"
        adaptive
        height="auto"
        style="z-index: 1031"
        @opened="disableAppScroll"
        @closed="enableAppScroll"
      >
        <form class="h-100">
          <div class="modal-header">
            <h5 class="modal-title">Konfiguriertes Kabel speichern</h5>
            <button
              type="button"
              class="close"
              @click="$modal.hide('save-to-catalog')"
              aria-label="Schließen"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="artnr">Artikelnummer:*</label>
              <input
                type="text"
                class="form-control"
                name="artnr"
                id="artnr"
                v-model="customProductNumber"
              />
            </div>

            <div class="custom-control custom-checkbox form-group">
              <input
                id="length-independent"
                type="checkbox"
                class="custom-control-input"
                v-model="lengthIndependent"
              />
              <label class="custom-control-label" for="length-independent"
                >Längenunabhängig speichern?</label
              >
              <small class="form-text text-muted"
                >Das Produkt wird ohne die feste Länge von {{ cableLength }}m in
                Ihren Katalog abgelgt und kann so in verschiedenen Längen
                nachbestellt werden.</small
              >
            </div>

            <div class="form-group">
              <label for="name">Bezeichnung:*</label>
              <input
                type="text"
                class="form-control"
                name="name"
                id="name"
                disabled
                :value="$t('productNames.trunk')"
              />
            </div>

            <div class="form-group">
              <label for="description">Beschreibung:</label>
              <textarea
                class="form-control"
                name="description"
                id="description"
                v-model="summary"
                disabled
                rows="6"
              ></textarea>
            </div>

            <span class="message"></span>

            <p>* gekennzeichnete Felder sind Pflichtfelder</p>
          </div>
          <div class="modal-footer mb-5">
            <button
              type="button"
              class="px-4 py-2 rounded-pill mr-2 bg-transparent border border-secondary text-secondary"
              @click="$modal.hide('save-to-catalog')"
            >
              {{ $t("close") }}
            </button>
            <button
              type="submit"
              class="px-4 py-2 bg-saka-green border-0 text-light rounded-pill"
              @click.prevent="addToMyCatalog"
            >
              <i class="fas fa-check"></i> {{ $t("save") }}
            </button>
          </div>
        </form>
      </modal>

      <div
        class="mobile-product-info-toggle-group d-flex border-top border-configurator"
      >
        <button
          class="product-info-toggle-button btn font-weight-bold active w-50 text-left rounded-0 border-0"
          @click="
            () => {
              mobile.displayMode = 'productImage';
            }
          "
          :class="{
            'bg-white text-saka-green': mobile.displayMode === 'productImage',
            'bg-eee text-secondary': mobile.displayMode !== 'productImage',
          }"
        >
          Kabelkonfigurator
        </button>
        <button
          class="product-info-toggle-button btn font-weight-bold active w-50 text-left rounded-0 border-0"
          @click="
            () => {
              mobile.displayMode = 'productInfo';
            }
          "
          :class="{
            'bg-white text-saka-green': mobile.displayMode === 'productInfo',
            'bg-eee text-secondary': mobile.displayMode !== 'productInfo',
          }"
        >
          Zusammenfassung
        </button>
      </div>
      <transition mode="out-in" name="fade" tag="div">
        <configurator-step
          v-if="configuratorStep === 0"
          class="d-block px-2 py-2"
          :configuratorStep="configuratorStep"
          key="cable-step"
          :is-pigtail="isPigtail"
          :display-cable-side-indicator="true"
          :display-cable-length-input="
            false /* mobile.displayMode === `productImage` ? true : false */
          "
          :display-product-image="
            mobile.displayMode === `productImage` ? true : false
          "
          :display-product-info="
            mobile.displayMode === `productImage` ? false : true
          "
          :product-info="summary"
        >
          <div class="d-flex flex-wrap">
            <carousel-scroll-select
              class="w-100"
              class-prop="w-100"
              filter-key="cables"
              filter-property-name="cableType"
              type="CarouselScrollSelectCableType"
              ref="cable-faces"
              :disabledItems="
                disabledItemsForScope({
                  scope: 'getters',
                  key: 'cables',
                  propertyName: 'cableType',
                })
              "
              :fiber-count="selectedValue('cables', 'fiberCount')"
              :items="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'cables',
                  propertyName: 'cableType',
                })
              "
              :key="`cable-faces`"
              :label="$t('cable-type')"
              :show-unselected="
                missingSelectionIncludes({
                  step: 0,
                  filterKey: 'cables',
                  propertyName: 'cableType',
                })
              "
              :value="selectedValue('cables', 'cableType')"
              :color="selectedCableDropdownColor"
              :visible-items-count="$runtimeEnvironment.isMobileOnly ? 2 : 3"
            />
            <hr />

            <custom-select
              :class="
                $runtimeEnvironment.isMobileOnly
                  ? `w-100 mt-2`
                  : `w-50 mt-4 pr-1`
              "
              class-prop=""
              :show-label="false"
              :label="$t('fiber-count')"
              :items="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'cables',
                  propertyName: 'fiberCount',
                  sort: fiberCountSorting,
                })
              "
              :disabledItems="
                disabledItemsForScope({
                  scope: 'getters',
                  key: 'cables',
                  propertyName: 'fiberCount',
                })
              "
              filter-key="cables"
              filter-property-name="fiberCount"
              :value="selectedValue('cables', 'fiberCount')"
              :show-unselected="
                missingSelectionIncludes({
                  step: 0,
                  filterKey: 'cables',
                  propertyName: 'fiberCount',
                })
              "
            />
            <custom-select
              :class="
                $runtimeEnvironment.isMobileOnly
                  ? `w-100 mt-2`
                  : `w-50 mt-4 pl-1`
              "
              class-prop=""
              :show-label="false"
              :label="$t('fiber-class')"
              :items="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'cables',
                  propertyName: 'fiberClass',
                })
              "
              :disabledItems="
                disabledItemsForScope({
                  scope: 'getters',
                  key: 'cables',
                  propertyName: 'fiberClass',
                })
              "
              filter-key="cables"
              filter-property-name="fiberClass"
              :value="selectedValue('cables', 'fiberClass')"
              :show-unselected="
                missingSelectionIncludes({
                  step: 0,
                  filterKey: 'cables',
                  propertyName: 'fiberClass',
                })
              "
            />

            <custom-select
              :class="
                $runtimeEnvironment.isMobileOnly
                  ? `w-100 mt-2`
                  : `w-50 mt-4 pr-1`
              "
              class-prop=""
              :show-label="false"
              :label="`${$t('cable-manufacturer')}`"
              :items="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'cables',
                  propertyName: 'manufacturer',
                })
              "
              :disabledItems="
                disabledItemsForScope({
                  scope: 'getters',
                  key: 'cables',
                  propertyName: 'manufacturer',
                })
              "
              filter-key="cables"
              filter-property-name="manufacturer"
              :value="selectedValue('cables', 'manufacturer')"
              :show-unselected="
                missingSelectionIncludes({
                  step: 0,
                  filterKey: 'cables',
                  propertyName: 'manufacturer',
                })
              "
            />

            <custom-select
              :class="
                $runtimeEnvironment.isMobileOnly
                  ? `w-100 mt-2`
                  : `w-50 mt-4 pl-1`
              "
              v-if="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'cables',
                  propertyName: 'cpr',
                }).length >= 1 &&
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'cables',
                  propertyName: 'cpr',
                })[0] !== 'undefined'
              "
              class-prop=""
              :show-label="false"
              :label="$t('cable-cpr')"
              :items="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'cables',
                  propertyName: 'cpr',
                })
              "
              :displayItems="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'cables',
                  propertyName: 'cpr',
                }).map((i) => (i === 'null' ? $t('ohne') : i))
              "
              :disabledItems="
                disabledItemsForScope({
                  scope: 'getters',
                  key: 'cables',
                  propertyName: 'cpr',
                })
              "
              filter-key="cables"
              filter-property-name="cpr"
              is-optional
              :value="selectedValue('cables', 'cpr')"
              :show-unselected="
                false /*missingSelectionIncludes({ step: 0, filterKey: 'cables', propertyName: 'diameter'}) */
              "
            />

            <!-- <custom-select
              :class="$runtimeEnvironment.isMobileOnly ? `w-100 mt-2`: `w-50 mt-4 pl-1`"
              class-prop=""
              :show-label="false"
              :label="$t('cable-diameter')"
              :items="distinctPropertyValuesFor({scope: 'getters', key: 'cables', propertyName: 'diameter'})"
              :disabledItems="disabledItemsForScope({ scope: 'getters', key: 'cables', propertyName: 'diameter'})"
              filter-key="cables"
              filter-property-name="diameter"
              :value="selectedValue('cables', 'diameter')"
              :show-unselected="missingSelectionIncludes({ step: 0, filterKey: 'cables', propertyName: 'diameter'})"
            /> -->
            <color-select
              :class="
                $runtimeEnvironment.isMobileOnly
                  ? `w-100 mt-2`
                  : `w-50 mt-4 pl-1`
              "
              class-prop="d-flex justify-content-between align-items-center"
              :label="$t('cable-color')"
              :items="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'remainingCables',
                  propertyName: 'cableColor',
                })
              "
              :disabledItems="[] /*disabledItemsForScope({ scope: 'getters', key: 'cables', propertyName: 'cableColor'}) */"
              filter-key="cables"
              filter-property-name="cableColor"
              :value="selectedValue('cables', 'cableColor')"
              :show-unselected="
                missingSelectionIncludes({
                  step: 0,
                  filterKey: 'cables',
                  propertyName: 'cableColor',
                })
              "
            />

            <a
              class="w-100 mt-4 text-center py-2 rounded-pill decoration-none configurator-nav text-secondary rounded clickable"
              @click.prevent="clearFilters()"
            >
              <span class="text-danger"><i class="fas fa-times"></i></span
              >&nbsp;{{ $t("clear-filters") }}
            </a>
            <hr class="border-0 w-100" />
            <!-- <div class="custom-control custom-checkbox ios d-flex justify-content-between">
              <label class="custom-control-label clickable text-secondary" for="auto-fill-switch">{{ $t('auto-fill') }}</label>
              <input type="checkbox" class="custom-control-input clickable" id="auto-fill-switch" v-model="$store.state.autoFill">
            </div> -->
            <div class="my-5 w-auto fixed-footer-block"></div>
          </div>
        </configurator-step>
        <configurator-step
          v-if="configuratorStep === 1"
          class="d-block px-2 py-2"
          :configuratorStep="configuratorStep"
          key="plugs-a-step"
          :is-pigtail="isPigtail"
          :display-cable-side-indicator="true"
          :display-cable-length-input="
            false /* mobile.displayMode === `productImage` ? true : false */
          "
          :display-product-image="
            mobile.displayMode === `productImage` ? true : false
          "
          :display-product-info="
            mobile.displayMode === `productImage` ? false : true
          "
          :load="() => (overlay = 'sideA')"
          :overlay="'sideB'"
          :product-info="summary"
          v-cloak
        >
          <div class="d-flex flex-wrap">
            <carousel-scroll-select
              class="w-100"
              class-prop="pl-n4"
              :label="$t('plug-type')"
              :items="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'plugsA',
                  propertyName: 'plugType',
                })
              "
              :disabledItems="
                disabledItemsForScope({
                  scope: 'getters',
                  key: 'plugsA',
                  propertyName: 'plugType',
                })
              "
              :displayItems="
                disabledItemsForScope({
                  scope: 'getters',
                  key: 'plugsA',
                  propertyName: 'plugType',
                })
              "
              :color="selectedValue('plugsA', 'plugColor')"
              :cable-color="selectedCableDropdownColor"
              :fiber-count="selectedValue('cables', 'fiberCount')"
              :plex="selectedValue('plugsA', 'plex')"
              type="CarouselScrollSelectPlugType"
              filter-property-name="plugType"
              filter-key="plugsA"
              :value="selectedValue('plugsA', 'plugType')"
              :mode="
                selectedValue('cables', 'fiberClass').indexOf('OS') === 0
                  ? 'sm'
                  : 'mm'
              "
              :plug-id="
                remainingPlugsA.length === 1 ? remainingPlugsA[0].id : null
              "
              :show-unselected="
                missingSelectionIncludes({
                  step: 1,
                  filterKey: 'plugsA',
                  propertyName: 'plugType',
                })
              "
              :visible-items-count="$runtimeEnvironment.isMobileOnly ? 2 : 3"
            />
            <hr />

            <custom-select
              :class="
                $runtimeEnvironment.isMobileOnly
                  ? `w-100 mt-2`
                  : `w-50 mt-4 pr-1`
              "
              class-prop=""
              :label="$t('plug-plex')"
              :show-label="false"
              :items="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'plugsA',
                  propertyName: 'plex',
                })
              "
              :displayItems="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'plugsA',
                  propertyName: 'plex',
                })
                  .map((item) =>
                    $i18n.locale !== 'de' ? item.replace('mit', 'with') : item
                  )
                  .map((item) =>
                    item === 'sx' ? 'Simplex' : item === 'dx' ? 'Duplex' : item
                  )
              "
              :disabledItems="
                disabledItemsForScope({
                  scope: 'getters',
                  key: 'plugsA',
                  propertyName: 'plex',
                })
              "
              filter-key="plugsA"
              filter-property-name="plex"
              :value="selectedValue('plugsA', 'plex')"
              :show-unselected="
                missingSelectionIncludes({
                  step: 1,
                  filterKey: 'plugsA',
                  propertyName: 'plex',
                })
              "
            />

            <custom-select
              :class="
                $runtimeEnvironment.isMobileOnly
                  ? `w-100 mt-2`
                  : `w-50 mt-4 pl-1`
              "
              class-prop=""
              :label="$t('plug-polish')"
              :show-label="false"
              :items="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'plugsA',
                  propertyName: 'polish',
                })
              "
              :disabledItems="
                disabledItemsForScope({
                  scope: 'getters',
                  key: 'plugsA',
                  propertyName: 'polish',
                })
              "
              :displayItems="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'plugsA',
                  propertyName: 'polish',
                }).map((item) => item.replace('/', ''))
              "
              filter-key="plugsA"
              filter-property-name="polish"
              :value="selectedValue('plugsA', 'polish')"
              :show-unselected="
                missingSelectionIncludes({
                  step: 1,
                  filterKey: 'plugsA',
                  propertyName: 'polish',
                })
              "
            />

            <custom-select
              :class="
                $runtimeEnvironment.isMobileOnly
                  ? `w-100 mt-2`
                  : `w-50 mt-4 pr-1`
              "
              class-prop=""
              :show-label="false"
              :label="`${$t('plug-manufacturer')} A`"
              :items="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'plugsA',
                  propertyName: 'manufacturer',
                })
              "
              :disabledItems="
                disabledItemsForScope({
                  scope: 'getters',
                  key: 'plugsA',
                  propertyName: 'manufacturer',
                })
              "
              :displayItems="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'plugsA',
                  propertyName: 'manufacturer',
                }).map((item) =>
                  item === 'EM'
                    ? 'Euromicron'
                    : item === 'H+S'
                    ? 'Huber+Suhner'
                    : item
                )
              "
              filter-key="plugsA"
              filter-property-name="manufacturer"
              :value="selectedValue('plugsA', 'manufacturer')"
              :show-unselected="
                missingSelectionIncludes({
                  step: 1,
                  filterKey: 'plugsA',
                  propertyName: 'manufacturer',
                })
              "
            />

            <custom-select
              :class="
                $runtimeEnvironment.isMobileOnly
                  ? `w-100 mt-2`
                  : `w-50 mt-4 pl-1`
              "
              class-prop=""
              :label="$t('plug-clip')"
              :show-label="false"
              :items="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'plugsA',
                  propertyName: 'clip',
                })
              "
              :disabledItems="
                disabledItemsForScope({
                  scope: 'getters',
                  key: 'plugsA',
                  propertyName: 'clip',
                })
              "
              :displayItems="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'plugsA',
                  propertyName: 'clip',
                })
                  .map((item) =>
                    $i18n.locale !== 'de' ? item.replace('mit', 'with') : item
                  )
                  .map((item) =>
                    $i18n.locale !== 'de' ? item.replace('ohne', 'none') : item
                  )
              "
              filter-key="plugsA"
              filter-property-name="clip"
              :value="selectedValue('plugsA', 'clip')"
              :show-unselected="
                missingSelectionIncludes({
                  step: 1,
                  filterKey: 'plugsA',
                  propertyName: 'clip',
                })
              "
            />

            <color-select
              :class="
                $runtimeEnvironment.isMobileOnly
                  ? `w-100 mt-2`
                  : `w-50 mt-4 pr-1`
              "
              class-prop="d-flex justify-content-between align-items-center"
              :label="$t('plug-color')"
              :items="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'remainingPlugsA',
                  propertyName: 'plugColor',
                })
              "
              :disabledItems="[] /*disabledItemsForScope({scope: 'getters', key: 'plugsA', propertyName: 'plugColor'}) */"
              filter-key="plugsA"
              filter-property-name="plugColor"
              :value="selectedValue('plugsA', 'plugColor')"
              :show-unselected="
                missingSelectionIncludes({
                  step: 1,
                  filterKey: 'plugsA',
                  propertyName: 'plugColor',
                })
              "
            />

            <multi-color-select
              :visible="remainingPlugsA.length === 1"
              v-if="$runtimeEnvironment.isTablet"
              :items="bendProtectionsA"
              :label="$t('bend-protection')"
              class="tablet w-50 d-flex pl-1 mt-4"
              :class="{ 'text-danger': remainingPlugsA.length !== 1 }"
              :value="selectedValue('bendProtectionsA', 'id')"
              filter-key="bendProtectionsA"
              filter-property-name="id"
              :style="{
                backgroundColor:
                  remainingPlugsA.length === 1 ? 'transparent' : '#FEF4E5',
              }"
              :show-unselected="
                missingSelectionIncludes({
                  step: 1,
                  filterKey: 'bendProtectionsA',
                  propertyName: 'id',
                })
              "
            />

            <multi-color-select
              :visible="remainingPlugsA.length === 1"
              v-if="$runtimeEnvironment.isMobileOnly"
              :items="bendProtectionsA"
              :label="$t('bend-protection')"
              class="mobile ml-n2 pl-2 mt-2 mr-n2 pr-2 vw-100"
              :class="{ 'text-danger': remainingPlugsA.length !== 1 }"
              :value="selectedValue('bendProtectionsA', 'id')"
              filter-key="bendProtectionsA"
              filter-property-name="id"
              :style="{
                backgroundColor:
                  remainingPlugsA.length === 1 ? 'transparent' : '#FEF4E5',
              }"
              :show-unselected="
                missingSelectionIncludes({
                  step: 1,
                  filterKey: 'bendProtectionsA',
                  propertyName: 'id',
                })
              "
            />

            <a
              class="mt-4 text-center py-2 w-100 rounded-pill decoration-none configurator-nav text-secondary rounded clickable"
              @click.prevent="clearFilters()"
            >
              <span class="text-danger"><i class="fas fa-times"></i></span
              >&nbsp;{{ $t("clear-filters") }}
            </a>
            <hr class="border-0 w-100" />
            <!-- <div class="custom-control custom-checkbox ios d-flex justify-content-between">
              <label class="custom-control-label clickable text-secondary" for="auto-fill-switch">{{ $t('auto-fill') }}</label>
              <input type="checkbox" class="custom-control-input clickable" id="auto-fill-switch" v-model="$store.state.autoFill">
            </div> -->
            <div class="my-5 w-auto fixed-footer-block"></div>
          </div>
        </configurator-step>
        <configurator-step
          v-if="configuratorStep === 2"
          class="d-block px-2 py-2"
          :configuratorStep="configuratorStep"
          key="plugs-b-step"
          :is-pigtail="isPigtail"
          :display-cable-side-indicator="true"
          :display-cable-length-input="
            false /* mobile.displayMode === `productImage` ? true : false */
          "
          :display-product-image="
            mobile.displayMode === `productImage` ? true : false
          "
          :display-product-info="
            mobile.displayMode === `productImage` ? false : true
          "
          :overlay="overlay"
          :load="showSideBSetupModal"
          :product-info="summary"
        >
          <div class="d-flex flex-wrap">
            <carousel-scroll-select
              class="w-100"
              class-prop="pl-n4"
              :label="$t('plug-type')"
              :items="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'plugsB',
                  propertyName: 'plugType',
                })
              "
              :disabledItems="
                disabledItemsForScope({
                  scope: 'getters',
                  key: 'plugsB',
                  propertyName: 'plugType',
                })
              "
              :displayItems="
                disabledItemsForScope({
                  scope: 'getters',
                  key: 'plugsB',
                  propertyName: 'plugType',
                })
              "
              :color="selectedValue('plugsB', 'plugColor')"
              :cable-color="selectedCableDropdownColor"
              :fiber-count="selectedValue('cables', 'fiberCount')"
              :plex="selectedValue('plugsB', 'plex')"
              type="CarouselScrollSelectPlugType"
              filter-property-name="plugType"
              filter-key="plugsB"
              :value="selectedValue('plugsB', 'plugType')"
              :mode="
                selectedValue('cables', 'fiberClass').indexOf('OS') === 0
                  ? 'sm'
                  : 'mm'
              "
              :plug-id="
                remainingPlugsB.length === 1 ? remainingPlugsB[0].id : null
              "
              :show-unselected="
                missingSelectionIncludes({
                  step: 1,
                  filterKey: 'plugsB',
                  propertyName: 'plugType',
                })
              "
              :visible-items-count="$runtimeEnvironment.isMobileOnly ? 2 : 3"
            />
            <hr />

            <custom-select
              :class="
                $runtimeEnvironment.isMobileOnly
                  ? `w-100 mt-2`
                  : `w-50 mt-4 pr-1`
              "
              class-prop=""
              :label="$t('plug-plex')"
              :show-label="false"
              :items="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'plugsB',
                  propertyName: 'plex',
                })
              "
              :displayItems="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'plugsB',
                  propertyName: 'plex',
                })
                  .map((item) =>
                    $i18n.locale !== 'de' ? item.replace('mit', 'with') : item
                  )
                  .map((item) =>
                    item === 'sx' ? 'Simplex' : item === 'dx' ? 'Duplex' : item
                  )
              "
              :disabledItems="
                disabledItemsForScope({
                  scope: 'getters',
                  key: 'plugsB',
                  propertyName: 'plex',
                })
              "
              filter-key="plugsB"
              filter-property-name="plex"
              :value="selectedValue('plugsB', 'plex')"
              :show-unselected="
                missingSelectionIncludes({
                  step: 1,
                  filterKey: 'plugsB',
                  propertyName: 'plex',
                })
              "
            />

            <custom-select
              :class="
                $runtimeEnvironment.isMobileOnly
                  ? `w-100 mt-2`
                  : `w-50 mt-4 pl-1`
              "
              class-prop=""
              :label="$t('plug-polish')"
              :show-label="false"
              :items="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'plugsB',
                  propertyName: 'polish',
                })
              "
              :disabledItems="
                disabledItemsForScope({
                  scope: 'getters',
                  key: 'plugsB',
                  propertyName: 'polish',
                })
              "
              :displayItems="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'plugsB',
                  propertyName: 'polish',
                }).map((item) => item.replace('/', ''))
              "
              filter-key="plugsB"
              filter-property-name="polish"
              :value="selectedValue('plugsB', 'polish')"
              :show-unselected="
                missingSelectionIncludes({
                  step: 1,
                  filterKey: 'plugsB',
                  propertyName: 'polish',
                })
              "
            />

            <custom-select
              :class="
                $runtimeEnvironment.isMobileOnly
                  ? `w-100 mt-2`
                  : `w-50 mt-4 pr-1`
              "
              class-prop=""
              :show-label="false"
              :label="`${$t('plug-manufacturer')} B`"
              :items="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'plugsB',
                  propertyName: 'manufacturer',
                })
              "
              :disabledItems="
                disabledItemsForScope({
                  scope: 'getters',
                  key: 'plugsB',
                  propertyName: 'manufacturer',
                })
              "
              :displayItems="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'plugsB',
                  propertyName: 'manufacturer',
                }).map((item) =>
                  item === 'EM'
                    ? 'Euromicron'
                    : item === 'H+S'
                    ? 'Huber+Suhner'
                    : item
                )
              "
              filter-key="plugsB"
              filter-property-name="manufacturer"
              :value="selectedValue('plugsB', 'manufacturer')"
              :show-unselected="
                missingSelectionIncludes({
                  step: 1,
                  filterKey: 'plugsB',
                  propertyName: 'manufacturer',
                })
              "
            />

            <custom-select
              :class="
                $runtimeEnvironment.isMobileOnly
                  ? `w-100 mt-2`
                  : `w-50 mt-4 pl-1`
              "
              class-prop=""
              :label="$t('plug-clip')"
              :show-label="false"
              :items="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'plugsB',
                  propertyName: 'clip',
                })
              "
              :disabledItems="
                disabledItemsForScope({
                  scope: 'getters',
                  key: 'plugsB',
                  propertyName: 'clip',
                })
              "
              :displayItems="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'plugsB',
                  propertyName: 'clip',
                })
                  .map((item) =>
                    $i18n.locale !== 'de' ? item.replace('mit', 'with') : item
                  )
                  .map((item) =>
                    $i18n.locale !== 'de' ? item.replace('ohne', 'none') : item
                  )
              "
              filter-key="plugsB"
              filter-property-name="clip"
              :value="selectedValue('plugsB', 'clip')"
              :show-unselected="
                missingSelectionIncludes({
                  step: 1,
                  filterKey: 'plugsB',
                  propertyName: 'clip',
                })
              "
            />

            <color-select
              :class="
                $runtimeEnvironment.isMobileOnly
                  ? `w-100 mt-2`
                  : `w-50 mt-4 pr-1`
              "
              class-prop="d-flex justify-content-between align-items-center"
              :label="$t('plug-color')"
              :items="
                distinctPropertyValuesFor({
                  scope: 'getters',
                  key: 'remainingPlugsB',
                  propertyName: 'plugColor',
                })
              "
              :disabledItems="[] /*disabledItemsForScope({scope: 'getters', key: 'plugsB', propertyName: 'plugColor'}) */"
              filter-key="plugsB"
              filter-property-name="plugColor"
              :value="selectedValue('plugsB', 'plugColor')"
              :show-unselected="
                missingSelectionIncludes({
                  step: 1,
                  filterKey: 'plugsB',
                  propertyName: 'plugColor',
                })
              "
            />

            <multi-color-select
              :visible="remainingPlugsB.length === 1"
              v-if="$runtimeEnvironment.isTablet"
              :items="bendProtectionsB"
              :label="$t('bend-protection')"
              class="tablet w-50 d-flex pl-1 mt-4"
              :class="{ 'text-danger': remainingPlugsB.length !== 1 }"
              :value="selectedValue('bendProtectionsB', 'id')"
              filter-key="bendProtectionsB"
              filter-property-name="id"
              :style="{
                backgroundColor:
                  remainingPlugsB.length === 1 ? 'transparent' : '#FEF4E5',
              }"
              :show-unselected="
                missingSelectionIncludes({
                  step: 1,
                  filterKey: 'bendProtectionsB',
                  propertyName: 'id',
                })
              "
            />

            <multi-color-select
              :visible="remainingPlugsB.length === 1"
              v-if="$runtimeEnvironment.isMobileOnly"
              :items="bendProtectionsB"
              :label="$t('bend-protection')"
              class="mobile ml-n2 pl-2 mt-2 mr-n2 pr-2 vw-100"
              :class="{ 'text-danger': remainingPlugsB.length !== 1 }"
              :value="selectedValue('bendProtectionsB', 'id')"
              filter-key="bendProtectionsB"
              filter-property-name="id"
              :style="{
                backgroundColor:
                  remainingPlugsB.length === 1 ? 'transparent' : '#FEF4E5',
              }"
              :show-unselected="
                missingSelectionIncludes({
                  step: 1,
                  filterKey: 'bendProtectionsB',
                  propertyName: 'id',
                })
              "
            />

            <a
              class="mt-4 text-center py-2 w-100 rounded-pill decoration-none configurator-nav text-secondary rounded clickable"
              @click.prevent="clearFilters()"
            >
              <span class="text-danger"><i class="fas fa-times"></i></span
              >&nbsp;{{ $t("clear-filters") }}
            </a>
            <hr class="border-0 w-100" />
            <!-- <div class="custom-control custom-checkbox ios d-flex justify-content-between">
              <label class="custom-control-label clickable text-secondary" for="auto-fill-switch">{{ $t('auto-fill') }}</label>
              <input type="checkbox" class="custom-control-input clickable" id="auto-fill-switch" v-model="$store.state.autoFill">
            </div> -->
            <div class="my-5 w-auto fixed-footer-block"></div>
          </div>
        </configurator-step>
        <configurator-step
          v-if="configuratorStep === 3"
          class="d-block px-2 py-2"
          :configuratorStep="configuratorStep"
          key="options-step"
          :is-pigtail="isPigtail"
          :display-cable-side-indicator="true"
          :display-cable-length-input="
            true /* mobile.displayMode === `productImage` ? true : false */
          "
          :display-product-image="true"
          :display-product-info="
            mobile.displayMode === `productImage` ? false : true
          "
          :product-info="summary"
        >
          <template v-slot:default>
            <div class="d-flex w-100 obligatory-parts flex-wrap">
              <custom-select
                :class="
                  $runtimeEnvironment.isMobileOnly
                    ? `w-100 mt-2`
                    : `w-50 mt-4 pr-1`
                "
                class-prop=""
                :show-label="false"
                :label="$t('whip-side-a')"
                :items="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'trunkWhipsA',
                    propertyName: 'id',
                    sort: whipSorting,
                  })
                "
                :displayItems="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'trunkWhipsA',
                    propertyName: 'id',
                    sort: whipSorting,
                  }).map(
                    (item) =>
                      $store.state.whips.filter((whip) => whip.id === item)[0]
                        .length
                  )
                "
                filter-key="whipsA"
                filter-property-name="id"
                :value="selectedValue('whipsA', 'id')"
                :show-unselected="
                  missingSelectionIncludes({
                    step: 3,
                    filterKey: 'whipsA',
                    propertyName: 'id',
                  })
                "
                :disabled-items="disabledWhipsA"
              />

              <custom-select
                :class="
                  $runtimeEnvironment.isMobileOnly
                    ? `w-100 mt-2`
                    : `w-50 mt-4 pr-1`
                "
                class-prop=""
                :show-label="false"
                v-if="!isPigtail"
                :label="$t('whip-side-b')"
                :items="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'trunkWhipsB',
                    propertyName: 'id',
                    sort: whipSorting,
                  })
                "
                :displayItems="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'trunkWhipsB',
                    propertyName: 'id',
                    sort: whipSorting,
                  }).map(
                    (item) =>
                      $store.state.whips.filter((whip) => whip.id === item)[0]
                        .length
                  )
                "
                filter-key="whipsB"
                filter-property-name="id"
                :value="selectedValue('whipsB', 'id')"
                :show-unselected="
                  missingSelectionIncludes({
                    step: 3,
                    filterKey: 'whipsB',
                    propertyName: 'id',
                  })
                "
                :disabled-items="disabledWhipsB"
              />
              <custom-select
                :class="
                  $runtimeEnvironment.isMobileOnly
                    ? `w-100 mt-2`
                    : `w-50 mt-4 pr-1`
                "
                class-prop=""
                :show-label="false"
                :label="$t('spreader-a')"
                v-if="
                  !needsSpreader({
                    cableType: selectedValue('cables', 'cableType'),
                    plugType: selectedValue('plugsA', 'plugType'),
                  })
                "
                :items="[$t('shrinking-tube')]"
                disabled
                filter-key="spreadersA"
                filter-property-name="id"
                :value="$t('shrinking-tube')"
              />
              <custom-select
                :class="
                  $runtimeEnvironment.isMobileOnly
                    ? `w-100 mt-2`
                    : `w-50 mt-4 pr-1`
                "
                class-prop=""
                :show-label="false"
                :label="$t('spreader-a')"
                reset-disabled
                v-else
                filter-key="spreadersA"
                filter-property-name="id"
                :items="
                  $store.getters.spreadersA
                    .filter(
                      (spreader) =>
                        spreader.times ==
                        $store.state.partsList.plugsA.length *
                          parseInt(
                            selectedValue('plugsA', 'plex') === 'dx' ? 2 : 1
                          )
                    )
                    .map((spreader) => spreader.id)
                "
                :displayItems="
                  $store.getters.spreadersA
                    .filter(
                      (spreader) =>
                        spreader.times ==
                        $store.state.partsList.plugsA.length *
                          parseInt(
                            selectedValue('plugsA', 'plex') === 'dx' ? 2 : 1
                          )
                    )
                    .map(
                      (spreader) =>
                        `${spreader.times}${
                          $i18n.locale === 'de'
                            ? '-fach Aufteiler'
                            : ' times Dividing element'
                        } ${$t(spreader.material)}`
                    )
                "
                :value="
                  $store.getters.spreadersA.filter(
                    (spreader) =>
                      spreader.times ==
                      $store.state.partsList.plugsA.length *
                        parseInt(
                          selectedValue('plugsA', 'plex') === 'dx' ? 2 : 1
                        )
                  )[0]
                    ? $store.state.spreaders.filter(
                        (spreader) =>
                          spreader.times ==
                          $store.state.partsList.plugsA.length *
                            parseInt(
                              selectedValue('plugsA', 'plex') === 'dx' ? 2 : 1
                            )
                      )[0].id
                    : null
                "
              />

              <custom-select
                :class="
                  $runtimeEnvironment.isMobileOnly
                    ? `w-100 mt-2`
                    : `w-50 mt-4 pr-1`
                "
                class-prop=""
                :show-label="false"
                :label="$t('spreader-b')"
                v-if="
                  !isPigtail &&
                  !needsSpreader({
                    cableType: selectedValue('cables', 'cableType'),
                    plugType: selectedValue('plugsB', 'plugType'),
                  })
                "
                :items="[$t('shrinking-tube')]"
                disabled
                filter-key="spreadersB"
                filter-property-name="id"
                :value="$t('shrinking-tube')"
              />
              <custom-select
                :class="
                  $runtimeEnvironment.isMobileOnly
                    ? `w-100 mt-2`
                    : `w-50 mt-4 pr-1`
                "
                class-prop=""
                :show-label="false"
                :label="$t('spreader-b')"
                v-else-if="
                  !isPigtail &&
                  needsSpreader({
                    cableType: selectedValue('cables', 'cableType'),
                    plugType: selectedValue('plugsB', 'plugType'),
                  })
                "
                reset-disabled
                filter-key="spreadersB"
                filter-property-name="id"
                :items="
                  $store.getters.spreadersB
                    .filter(
                      (spreader) =>
                        spreader.times ==
                        $store.state.partsList.plugsB.length *
                          parseInt(
                            selectedValue('plugsB', 'plex') === 'dx' ? 2 : 1
                          )
                    )
                    .map((spreader) => spreader.id)
                "
                :displayItems="
                  $store.getters.spreadersB
                    .filter(
                      (spreader) =>
                        spreader.times ==
                        $store.state.partsList.plugsB.length *
                          parseInt(
                            selectedValue('plugsB', 'plex') === 'dx' ? 2 : 1
                          )
                    )
                    .map(
                      (spreader) =>
                        `${spreader.times}${
                          $i18n.locale === 'de'
                            ? '-fach Aufteiler'
                            : ' times Dividing element'
                        } ${$t(spreader.material)}`
                    )
                "
                :value="
                  $store.getters.spreadersB.filter(
                    (spreader) =>
                      spreader.times ==
                      $store.state.partsList.plugsB.length *
                        parseInt(
                          selectedValue('plugsB', 'plex') === 'dx' ? 2 : 1
                        )
                  )[0]
                    ? $store.state.spreaders.filter(
                        (spreader) =>
                          spreader.times ==
                          $store.state.partsList.plugsB.length *
                            parseInt(
                              selectedValue('plugsB', 'plex') === 'dx' ? 2 : 1
                            )
                      )[0].id
                    : null
                "
              />
            </div>
            <hr />
            <div class="d-flex w-100 optional-parts flex-wrap">
              <custom-select
                :class="
                  $runtimeEnvironment.isMobileOnly
                    ? `w-100 mt-2`
                    : `w-50 mt-4 pr-1`
                "
                class-prop=""
                :show-label="false"
                :label="$t('protection-side-a')"
                :items="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'protectionsA',
                    propertyName: 'id',
                  })
                "
                :displayItems="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'protectionsA',
                    propertyName: 'id',
                  }).map((item) =>
                    $t(
                      $store.state.protections.filter(
                        (protection) => protection.id === item
                      )[0].description
                    )
                  )
                "
                filter-key="protectionsA"
                filter-property-name="id"
                :value="selectedValue('protectionsA', 'id')"
                :show-unselected="
                  missingSelectionIncludes({
                    step: 3,
                    filterKey: 'protectionsA',
                    propertyName: 'id',
                  })
                "
                is-optional
                :disabled-items="disabledProtectionsA"
              />

              <custom-select
                :class="
                  $runtimeEnvironment.isMobileOnly
                    ? `w-100 mt-2`
                    : `w-50 mt-4 pl-1`
                "
                class-prop=""
                :show-label="false"
                v-if="!isPigtail"
                :label="$t('protection-side-b')"
                :items="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'protectionsB',
                    propertyName: 'id',
                  })
                "
                :displayItems="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'protectionsB',
                    propertyName: 'id',
                  }).map((item) =>
                    $t(
                      $store.state.protections.filter(
                        (protection) => protection.id === item
                      )[0].description
                    )
                  )
                "
                filter-key="protectionsB"
                filter-property-name="id"
                :value="selectedValue('protectionsB', 'id')"
                :show-unselected="
                  missingSelectionIncludes({
                    step: 3,
                    filterKey: 'protectionsB',
                    propertyName: 'id',
                  })
                "
                is-optional
                :disabledItems="disabledProtectionsB"
              />
              <custom-select
                :class="
                  $runtimeEnvironment.isMobileOnly
                    ? `w-100 mt-2`
                    : `w-50 mt-4 pr-1`
                "
                class-prop=""
                :show-label="false"
                :label="$t('fixation-side-a')"
                :items="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'fixationsA',
                    propertyName: 'id',
                  })
                "
                :displayItems="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'fixationsA',
                    propertyName: 'id',
                  }).map(
                    (item) =>
                      `${
                        $store.state.fixations.filter(
                          (fixation) => fixation.id === item
                        )[0].size
                      } ${$t('inkl. Gegenmutter')}`
                  )
                "
                filter-key="fixationsA"
                filter-property-name="id"
                :value="selectedValue('fixationsA', 'id')"
                :show-unselected="
                  missingSelectionIncludes({
                    step: 3,
                    filterKey: 'fixationsA',
                    propertyName: 'id',
                  })
                "
                is-optional
              />
              <custom-select
                :class="
                  $runtimeEnvironment.isMobileOnly
                    ? `w-100 mt-2`
                    : `w-50 mt-4 pl-1`
                "
                class-prop=""
                :show-label="false"
                v-if="!isPigtail"
                :label="$t('fixation-side-b')"
                :items="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'fixationsB',
                    propertyName: 'id',
                  })
                "
                :displayItems="
                  distinctPropertyValuesFor({
                    scope: 'getters',
                    key: 'fixationsB',
                    propertyName: 'id',
                  }).map(
                    (item) =>
                      `${
                        $store.state.fixations.filter(
                          (fixation) => fixation.id === item
                        )[0].size
                      } ${$t('inkl. Gegenmutter')}`
                  )
                "
                filter-key="fixationsB"
                filter-property-name="id"
                :value="selectedValue('fixationsB', 'id')"
                :show-unselected="
                  missingSelectionIncludes({
                    step: 3,
                    filterKey: 'fixationsB',
                    propertyName: 'id',
                  })
                "
                is-optional
                :disabled-items="disabledProtectionsB"
              />

              <custom-select
                :class="
                  $runtimeEnvironment.isMobileOnly
                    ? `w-100 mt-2`
                    : `w-50 mt-4 pr-1`
                "
                class-prop=""
                :show-label="false"
                is-optional
                :label="`${$t('options-label')} ${$t('side')} A`"
                :items="$store.state.labels.map((label) => label.id)"
                :displayItems="
                  $store.state.labels.map((label) =>
                    $t('labels.' + label.longDescription)
                  )
                "
                filter-key="labelsA"
                filter-property-name="id"
                :value="selectedValue('labelsA', 'id')"
              />
              <custom-select
                :class="
                  $runtimeEnvironment.isMobileOnly
                    ? `w-100 mt-2 mb-5`
                    : `w-50 mt-4 pl-1`
                "
                class-prop=""
                :show-label="false"
                v-if="!isPigtail"
                is-optional
                :label="`${$t('options-label')} ${$t('side')} B`"
                :items="$store.state.labels.map((label) => label.id)"
                :displayItems="
                  $store.state.labels.map((label) =>
                    $t('labels.' + label.longDescription)
                  )
                "
                filter-key="labelsB"
                filter-property-name="id"
                :value="selectedValue('labelsB', 'id')"
              />
            </div>
            <div class="mb-5 w-auto fixed-footer-block"></div>
          </template>
          <template v-slot:pricing>
            <fetch-price
              :cable-length="parseFloat($store.state.cableLength)"
              v-if="$store.state.loggedIn"
            >
              <div class="w-auto" slot-scope="{ price }">
                <div
                  class="bg-dark d-flex ml-n4 pl-4 mr-n4 mt-2 pt-3 pb-2 align-items-baseline"
                >
                  <div class="w-50">
                    <label class="w-25 text-light" for="quantity"
                      >{{ $t("quantity") }}:
                    </label>
                  </div>
                  <input
                    type="number"
                    min="1"
                    max="999"
                    step="1"
                    :value="quantity"
                    @change="
                      ($event) => {
                        quantity = Math.floor(
                          $event.target.value
                        ); /* whole numbers only */
                      }
                    "
                    class="w-25 ml-n3 text-secondary font-weight-bold border-0"
                  />
                </div>
                <div
                  class="d-flex ml-n4 pl-4 mr-n4 mt-2 py-2 border-bottom border-configurator"
                >
                  <div class="w-50">
                    <span class="text-muted">{{ $t("delivery-time") }}: </span>
                  </div>
                  <span class="ml-n3 text-secondary font-weight-bold">{{
                    $t("days", ["7-14"])
                  }}</span>
                </div>
                <div class="d-flex ml-n4 pl-4 mr-n4 mt-2 py-2">
                  <div class="w-50">
                    <span class="text-muted">{{ $t("price") }}: </span>
                  </div>
                  <span class="ml-n3 text-secondary font-weight-bold"
                    >{{
                      new Intl.NumberFormat("de-DE", {
                        style: "currency",
                        currency: "EUR",
                      }).format(price)
                    }}
                  </span>
                </div>
                <div
                  class="d-flex ml-n4 pl-4 mr-n4 mt-2 py-3 bg-eee border-bottom"
                >
                  <div class="w-50">
                    <span class="text-muted">{{ $t("total") }}: </span>
                  </div>
                  <span class="ml-n3 text-secondary font-weight-bold"
                    >{{
                      new Intl.NumberFormat("de-DE", {
                        style: "currency",
                        currency: "EUR",
                      }).format(parseFloat(price.toFixed(2)) * quantity)
                    }}
                  </span>
                </div>
                <div
                  class="w-auto py-3"
                  v-if="
                    isDataCenterMode
                      ? configuratorStep === 4
                      : configuratorStep === 3
                  "
                >
                  <button
                    class="btn bg-saka-green text-light rounded-pill w-100 text-center text-capitalize"
                  >
                    {{ $t("addToCart") }}
                  </button>
                </div>
                <div class="my-5 w-auto fixed-footer-block"><hr /></div>
              </div>
            </fetch-price>
            <div class="w-auto" v-else>
              <div
                class="bg-dark d-flex ml-n4 pl-4 mr-n4 mt-2 pt-3 pb-2 align-items-baseline"
              >
                <div class="w-50">
                  <label class="w-25 text-light" for="quantity"
                    >{{ $t("quantity") }}:
                  </label>
                </div>
                <input
                  type="number"
                  min="1"
                  max="999"
                  step="1"
                  :value="quantity"
                  @change="
                    ($event) => {
                      quantity = Math.floor(
                        $event.target.value
                      ); /* whole numbers only */
                    }
                  "
                  class="w-25 ml-n3 text-secondary font-weight-bold border-0"
                />
              </div>
              <div
                class="d-flex ml-n4 pl-4 mr-n4 mt-2 py-2 border-bottom border-configurator"
              >
                <div class="w-50">
                  <span class="text-muted">{{ $t("cable-length") }}: </span>
                </div>
                <span class="ml-n3 text-secondary font-weight-bold"
                  >{{ $store.state.cableLength }} m</span
                >
              </div>
              <div
                class="d-flex ml-n4 pl-4 mr-n4 mt-2 py-2 border-bottom border-configurator"
              >
                <div class="w-50">
                  <span class="text-muted">{{ $t("delivery-time") }}: </span>
                </div>
                <span class="ml-n3 text-secondary font-weight-bold">{{
                  $t("days", ["7-14"])
                }}</span>
              </div>
              <div>
                <p class="text-secondary text-center pt-4 px-1">
                  {{ $t("register-hint.lead") }}<br />{{
                    $t("register-hint.text")
                  }}
                </p>
              </div>
              <div>
                <a
                  class="btn btn-sm bg-saka-green text-light rounded-pill w-100 py-2"
                  href="/login?login=true"
                  >Login</a
                >
                <a
                  class="mt-3 btn btn-sm bg-transparent border-saka-green text-saka-green rounded-pill w-100 py-2"
                  href="/login?register=true"
                  >{{ $t("register") }}</a
                >
              </div>
              <div class="mb-5 w-auto fixed-footer-block"></div>
            </div>
          </template>
        </configurator-step>
        <configurator-step
          v-else-if="configuratorStep === 4"
          class="d-block p-2"
          key="conclusion"
          :is-pigtail="isPigtail"
          :configuratorStep="configuratorStep"
          :load="
            () => {
              $store.state.features.fetchProductNumberEnabled
                ? setupAndResolveProductNumber()
                : () => {};
              triggerLastStep();
            }
          "
          :display-cable-side-indicator="false"
          :display-cable-length-input="false"
          :display-product-image="
            mobile.displayMode === `productImage` ? false : true
          "
          :display-product-info="
            mobile.displayMode === `productImage` ? false : true
          "
          :product-info="summary"
          :override-product-info-height="`auto`"
        >
          <template v-slot v-cloak>
            <div
              class="d-flex flex-column align-items-center"
              v-if="mobile.displayMode === `productImage`"
            >
              <img :src="`${$pathPrefix}/assets/done_v2.svg`" />
              <span class="text-secondary font-weight-bold">{{
                $t("done-mobile")
              }}</span>
              <hr class="d-block border border-configurator" />
              <button
                v-if="$store.state.loggedIn"
                @click="$modal.show('save-to-cart')"
                class="btn bg-saka-green text-light px-5 my-2 rounded-pill text-center"
              >
                {{ $t("addToCart") }}
              </button>
              <portal to="save-to-cart-modal" v-if="$store.state.loggedIn">
                <modal
                  name="save-to-cart"
                  adaptive
                  height="auto"
                  style="z-index: 1031"
                  @opened="disableAppScroll"
                  @closed="enableAppScroll"
                >
                  <fetch-price
                    :cable-length="parseFloat($store.state.cableLength)"
                  >
                    <form slot-scope="{ loading, price }">
                      <div class="px-2 pb-2 w-auto">
                        <div
                          class="bg-dark d-flex ml-n4 pl-4 mr-n4 mt-2 pt-3 pb-2 align-items-baseline"
                        >
                          <div class="w-50">
                            <label class="w-25 text-light" for="quantity"
                              >{{ $t("quantity") }}:
                            </label>
                          </div>
                          <input
                            type="number"
                            min="1"
                            max="999"
                            step="1"
                            :value="quantity"
                            @change="
                              ($event) => {
                                quantity = Math.floor(
                                  $event.target.value
                                ); /* whole numbers only */
                              }
                            "
                            class="w-25 ml-n3 text-secondary font-weight-bold border-0"
                          />
                        </div>
                        <div
                          class="d-flex ml-n4 pl-4 mr-n4 mt-2 py-2 border-bottom border-configurator"
                        >
                          <div class="w-50">
                            <span class="text-muted"
                              >{{ $t("cable-length") }}:
                            </span>
                          </div>
                          <span class="ml-n3 text-secondary font-weight-bold"
                            >{{ $store.state.cableLength }} m</span
                          >
                        </div>
                        <div
                          class="d-flex ml-n4 pl-4 mr-n4 mt-2 py-2 border-bottom border-configurator"
                        >
                          <div class="w-50">
                            <span class="text-muted"
                              >{{ $t("delivery-time") }}:
                            </span>
                          </div>
                          <span class="ml-n3 text-secondary font-weight-bold">{{
                            $t("days", ["7-14"])
                          }}</span>
                        </div>
                        <div class="d-flex ml-n4 pl-4 mr-n4 mt-2 py-2">
                          <div class="w-50">
                            <span class="text-muted">{{ $t("price") }}: </span>
                          </div>
                          <span class="ml-n3 text-secondary font-weight-bold"
                            >{{
                              new Intl.NumberFormat("de-DE", {
                                style: "currency",
                                currency: "EUR",
                              }).format(price)
                            }}
                          </span>
                        </div>
                        <div
                          class="d-flex ml-n4 pl-4 mr-n4 mt-2 py-3 bg-eee border-bottom"
                        >
                          <div class="w-50">
                            <span class="text-muted">{{ $t("total") }}: </span>
                          </div>
                          <span class="ml-n3 text-secondary font-weight-bold"
                            >{{
                              new Intl.NumberFormat("de-DE", {
                                style: "currency",
                                currency: "EUR",
                              }).format(parseFloat(price.toFixed(2)) * quantity)
                            }}
                          </span>
                        </div>
                        <button
                          :disabled="loading"
                          type="submit"
                          class="mt-2 px-4 py-2 bg-saka-green border-0 text-light rounded-pill w-100"
                          @click.prevent="addToCart"
                        >
                          {{ $t("addToCartPlus") }}
                        </button>
                      </div>
                    </form>
                  </fetch-price>
                </modal>
              </portal>
              <a
                v-if="$store.state.loggedIn"
                href="#"
                :disabled="false /* loading */"
                ref="addToMyCatalog"
                @click.prevent="$modal.show('save-to-catalog')"
                class="text-secondary d-inline-flex align-items-center my-2"
                v-html="$t('saveToMyCatalogue')"
              >
              </a>
              <a
                v-else
                :href="createOfferRequest"
                class="text-secondary d-inline-flex align-items-center"
                @click="triggerClickedOfferRequest"
                v-html="$t('requestOffer')"
              >
              </a>
              <hr class="d-block border border-configurator" />
              <a
                v-if="!$runtimeEnvironment.isMobileSafari"
                href="#"
                ref="mobileDownloadDataSheetButton"
                @click="triggerClickedDownloadDataSheet"
                class="text-secondary d-inline-flex align-items-center my-2"
                v-html="
                  dataSheetIsLoading
                    ? $t('generating-datasheet')
                    : $t('download-datasheet')
                "
              >
              </a>
              <hr
                class="d-block border border-configurator"
                v-if="!$runtimeEnvironment.isMobileSafari"
              />
              <a
                href="#"
                ref="addToFavorites"
                :disabled="false /* loading */"
                v-if="$store.state.loggedIn"
                @click.prevent="addToFavorites"
                class="text-secondary d-inline-flex align-items-center my-2"
                v-html="$t('addToFavorites')"
              >
              </a>
              <div class="mb-5 w-auto fixed-footer-block"><hr /></div>
            </div>
          </template>

          <template v-slot:pricing>
            <fetch-price
              :cable-length="parseFloat($store.state.cableLength)"
              v-if="$store.state.loggedIn"
            >
              <div class="w-auto" slot-scope="{ price }">
                <div
                  class="bg-dark d-flex ml-n4 pl-4 mr-n4 mt-2 pt-3 pb-2 align-items-baseline"
                >
                  <div class="w-50">
                    <label class="w-25 text-light" for="quantity"
                      >{{ $t("quantity") }}:
                    </label>
                  </div>
                  <input
                    type="number"
                    min="1"
                    max="999"
                    step="1"
                    :value="quantity"
                    @change="
                      ($event) => {
                        quantity = Math.floor(
                          $event.target.value
                        ); /* whole numbers only */
                      }
                    "
                    class="w-25 ml-n3 text-secondary font-weight-bold border-0"
                  />
                </div>
                <div
                  class="d-flex ml-n4 pl-4 mr-n4 mt-2 py-2 border-bottom border-configurator"
                >
                  <div class="w-50">
                    <span class="text-muted">{{ $t("cable-length") }}: </span>
                  </div>
                  <span class="ml-n3 text-secondary font-weight-bold"
                    >{{ $store.state.cableLength }} m</span
                  >
                </div>
                <div
                  class="d-flex ml-n4 pl-4 mr-n4 mt-2 py-2 border-bottom border-configurator"
                >
                  <div class="w-50">
                    <span class="text-muted">{{ $t("delivery-time") }}: </span>
                  </div>
                  <span class="ml-n3 text-secondary font-weight-bold">{{
                    $t("days", ["7-14"])
                  }}</span>
                </div>
                <div class="d-flex ml-n4 pl-4 mr-n4 mt-2 py-2">
                  <div class="w-50">
                    <span class="text-muted">{{ $t("price") }}: </span>
                  </div>
                  <span class="ml-n3 text-secondary font-weight-bold"
                    >{{
                      new Intl.NumberFormat("de-DE", {
                        style: "currency",
                        currency: "EUR",
                      }).format(price)
                    }}
                  </span>
                </div>
                <div
                  class="d-flex ml-n4 pl-4 mr-n4 mt-2 py-3 bg-eee border-bottom"
                >
                  <div class="w-50">
                    <span class="text-muted">{{ $t("total") }}: </span>
                  </div>
                  <span class="ml-n3 text-secondary font-weight-bold"
                    >{{
                      new Intl.NumberFormat("de-DE", {
                        style: "currency",
                        currency: "EUR",
                      }).format($store.state.price * quantity)
                    }}
                  </span>
                </div>
                <div class="w-auto py-3">
                  <button
                    @click="addToCart"
                    class="btn bg-saka-green text-light rounded-pill w-100 text-center text-capitalize"
                  >
                    {{ $t("addToCart") }}
                  </button>
                </div>
                <div class="mb-5 w-auto fixed-footer-block"><hr /></div>
              </div>
            </fetch-price>
            <div class="w-auto" v-else>
              <div
                class="bg-dark d-flex ml-n4 pl-4 mr-n4 mt-2 pt-3 pb-2 align-items-baseline"
              >
                <div class="w-50">
                  <label class="w-25 text-light" for="quantity"
                    >{{ $t("quantity") }}:
                  </label>
                </div>
                <input
                  type="number"
                  min="1"
                  max="999"
                  step="1"
                  :value="quantity"
                  @change="
                    ($event) => {
                      quantity = Math.floor(
                        $event.target.value
                      ); /* whole numbers only */
                    }
                  "
                  class="w-25 ml-n3 text-secondary font-weight-bold border-0"
                />
              </div>
              <div
                class="d-flex ml-n4 pl-4 mr-n4 mt-2 py-2 border-bottom border-configurator"
              >
                <div class="w-50">
                  <span class="text-muted">{{ $t("cable-length") }}: </span>
                </div>
                <span class="ml-n3 text-secondary font-weight-bold"
                  >{{ $store.state.cableLength }} m</span
                >
              </div>
              <div
                class="d-flex ml-n4 pl-4 mr-n4 mt-2 py-2 border-bottom border-configurator"
              >
                <div class="w-50">
                  <span class="text-muted">{{ $t("delivery-time") }}: </span>
                </div>
                <span class="ml-n3 text-secondary font-weight-bold">{{
                  $t("days", ["7-14"])
                }}</span>
              </div>
              <div>
                <p class="text-secondary text-center pt-4 px-1">
                  {{ $t("register-hint.lead") }}<br />{{
                    $t("register-hint.text")
                  }}
                </p>
              </div>
              <div>
                <a
                  class="btn btn-sm bg-saka-green text-light rounded-pill w-100 py-2"
                  href="/login?login=true"
                  >Login</a
                >
                <a
                  class="mt-3 btn btn-sm bg-transparent border-saka-green text-saka-green rounded-pill w-100 py-2"
                  href="/login?register=true"
                  >{{ $t("register") }}</a
                >
              </div>
              <div class="mb-5 w-auto fixed-footer-block"></div>
            </div>
          </template>
        </configurator-step>
      </transition>
      <div
        class="mobile-navigation container-md fixed-bottom d-flex justify-content-between align-items-center px-1 bg-white border-top border-configurator py-3"
        :class="{ 'mb-4': mobileSurvicateLoaded }"
      >
        <button
          class="btn btn-sm bg-saka-orange text-light rounded-pill px-4 py-2 mobile-step-button h-auto"
          @click="handleSwipeRight"
        >
          {{ $t("step-back") }}
        </button>
        <div class="flex-grow-1">
          <stepped-progress
            :steps="displaySteps"
            :plug-side="configuratorStep === 1 ? 'A' : 'B'"
            class="justify-content-center"
          />
        </div>
        <button
          class="btn btn-sm bg-saka-orange text-light rounded-pill px-4 py-2 mobile-step-button h-auto"
          :disabled="
            (isDataCenterMode
              ? configuratorStep === 4
              : configuratorStep === 3) && mobile.displayMode === 'productInfo'
          "
          @click="handleSwipeLeft"
        >
          {{ $t("step-forward") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SteppedProgress from "@/components/SteppedProgress";
import ConfiguratorStep from "@/components/ConfiguratorStep";
import FooterBar from "@/components/Footer";
import CustomSelect from "@/components/CustomSelect";
import ColorSelect from "@/components/ColorSelect";
import CarouselScrollSelect from "@/components/CarouselScrollSelect";
import ConfigurationNavigation from "@/components/ConfigurationNavigation";
import MultiColorSelect from "@/components/MultiColorSelect";
import SideBlock from "@/components/SideBlock";
import FetchPrice from "@/components/FetchPrice";
import RegisterHint from "@/components/RegisterHint";

import { mapGetters, /* mapMutations, */ mapState } from "vuex";
import calculatePlugCountFn from "@/utils/calculate-plug-count";
import calculateBendProtectionCount from "@/utils/calculate-bend-protection-count";
import jsreport from "jsreport-browser-client-dist";
import { fetchPngToDataUri } from "@/utils/fetch-png-to-datauri.js";
import {
  needsSpreader,
  needsShrinkingTube,
} from "@/utils/trunk-cable-needs-spreader";
import { buildMailtoOfferRequest } from "@/utils/build-mailto-offer-request";
import { stripIndents } from "common-tags";

import openRegistration from "@/mixins/open-registration";
import buildProductProperties from "@/mixins/build-product-properties";
import triggerMixin from "@/mixins/triggers";
import projectsNormalizerMixin from "@/mixins/projects-normalizer";

import fiberCountSorting from "@/utils/fiber-count-sorting";
import getProductClip from "@/utils/get-product-clip";
import shortestWhipLength from "@/utils/shortest-whip-length";
import blobToBase64 from "@/utils/blob-to-base64";
import { disableAppScroll, enableAppScroll } from "@/utils/app-scroll-toggle";

import Bowser from "bowser";

// remove for mdc
// import { mapProperties } from '@/utils/property-mapping.js'
import { getMaterialGroup } from "@/utils/material-groups.js";
import { getIndustryIds } from "@/utils/industries.js";

import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
//inquiryForm for digikey users
import InquiryForm from "@/components/InquiryForm.vue";
import Cookie from "js-cookie";

export default {
  name: "TrunkConfigurator",
  components: {
    SteppedProgress,
    ConfiguratorStep,
    CustomSelect,
    ColorSelect,
    CarouselScrollSelect,
    ConfigurationNavigation,
    FooterBar,
    MultiColorSelect,
    FetchPrice,
    SideBlock,
    RegisterHint,
    Treeselect,
    InquiryForm,

  },
  async mounted() {
    this.$store.state.getsDataCenterProducts
      ? await this.loadDataCenterData()
      : await this.loadDefaultData();

    if (!this.$store.state.loadedProduct) this.clearFilters();

    if (this.$store.state.cableLength < 3)
      this.$store.commit("setState", { stateKey: "cableLength", data: 3 });

    if (
      this.$store.state.loadedProduct &&
      this.$store.state.isPigtail === true
    ) {
      this.isPigtail = true;
      this.sideBPick = "pigtail";
    }

    this.resizeListener = window.addEventListener(
      "resize",
      this.trySetModalPosition,
      { capture: true, passive: true }
    );
    this.resizeListener = window.addEventListener(
      "scroll",
      this.trySetModalPosition,
      { capture: true, passive: true }
    );
    this.trySetModalPosition();
    this.showDigikey = localStorage.getItem("userSource");
    if (this.showDigikey === "digikey") {
      this.fetchPriceGroup();
      this.$store.commit("setLoggedIn", true); // Use mutation
    }
  },
  beforeDestroy() {
    document.removeEventListener("resize", this.trySetModalPosition);
    document.removeEventListener("scroll", this.trySetModalPosition);
  },
  data() {
    return {
      productGroup: 6,
      resizeListener: null,
      configuratorStep: 0,
      isPigtail: false,
      thickness: "normal",
      missingSelections: {
        0: [],
        1: [],
        2: [],
        3: [],
        4: [],
      },
      dataSheetIsLoading: true,
      dataSheet: null,
      dataSheetBlobUrl: null,
      dataSheetBlob: null,
      dataSheetError: null,
      remountKey: "cable-faces",
      cableId: null,
      showDigikey: null,
      surchargeDigikey: null,
      currency_adjustment_percent: null,
      quantity: 1,
      sideBPick: `individual`,
      modalPosition: {
        top: 1,
        right: 1,
        width: 1,
        height: 1,
        pivotY: 0.5,
      },
      duplicatePic: "",
      individualPic: "",
      pigtailPic: "",
      whipSteppings: ["straight", "2-times", "3-times", "4-times"],
      customProductNumber: null,
      browser: Bowser.parse(window.navigator.userAgent),
      base64Pdf: null,
      mobile: {
        displayMode: `productImage`,
      },
      productProperties: null,
      lengthIndependent: false,
      newProjectName: "",
      currentProjectId: null,
    };
  },
  computed: {
    activePage() {
      return this.displaySteps.filter((item) => item.state === "active")[0].key;
    },
    displaySteps() {
      return [
        {
          id: 0,
          label: 1,
          caption: this.$t("steps.default.cable"),
          state: this.configuratorStep === 0 ? "active" : "configured",
          key: "cable",
        },
        {
          id: 1,
          label: 2,
          caption: this.$t("steps.default.plugs"),
          state:
            this.configuratorStep === 1 || this.configuratorStep === 2
              ? "active"
              : this.configuratorStep >= 3
              ? "configured"
              : "unconfigured",
          key: "plugs",
        },
        {
          id: 2,
          label: 3,
          caption: this.$t("steps.default.options"),
          state:
            this.configuratorStep === 3
              ? "active"
              : this.configuratorStep === 4
              ? "configured"
              : "unconfigured",
          key: "options",
        },
        {
          id: 3,
          label: 4,
          caption: this.$t("steps.default.done"),
          state: this.configuratorStep === 4 ? "active" : "unconfigured",
          key: "done",
        },
      ];
    },
    ...mapGetters({
      distinctPropertyValuesFor: "distinctPropertyValues",
      disabledItemsForScope: "disabledPropertyValuesWithoutSelf",
      remainingCables: "remainingCables",
      selectedValue: "selectedValue",
      getCssColor: "getCssColor",
      filters: "filters",
      remainingPlugsA: "remainingPlugsA",
      remainingPlugsB: "remainingPlugsB",
      bendProtectionsA: "remainingBendProtectionsA",
      bendProtectionsB: "remainingBendProtectionsB",
      selectedBendProtectionA: "selectedBendProtectionA",
      selectedBendProtectionB: "selectedBendProtectionB",
      remainingWhipsA: "remainingWhipsA",
      remainingWhipsB: "remainingWhipsB",
      whipAId: "whipAId",
      whipBId: "whipBId",
      trunkWhipsA: "trunkWhipsA",
      trunkWhipsB: "trunkWhipsB",
    }),
    ...mapState([
      "bendProtections",
      "cableCompositionDataUri",
      "partsList",
      "cableLength",
      "mobileSurvicateLoaded",
      "projects",
      "pricingRequestData",
    ]),
    ...mapState({
      isDataCenterMode: "getsDataCenterProducts",
      protectionA: (state) =>
        state.protections.find(
          (protection) => protection.id === state.filters.protectionsA.id
        ) || null,
      protectionB: (state) =>
        state.protections.find(
          (protection) => protection.id === state.filters.protectionsB.id
        ) || null,
    }),
    selectedCableDropdownColor() {
      const cableColorName = this.selectedValue('cables', 'cableColor')
      return cableColorName ? this.getCssColor(cableColorName) : ''
    },
    // Filter spreaders by cable color for synchronization
    spreadersAByColor() {
      const cableColor = this.selectedValue('cables', 'cableColor')
      if (!cableColor) return this.$store.getters.spreadersA
      return this.$store.getters.spreadersA.filter(spreader => spreader.color === cableColor)
    },
    spreadersBByColor() {
      const cableColor = this.selectedValue('cables', 'cableColor')
      if (!cableColor) return this.$store.getters.spreadersB
      return this.$store.getters.spreadersB.filter(spreader => spreader.color === cableColor)
    },
    allSelectionsMade() {
      switch (this.configuratorStep) {
        case 0:
        case 1:
        case 2:
        case 3:
          return this.requiredSelections.every(
            (item) =>
              this.selectedValue(item.filterKey, item.propertyName) !== null
          );
        // && this.remainingCables.length === 1
        default:
          return false;
      }
    },
    requiredSelections() {
      switch (this.configuratorStep) {
        case 0: // maps to configuratorStep
          return [
            { filterKey: "cables", propertyName: "cableType" },
            { filterKey: "cables", propertyName: "fiberCount" },
            { filterKey: "cables", propertyName: "fiberClass" },
            { filterKey: "cables", propertyName: "cableColor" },
            { filterKey: "cables", propertyName: "manufacturer" },
          ];
        case 1:
          return [
            { filterKey: "plugsA", propertyName: "plugType" },
            { filterKey: "plugsA", propertyName: "plex" },
            { filterKey: "plugsA", propertyName: "polish" },
            { filterKey: "plugsA", propertyName: "manufacturer" },
            { filterKey: "plugsA", propertyName: "plugColor" },
            { filterKey: "plugsA", propertyName: "clip" },
            { filterKey: "bendProtectionsA", propertyName: "id" },
          ];
        case 2:
          return [
            { filterKey: "plugsB", propertyName: "plugType" },
            { filterKey: "plugsB", propertyName: "plex" },
            { filterKey: "plugsB", propertyName: "polish" },
            { filterKey: "plugsB", propertyName: "manufacturer" },
            { filterKey: "plugsB", propertyName: "plugColor" },
            { filterKey: "plugsB", propertyName: "clip" },
            { filterKey: "bendProtectionsB", propertyName: "id" },
          ];
        case 3: {
          if (this.isPigtail) {
            if (
              this.selectedValue("plugsA", "plugType") === "URM NG P8" &&
              this.$store.state.partsList.plugsA.length === 1
            ) {
              return [
                { filterKey: "fixationsA", propertyName: "id" },
                { filterKey: "whipsA", propertyName: "id" },
              ];
            } else {
              return [{ filterKey: "whipsA", propertyName: "id" }];
            }
          } else {
            if (
              this.selectedValue("plugsA", "plugType") === "URM NG P8" &&
              this.$store.state.partsList.plugsA.length === 1
            ) {
              return [
                { filterKey: "fixationsA", propertyName: "id" },
                { filterKey: "whipsA", propertyName: "id" },
                { filterKey: "fixationsB", propertyName: "id" },
                { filterKey: "whipsB", propertyName: "id" },
              ];
            } else {
              return [
                { filterKey: "whipsA", propertyName: "id" },
                { filterKey: "whipsB", propertyName: "id" },
              ];
            }
          }
        }
        case 4:
          return [];
        default:
          return [];
      }
    },
    createOfferRequest() {
      let language = this.$i18n.locale;
      let productDescription = `${this.quantity}x ${this.cableLength}m\n${this.summary}`;

      let mailtoLink = buildMailtoOfferRequest({
        productDescription,
        language,
      });

      return mailtoLink;
    },
     offerRequestParams() {
      return {
        language: this.$i18n.locale,
        productDescription: `${this.quantity}x ${this.cableLength}m\n${this.summary}`,
      };
    },
    summary() {
      return this.summaryByLocale(this.$i18n.locale);
    },
    isDataCenterToggleVisible: () =>
      window.location.hostname === "localhost" ||
      window.location.hostname === "emcom-go-dw2",
    additionalHints() {
      // Whip + Bend Protection means stepped whips longest to shortest
      let hints = [];

      if (this.protectionA && this.selectedValue("whipsA", "id")) {
        // get the length and use it to calculate the shortest whip length
        let whipLength = this.$store.state.whips.find(
          (item) => item.id === this.selectedValue("whipsA", "id")
        ).length;
        let whipLengthNumber = parseFloat(
          whipLength.replace("m", "").replace(",", ".")
        );
        let spreaderATimes =
          this.$store.state.partsList.plugsA.length *
          parseInt(this.selectedValue("plugsA", "plex") === "dx" ? 2 : 1);
        let whipMultiplierA =
          this.selectedValue("plugsA", "plex") !== "dx" ? 1 : 2;
        hints.push({
          type: "information",
          messageId: "hints.min-max-whips",
          fillInData: [
            "A", // which side
            shortestWhipLength({
              // calculated shrotest whip length
              spreaderTimes: spreaderATimes,
              whipLength: whipLengthNumber,
              isUrmP8: this.selectedValue("plugsA", "plugType") === "URM NG P8",
            }),
            this.calculatePlugCount({
              // last whip is always the shortest
              fiberCount: this.selectedValue("cables", "fiberCount"),
              plugType: this.selectedValue("plugsA", "plugType"),
              plex: this.selectedValue("plugsA", "plex"),
            }) * whipMultiplierA,
          ],
        });
      }

      // same as above for side B
      if (this.protectionB && this.selectedValue("whipsB", "id")) {
        let whipLength = this.$store.state.whips.find(
          (item) => item.id === this.selectedValue("whipsB", "id")
        ).length;
        let whipLengthNumber = parseFloat(
          whipLength.replace("m", "").replace(",", ".")
        );
        let spreaderBTimes =
          this.$store.state.partsList.plugsB.length *
          parseInt(this.selectedValue("plugsB", "plex") === "dx" ? 2 : 1);
        let whipMultiplierB =
          this.selectedValue("plugsB", "plex") !== "dx" ? 1 : 2;
        hints.push({
          type: "information",
          messageId: "hints.min-max-whips",
          fillInData: [
            "B",
            shortestWhipLength({
              spreaderTimes: spreaderBTimes,
              whipLength: whipLengthNumber,
              isUrmP8: this.selectedValue("plugsB", "plugType") === "URM NG P8",
            }),
            this.calculatePlugCount({
              fiberCount: this.selectedValue("cables", "fiberCount"),
              plugType: this.selectedValue("plugsB", "plugType"),
              plex: this.selectedValue("plugsB", "plex"),
            }) * whipMultiplierB,
          ],
        });
      }
      return hints;
    },
    disabledWhipsA() {
      // only if a ZuS is seleced, also look into disabledProtectionsA
      if (!this.selectedValue("protectionsA", "id")) return [];

      // get all the whips and there numeric lengths
      let whipsWithLengths = this.distinctPropertyValuesFor({
        scope: "getters",
        key: "trunkWhipsA",
        propertyName: "id",
        sort: false,
      }).map((whipId) => {
        return {
          whipId,
          length: parseFloat(
            this.$store.state.whips
              .find((whip) => whip.id === whipId)
              .length.replace("m", "")
              .replace(",", ".")
          ),
        };
      });

      // and how many single elements are on the spreader
      let spreaderTimes =
        this.$store.state.partsList.plugsA.length *
        parseInt(this.selectedValue("plugsA", "plex") === "dx" ? 2 : 1);

      // disable all those whips that are shorter then the minimum length via the
      // calculation of their shortest wip lengths
      let disabledWhipsWithTooShortLength = whipsWithLengths.filter(
        (whipWithLength) => {
          let shortestWhipLength = parseFloat(
            this.shortestWhipLength({
              spreaderTimes,
              whipLength: whipWithLength.length,
              locale: "en",
              isUrmP8: this.selectedValue("plugsA", "plugType") === "URM NG P8",
            })
          );
          return shortestWhipLength < 0.4;
        }
      );

      // only return the ids of the whips to disable them in the template
      return disabledWhipsWithTooShortLength.map(
        (whipWithLength) => whipWithLength.whipId
      );
    },
    disabledWhipsB() {
      if (!this.selectedValue("protectionsB", "id")) return [];

      let whipsWithLengths = this.distinctPropertyValuesFor({
        scope: "getters",
        key: "trunkWhipsB",
        propertyName: "id",
        sort: false,
      }).map((whipId) => {
        return {
          whipId,
          length: parseFloat(
            this.$store.state.whips
              .find((whip) => whip.id === whipId)
              .length.replace("m", "")
              .replace(",", ".")
          ),
        };
      });

      let spreaderTimes =
        this.$store.state.partsList.plugsB.length *
        parseInt(this.selectedValue("plugsB", "plex") === "dx" ? 2 : 1);

      let disabledWhipsWithTooShortLength = whipsWithLengths.filter(
        (whipWithLength) => {
          let shortestWhipLength = parseFloat(
            this.shortestWhipLength({
              spreaderTimes,
              whipLength: whipWithLength.length,
              locale: "en",
              isUrmP8: this.selectedValue("plugsB", "plugType") === "URM NG P8",
            })
          );
          return shortestWhipLength < 0.4;
        }
      );

      return disabledWhipsWithTooShortLength.map(
        (whipWithLength) => whipWithLength.whipId
      );
    },
    disabledProtectionsA() {
      if (!this.selectedValue("whipsA", "id")) return [];

      let selectedWhipLength = parseFloat(
        this.$store.state.whips
          .find((whip) => whip.id === this.selectedValue("whipsA", "id"))
          .length.replace("m", "")
          .replace(",", ".")
      );
      let spreaderTimes =
        this.$store.state.partsList.plugsA.length *
        parseInt(this.selectedValue("plugsA", "plex") === "dx" ? 2 : 1);
      let shortestWhipLength = this.shortestWhipLength({
        spreaderTimes,
        whipLength: selectedWhipLength,
        locale: "en",
        isUrmP8: this.selectedValue("plugsA", "plugType") === "URM NG P8",
      });
      if (shortestWhipLength < 0.4) {
        return this.$store.getters.protectionsA.map(
          (protection) =>
            protection /* .description.includes('Zug')).map(protection => protection*/.id
        );
      }
      return [];
    },
    disabledProtectionsB() {
      if (!this.selectedValue("whipsB", "id")) return [];

      let selectedWhipLength = parseFloat(
        this.$store.state.whips
          .find((whip) => whip.id === this.selectedValue("whipsB", "id"))
          .length.replace("m", "")
          .replace(",", ".")
      );
      let spreaderTimes =
        this.$store.state.partsList.plugsA.length *
        parseInt(this.selectedValue("plugsB", "plex") === "dx" ? 2 : 1);
      let shortestWhipLength = this.shortestWhipLength({
        spreaderTimes,
        whipLength: selectedWhipLength,
        locale: "en",
        isUrmP8: this.selectedValue("plugsB", "plugType") === "URM NG P8",
      });
      if (shortestWhipLength < 0.4) {
        return this.$store.getters.protectionsB.map(
          (protection) =>
            protection /*.description.includes('Zug')).map(protection => protection*/.id
        );
      }
      return [];
    },
    filterSpecification() {
      let spec = {
        cable: [
          // {
          //   name: 'Produktname',
          //   value: this.isPigtail
          //   ? this.$t('title.pigtail')
          //   : this.selectedValue('cables', 'fiberCount') === '1'
          //     ?  this.$t('title.simplexPatchCord')
          //     : this.$t('title.duplexPatchCord')
          // },
          {
            name: this.$t("cable-type"),
            value: this.selectedValue("cables", "cableType"),
          },
          {
            name: this.$t("usage-area"),
            value: this.genericCableType,
          },
          {
            name: this.$t("fiber-count"),
            value: `${this.selectedValue("cables", "fiberCount")}`,
          },
          {
            name: this.$t("fiber-class"),
            value: `${this.selectedValue("cables", "fiberClass")} (${
              this.selectedValue("cables", "fiberClass") &&
              this.selectedValue("cables", "fiberClass").indexOf("OS") > -1
                ? "Singlemode"
                : "Multimode"
            })`,
          },
        ],
        plugs: [
          {
            name: `${this.$t("plug-type")} A`,
            value: this.combinedPlugTypeA,
          },
          {
            name: `${this.$t("plug-plex")} A`,
            value: this.selectedValue("plugsA", "plex"),
          },
        ],
      };

      // { name: `${ this.$t('plug-type') } A`, value: `${ this.calculatePlugCount({
      //   fiberCount: this.selectedValue('cables', 'fiberCount'),
      //   plugType: this.selectedValue('plugsA', 'plugType'),
      //   plex: this.selectedValue('plugsA', 'plex')})}x ${this.selectedValue('plugsA', 'plugType')}${this.selectedValue('plugsA', 'polish')} ${this.selectedValue('plugsA', 'plex')}`},

      if (!this.isPigtail) {
        spec.plugs = spec.plugs.concat([
          {
            name: `${this.$t("plug-type")} B`,
            value: this.combinedPlugTypeB,
          },
          {
            name: `${this.$t("plug-plex")} B`,
            value: this.selectedValue("plugsB", "plex"),
          },
        ]);
      }
      return spec;
    },
    combinedPlugTypeA() {
      return `${this.selectedValue("plugsA", "plugType")}/${this.selectedValue(
        "plugsA",
        "polish"
      )}`.replace(/\/\//, "/");
    },
    combinedPlugTypeB() {
      return `${this.selectedValue("plugsB", "plugType")}/${this.selectedValue(
        "plugsB",
        "polish"
      )}`.replace(/\/\//, "/");
    },
    genericCableType() {
      let selectedCableType = this.selectedValue("cables", "cableType");

      if (!selectedCableType) return ``;

      let firstCharOfcableType = selectedCableType.charAt(0);

      switch (firstCharOfcableType) {
        case "A":
          return this.$t(`parameterValues.Außenkabel`);
        case "I":
          return this.$t(`parameterValues.Innenkabel`);
        case "U":
          return this.$t(`parameterValues.Universalkabel`);
        default:
          return ``;
      }
    },
    // spec vor neuem Katalog
    specification() {
      let spec = [
        {
          name: this.$t("cable-length"),
          value: `${this.$store.state.cableLength}m`,
        },
        {
          name: this.$t("fiber-count"),
          value: `${this.selectedValue("cables", "fiberCount")}`,
        },
        {
          name: this.$t("fiber-type"),
          value: `${
            this.selectedValue("cables", " fiberClass") === "E9/125µm"
              ? "Singlemode"
              : "Multimode"
          } (${this.selectedValue("cables", "fiberCount")})`,
        },
        {
          name: this.$t("cable-type"),
          value: this.selectedValue("cables", "cableType"),
        },
        {
          name: `${this.$t("plug-type")} A`,
          value: `${this.calculatePlugCount({
            fiberCount: this.selectedValue("cables", "fiberCount"),
            plugType: this.selectedValue("plugsA", "plugType"),
            plex: this.selectedValue("plugsA", "plex"),
          })}x ${this.selectedValue("plugsA", "plugType")}${this.selectedValue(
            "plugsA",
            "polish"
          )} ${this.selectedValue("plugsA", "plex")}`,
        },
      ];

      if (!this.isPigtail) {
        spec = spec.concat([
          {
            name: `${this.$t("plug-type")} B`,
            value: `${this.calculatePlugCount({
              fiberCount: this.selectedValue("cables", "fiberCount"),
              plugType: this.selectedValue("plugsB", "plugType"),
              plex: this.selectedValue("plugsB", "plex"),
            })}x ${this.selectedValue(
              "plugsB",
              "plugType"
            )}${this.selectedValue("plugsB", "polish")} ${this.selectedValue(
              "plugsB",
              "plex"
            )}`,
          },
        ]);
      }
      return spec;
    },
    shopCable() {
      let {
        filters,
        partsList,
        customLabelSideA,
        customLabelSideB,
        cableLength,
      } = this.$store.state;

      return {
        name: this.$t(`productNames.${this.$route.name}`, "de"),
        name_en: this.$t(`productNames.${this.$route.name}`, "en"),
        description: this.summaryByLocale("de"),
        description_en: this.summaryByLocale("en"),
        price: parseFloat(this.$store.state.listPrice.toFixed(2)),
        vkmin: parseFloat(this.$store.state.minPrice.toFixed(2)),
        length: cableLength,
        productgroup: this.productGroup,
        count: 1,
        show_in_catalog: 0,
        data: {
          filters,
          partsList,
          customLabelSideA,
          customLabelSideB,
          cableLength,
          configuratorType: this.$route.path,
          isPigtail: this.isPigtail,
          sideBPick: this.sideBPick,
          tabularSpecification: this.productProperties,
          shopFilters: this.filterSpecification,
          specification: this.specification,
          isDatacenterProduct: this.isDataCenterMode,
          pricingRequestData: this.pricingRequestData,
        },
        image: this.base64,
        // plug_a_id: this.plugAShopId,
        // plug_b_id: this.plugBShopId,
        excel_label:
          this.partsList.labelsA.length > 0 && this.partsList.labelsB.length > 0
            ? 1 // side A and B
            : (this.partsList.labelsA.length > 0 &&
                this.partsList.labelsB.length === 0) ||
              (this.partsList.labelsA.length > 0 && this.isPigtail)
            ? 2 // side A only
            : this.partsList.labelsB.length > 0 &&
              this.partsList.labelsA.length === 0
            ? 3 // side B only
            : 0, // no label
        datasheet: this.base64Pdf,
        materialgroup_id: getMaterialGroup({
          route: this.$route.name,
          isDatacenterMode: this.isDataCenterMode,
          fiberCount: this.selectedValue("cables", "fiberCount"),
        }),
        industry_ids: this.$store.state.userData.industries
          ? this.$store.state.userData.industries
          : getIndustryIds({ route: this.$route.name }),
        visibility: this.$store.state.loggedIn
          ? [`u${this.$store.state.userData.id}`]
          : [],
        use_pricegroup_new: 1,
      };
    },
  },
  methods: {
    fiberCountSorting,
    shortestWhipLength,
    calculatePlugCount: function({ fiberCount, plugType, plex }) {
      return calculatePlugCountFn({
        fiberCount,
        plugType,
        plex,
        cableType: this.$route.name,
      });
    },
    clearFilters() {
      // const filtersToClear = ['cables','plugsA','bendProtectionsA','plugsB',
      //     'bendProtectionsB','whipsA','whipsB','spreadersA','spreadersB',
      //     'fixationsA','fixationsB','protectionsA','protectionsB','labelsA',
      //     'labelsB'
      //   ]

      // if (this.configuratorStep === 0) {
      //   filtersToClear
      //     .forEach(filter =>
      //       this.$store.dispatch('clearLastFilterAndFilter', { filterKey: filter })
      //     )
      // }
      // if (this.configuratorStep === 1) {
      //   filtersToClear
      //     // without 'cables'
      //     .filter(filter => filter !== 'cables')
      //     .forEach(filter =>
      //       this.$store.dispatch('clearLastFilterAndFilter', { filterKey: filter })
      //     )
      // }

      // if (this.configuratorStep === 2 || this.configuratorStep === 3) {
      //   filtersToClear
      //     // without 'cables'
      //     .filter(filter => filter !== 'cables')
      //     // without sideA settings
      //     .filter(filter => filter !== 'plugsA' || filter !== 'bendProtectionsA')
      //     .forEach(filter =>
      //       this.$store.dispatch('clearLastFilterAndFilter', { filterKey: filter })
      //     )
      // }
      // ToDo
      // const filtersToClear = [
      //   'cables', 'plugsA', 'bendProtectionsA', 'plugsB', 'bendProtectionsB',
      //   'labels'
      // ]
      if (this.configuratorStep === 0) {
        ["cables"].forEach((filter) =>
          this.$store.dispatch("clearLastFilterAndFilter", {
            filterKey: filter,
          })
        );
      }

      if (this.configuratorStep === 1) {
        ["plugsA", "bendProtectionsA"].forEach((filter) =>
          this.$store.dispatch("clearLastFilterAndFilter", {
            filterKey: filter,
          })
        );
      }

      if (this.configuratorStep === 2) {
        ["plugsB", "bendProtectionsB"].forEach((filter) =>
          this.$store.dispatch("clearLastFilterAndFilter", {
            filterKey: filter,
          })
        );
      }
    },
    validateAllSelectionsMade() {
      if (this.allSelectionsMade) {
        switch (this.configuratorStep) {
          case 0:
            return this.setCableAndMoveForward();
          case 1:
            return this.setPlugAAndBendProtectionAAndMoveForward();
          case 2:
            return this.setPlugBAndBendProtectionBAndMoveForward();
          case 3:
            return this.setOptions();
        }
      }

      switch (this.configuratorStep) {
        case 0:
        case 1:
        case 2:
        case 3:
          this.missingSelections[this.configuratorStep] = [];
          this.missingSelections[this.configuratorStep] =
            this.requiredSelections.filter(
              (item) =>
                this.selectedValue(item.filterKey, item.propertyName) === null
            );
          break;
        default:
          // console.info("missing selections default. what to do?")
          break;
      }
    },
    missingSelectionIncludes({ step, filterKey, propertyName }) {
      return (
        this.missingSelections[step].filter(
          (item) =>
            item.filterKey == filterKey && item.propertyName == propertyName
        ).length > 0
      );
    },
    setCableAndMoveForward() {
      if (this.$store.state.partsList.plugsA.length > 0) {
        let cableId = this.remainingCables[0].id;

        let possibleCombos = this.$store.state.cablesPlugsCombinations
          .filter((combo) => combo.cableId === cableId)
          .map((combo) => combo.plugId);

        if (!possibleCombos.includes(this.$store.state.partsList.plugsA[0])) {
          this.$store.dispatch("clearLastFilterAndFilter", {
            filterKey: "plugsA",
          });
          this.$store.dispatch("clearLastFilterAndFilter", {
            filterKey: "bendProtectionsA",
          });
          this.$store.commit("clearPartsList", { partType: "plugsA" });
          this.$store.commit("clearPartsList", {
            partType: "bendProtectionsA",
          });
        }
      }

      if (this.$store.state.partsList.plugsB.length > 0) {
        let cableId = this.remainingCables[0].id;

        let possibleCombos = this.$store.state.cablesPlugsCombinations
          .filter((combo) => combo.cableId === cableId)
          .map((combo) => combo.plugId);

        if (!possibleCombos.includes(this.$store.state.partsList.plugsB[0])) {
          this.$store.dispatch("clearLastFilterAndFilter", {
            filterKey: "plugsB",
          });
          this.$store.dispatch("clearLastFilterAndFilter", {
            filterKey: "bendProtectionsB",
          });
          this.$store.commit("clearPartsList", { partType: "plugsB" });
          this.$store.commit("clearPartsList", {
            partType: "bendProtectionsB",
          });
        }
      }
      // reset for step back
      this.missingSelections[0] = [];

      // save cable composition for later
      let product = document.getElementById(
        `${this.selectedValue("cables", "cableType")}_${this.selectedValue("cables", "fiberCount") || 'default'}`
      );
      // // force scroll to cable face image
      if (!product) {
        this.remountKey = `${this.remountKey}-${Date.now()}`;
      }

      this.$nextTick(() => {
        product = document.getElementById(
          `${this.selectedValue("cables", "cableType")}_${this.selectedValue("cables", "fiberCount") || 'default'}`
        );
        let serializedProduct = new XMLSerializer().serializeToString(product);
        // console.log(serializedProduct)
        let cableCompositionDataUri =
          "data:image/svg+xml;base64," + btoa(serializedProduct);
        this.$store.commit("setState", {
          stateKey: "cableCompositionDataUri",
          data: cableCompositionDataUri,
        });

        let cableId = this.remainingCables[0].id;
        // eslint-disable-next-line
        // console.log(cableId)
        this.$store.commit("clearPartsList", { partType: "cables" });
        this.$store.commit("clearPartsList", { partType: "plugsA" });
        this.$store.commit("clearPartsList", { partType: "plugsB" });
        this.$store.commit("clearPartsList", { partType: "bendProtectionsA" });
        this.$store.commit("clearPartsList", { partType: "bendProtectionsB" });

        this.$store.commit("addToPartsList", {
          partType: "cables",
          partNumber: cableId,
        });

        let currentAutoFillSetting = this.$store.state.autoFill;
        // suppress auto fill on next page
        this.$store.commit("setAutoFill", { autoFill: false });

        // got next page
        this.configuratorStep += 1;

        // renenable autoFill so it works on selection
        this.$store.commit("setAutoFill", { autoFill: currentAutoFillSetting });
      });
    },
    setPlugAAndBendProtectionAAndMoveForward() {
      // reset for step back
      this.missingSelections[1] = [];

      // add plug to parts list
      let plugId = this.remainingPlugsA[0].id;
      this.$store.commit("clearPartsList", { partType: "plugsA" });

      let fiberCount = this.selectedValue("cables", "fiberCount");
      let plexSideA = this.selectedValue("plugsA", "plex");
      let plugTypeSideA = this.selectedValue("plugsA", "plugType");

      let numberOfPlugsSideA = calculatePlugCountFn({
        fiberCount: fiberCount,
        plugType: plugTypeSideA,
        plex: plexSideA,
        cableType: this.$route.name,
      });

      for (let i = 1; i <= numberOfPlugsSideA; i++) {
        this.$store.commit("addToPartsList", {
          partType: "plugsA",
          partNumber: plugId,
        });
      }

      // add the first bendProtection to side A
      if (this.selectedBendProtectionA) {
        this.$store.commit("clearPartsList", { partType: "bendProtectionsA" });
        let bendProtectionsSideACount = calculateBendProtectionCount({
          plex: plexSideA,
          plugCount: numberOfPlugsSideA,
        });
        for (let p = 1; p <= bendProtectionsSideACount; p++) {
          this.$store.commit("addToPartsList", {
            partType: "bendProtectionsA",
            partNumber: this.selectedBendProtectionA.id,
          });
        }
      }

      this.configuratorStep += 1;
    },
    setPlugBAndBendProtectionBAndMoveForward() {
      // reset for step back
      this.missingSelections[2] = [];

      // add plug to parts list
      let plugId = this.remainingPlugsB[0].id;
      this.$store.commit("clearPartsList", { partType: "plugsB" });

      let fiberCount = this.selectedValue("cables", "fiberCount");
      let plexSideB = this.selectedValue("plugsB", "plex");
      let plugTypeSideB = this.selectedValue("plugsB", "plugType");

      let numberOfPlugsSideB = calculatePlugCountFn({
        fiberCount: fiberCount,
        plugType: plugTypeSideB,
        plex: plexSideB,
        cableType: this.$route.name,
      });

      for (let i = 1; i <= numberOfPlugsSideB; i++) {
        this.$store.commit("addToPartsList", {
          partType: "plugsB",
          partNumber: plugId,
        });
      }

      // add the first bendProtection to side A
      if (this.selectedBendProtectionB) {
        this.$store.commit("clearPartsList", { partType: "bendProtectionsB" });
        let bendProtectionsSideBCount = calculateBendProtectionCount({
          plex: plexSideB,
          plugCount: numberOfPlugsSideB,
        });
        for (let p = 1; p <= bendProtectionsSideBCount; p++) {
          this.$store.commit("addToPartsList", {
            partType: "bendProtectionsB",
            partNumber: this.selectedBendProtectionB.id,
          });
        }
      }

      this.configuratorStep = 3;
    },
    setOptions() {
      this.$store.commit("clearPartsList", { partType: "spreadersA" });
      this.$store.commit("clearPartsList", { partType: "fixationsA" });
      this.$store.commit("clearPartsList", { partType: "protectionsA" });
      this.$store.commit("clearPartsList", { partType: "labelsA" });
      this.$store.commit("clearPartsList", { partType: "fixationsB" });
      this.$store.commit("clearPartsList", { partType: "spreadersB" });
      this.$store.commit("clearPartsList", { partType: "protectionsB" });
      this.$store.commit("clearPartsList", { partType: "labelsB" });

      let plugCountA = this.$store.state.partsList.plugsA.length;
      let plexSideA = this.selectedValue("plugsA", "plex");

      let whipMultiplier = plexSideA !== "dx" ? 1 : 2;

      let whipId = this.remainingWhipsA[0].id;
      this.$store.commit("setFilter", {
        filterKey: "whipsA",
        propertyName: "id",
        propertyValue: whipId,
      });

      this.$store.commit("clearPartsList", { partType: "whipsA" });
      // I-[FV](ZN)HH cables + P8 Plug do not need whips in the partslist
      // since they are allready in the cable
      let sideADoesNotGetWhips = needsShrinkingTube({
        cableType: this.selectedValue("cables", "cableType"),
        plugType: this.selectedValue("plugsA", "plugType"),
      });

      if (!sideADoesNotGetWhips) {
        for (let i = 1; i <= plugCountA * whipMultiplier; i++) {
          this.$store.commit("addToPartsList", {
            partType: "whipsA",
            partNumber: whipId,
          });
        }
      }

      this.$store.commit("clearPartsList", { partType: "fixationsA" });
      let fixationA = this.selectedValue("fixationsA", "id");
      if (fixationA) {
        this.$store.commit("addToPartsList", {
          partType: "fixationsA",
          partNumber: fixationA,
        });
      }

      this.$store.commit("clearPartsList", { partType: "spreadersA" });
      if (
        this.needsSpreader({
          cableType: this.selectedValue("cables", "cableType"),
          plugType: this.selectedValue("plugsA", "plugType"),
        })
      ) {
        let spreaderA =
          this.selectedValue("spreadersA", "id") ||
          this.$store.state.spreaders.filter(
            (spreader) =>
              spreader.times ==
              plugCountA *
                parseInt(this.selectedValue("plugsA", "plex") === "dx" ? 2 : 1)
          )[0].id;

        this.$store.commit("addToPartsList", {
          partType: "spreadersA",
          partNumber: spreaderA,
        });
        this.$store.commit("setFilter", {
          filterKey: "spreadersA",
          propertyName: "id",
          propertyValue: spreaderA,
        });
      }

      this.$store.commit("clearPartsList", { partType: "protectionsA" });
      let protectionA = this.selectedValue("protectionsA", "id");
      if (protectionA) {
        this.$store.commit("addToPartsList", {
          partType: "protectionsA",
          partNumber: protectionA,
        });
      }

      this.$store.commit("clearPartsList", { partType: "labelsA" });
      let labelA = this.selectedValue("labelsA", "id");
      if (labelA) {
        this.$store.commit("addToPartsList", {
          partType: "labelsA",
          partNumber: labelA,
        });
      }

      if (!this.isPigtail) {
        let plugCountB = this.$store.state.partsList.plugsB.length;
        let plexSideB = this.selectedValue("plugsB", "plex");

        whipMultiplier = plexSideB !== "dx" ? 1 : 2;

        whipId = this.remainingWhipsB[0].id;
        this.$store.commit("setFilter", {
          filterKey: "whipsB",
          propertyName: "id",
          propertyValue: whipId,
        });

        this.$store.commit("clearPartsList", { partType: "whipsB" });
        // I-[FV](ZN)HH cables + P8 Plug do not need whips in the partslist
        // since they are allready in the cable
        let sideBDoesNotGetWhips = needsShrinkingTube({
          cableType: this.selectedValue("cables", "cableType"),
          plugType: this.selectedValue("plugsB", "plugType"),
        });

        if (!sideBDoesNotGetWhips) {
          for (let i = 1; i <= plugCountB * whipMultiplier; i++) {
            this.$store.commit("addToPartsList", {
              partType: "whipsB",
              partNumber: whipId,
            });
          }
        }

        this.$store.commit("clearPartsList", { partType: "spreadersB" });
        if (
          this.needsSpreader({
            cableType: this.selectedValue("cables", "cableType"),
            plugType: this.selectedValue("plugsB", "plugType"),
          })
        ) {
          let spreaderB =
            this.selectedValue("spreadersB", "id") ||
            this.$store.state.spreaders.filter(
              (spreader) =>
                spreader.times ==
                plugCountB *
                  parseInt(
                    this.selectedValue("plugsB", "plex") === "dx" ? 2 : 1
                  )
            )[0].id;

          this.$store.commit("addToPartsList", {
            partType: "spreadersB",
            partNumber: spreaderB,
          });
          this.$store.commit("setFilter", {
            filterKey: "spreadersB",
            propertyName: "id",
            propertyValue: spreaderB,
          });
        }

        this.$store.commit("clearPartsList", { partType: "fixationsB" });
        let fixationB = this.selectedValue("fixationsB", "id");
        if (fixationB) {
          this.$store.commit("addToPartsList", {
            partType: "fixationsB",
            partNumber: fixationB,
          });
        }

        this.$store.commit("clearPartsList", { partType: "protectionsB" });
        let protectionB = this.selectedValue("protectionsB", "id");
        if (protectionB) {
          this.$store.commit("addToPartsList", {
            partType: "protectionsB",
            partNumber: protectionB,
          });
        }

        this.$store.commit("clearPartsList", { partType: "labelsB" });
        let labelB = this.selectedValue("labelsB", "id");
        if (labelB) {
          this.$store.commit("addToPartsList", {
            partType: "labelsB",
            partNumber: labelB,
          });
        }
      }

      this.configuratorStep += 1;

      this.fetchDataSheetAndMoveForward();
    },
    showSideBSetupModal() {
      try {
        // this method sets up the modal to chose the sibe B setup
        // is does so by
        //  1.) setting the product up as a pigtail and taking a picture
        //  2.) cloning the side A settings to side B and taking a picture
        //  3.) setting up individual settings for side B and ultimately taking a picture
        //    a) either via the settings that have been made earlier or that are passed via reconfigure
        //    b) picking a random plug and set a few of it's properties
        //  4.)reset the autoFill and display the modal

        // backup autoFill before generating pictures
        // this disables locking in a dicrete product
        let currentAutoFillSetting = this.$store.state.autoFill;
        this.$store.commit("setAutoFill", { autoFill: false });

        // backup side B settings, throw away references
        let filtersBackup = JSON.parse(
          JSON.stringify(this.$store.state.filters)
        );

        //  1.) set up pigtail
        this.isPigtail = true;

        // wait till propagation is done
        this.$nextTick(() => {
          // take and store the picture of the clipping area
          this.pigtailPic = getProductClip(this.$route.name);

          // reset for next picture
          this.isPigtail = false;

          // 2.) setup side A = side B
          this.$store.commit("cloneStateObject", {
            stateKey: "filters",
            sourceKey: "plugsA",
            destinationKey: "plugsB",
          });
          this.$store.commit("cloneStateObject", {
            stateKey: "filters",
            sourceKey: "bendProtectionsA",
            destinationKey: "bendProtectionsB",
          });

          // wait till propagation is done
          this.$nextTick(() => {
            // take and store picture
            this.duplicatePic = getProductClip(this.$route.name);

            // prepare individual side B settings
            this.$store.commit("clearFilters", { filterKey: "plugsB" });
            this.$store.commit("clearFilters", {
              filterKey: "bendProtectionsB",
            });

            // if side B has something setup (allready set up side B, reconfigure), reuse it
            if (Object.values(filtersBackup.plugsB).length > 0) {
              Object.entries(filtersBackup.plugsB).forEach(([key, value]) => {
                this.$store.commit("setFilter", {
                  filterKey: "plugsB",
                  propertyName: key,
                  propertyValue: value,
                });
              });
              this.$store.commit("setFilter", {
                filterKey: "bendProtectionsB",
                propertyName: "id",
                propertyValue: filtersBackup.bendProtectionsB.id,
              });
            }
            // else choose a ramm selectable plug and set it up for the picture
            else {
              let randomArrayIndex = Math.floor(
                Math.random() * (this.remainingPlugsB.length - 1)
              );
              let randomPlugB;

              if (
                this.remainingPlugsB.filter(
                  (plug) => plug.id != this.remainingPlugsA[0].id
                ).length === 0
              )
                randomPlugB = this.remainingPlugsA[0];
              else
                randomPlugB = this.remainingPlugsB.filter(
                  (plug) => plug.id != this.remainingPlugsA[0].id
                )[randomArrayIndex];

              if (!randomPlugB)
                this.$rollbar.warn(`${this.$route.name} side b setup error`, {
                  randomArrayIndex,
                  prefilterdPlugsB: this.remainingPlugsB.filter(
                    (plug) => plug.id != this.remainingPlugsA[0].id
                  ),
                });

              this.$store.commit("setFilter", {
                filterKey: "plugsB",
                propertyName: "plex",
                propertyValue: randomPlugB.plex,
              });
              this.$store.commit("setFilter", {
                filterKey: "plugsB",
                propertyName: "plugColor",
                propertyValue: randomPlugB.plugColor,
              });
              this.$store.commit("setFilter", {
                filterKey: "plugsB",
                propertyName: "plugType",
                propertyValue: randomPlugB.plugType,
              });
            }

            // wait till propagation is done
            this.$nextTick(() => {
              // take and store picture
              this.individualPic = getProductClip(this.$route.name);

              // reset settings from backups
              this.$store.state.filters.plugsB = filtersBackup.plugsB;
              this.$store.state.filters.bendProtectionsB =
                filtersBackup.bendProtectionsB;

              // show modal after value propagation is done
              this.$nextTick(() => {
                this.$refs["side-b-modal"].classList.remove("d-none");
                this.$refs["side-b-modal"].classList.add("d-block");

                // reset autoFill
                this.$store.commit("setAutoFill", {
                  autoFill: currentAutoFillSetting,
                });
              });
            });
          });
        });
      } catch (e) {
        this.$rollbar.error(e);
      }
    },
    handleSideBSetup() {
      switch (this.sideBPick) {
        case "duplicate":
          this.$store.commit("cloneStateObject", {
            stateKey: "filters",
            sourceKey: "plugsA",
            destinationKey: "plugsB",
          });
          this.$store.commit("cloneStateObject", {
            stateKey: "filters",
            sourceKey: "bendProtectionsA",
            destinationKey: "bendProtectionsB",
          });
          this.$store.commit("cloneStateObject", {
            stateKey: "partsList",
            sourceKey: "plugsA",
            destinationKey: "plugsB",
          });
          this.$store.commit("cloneStateObject", {
            stateKey: "partsList",
            sourceKey: "bendProtectionsA",
            destinationKey: "bendProtectionsB",
          });

          this.isPigtail = false;
          try {
            this.$refs["side-b-modal"].classList.remove("d-block");
            this.$refs["side-b-modal"].classList.add("d-none");
            // eslint-disable-next-line
          } catch (_) {}
          return (this.configuratorStep = 3);

        case "individual":
          this.isPigtail = false;

          try {
            this.$refs["side-b-modal"].classList.remove("d-block");
            this.$refs["side-b-modal"].classList.add("d-none");
            // eslint-disable-next-line
          } catch (_) {}
          return (this.configuratorStep = 2);

        case "pigtail":
          this.isPigtail = true;

          this.$store.commit("clearPartsList", { partType: "plugsB" });
          this.$store.commit("clearPartsList", {
            partType: "bendProtectionsB",
          });
          this.$store.commit("clearPartsList", { partType: "whipsA" });
          this.$store.commit("clearPartsList", { partType: "whipsB" });
          this.$store.commit("clearPartsList", { partType: "protectionsA" });
          this.$store.commit("clearPartsList", { partType: "protectionsB" });
          this.$store.commit("clearPartsList", { partType: "fixationsA" });
          this.$store.commit("clearPartsList", { partType: "fixationsB" });
          this.$store.commit("clearPartsList", { partType: "labelsA" });
          this.$store.commit("clearPartsList", { partType: "labelsB" });
          this.$store.commit("clearPartsList", { partType: "spreadersA" });
          this.$store.commit("clearPartsList", { partType: "spreadersB" });

          this.$store.dispatch("clearLastFilterAndFilter", {
            filterKey: "plugsB",
          });
          this.$store.dispatch("clearLastFilterAndFilter", {
            filterKey: "bendProtectionsB",
          });
          this.$store.dispatch("clearLastFilterAndFilter", {
            filterKey: "whipsA",
          });
          this.$store.dispatch("clearLastFilterAndFilter", {
            filterKey: "whipsB",
          });
          this.$store.dispatch("clearLastFilterAndFilter", {
            filterKey: "spreadersA",
          });
          this.$store.dispatch("clearLastFilterAndFilter", {
            filterKey: "spreadersB",
          });
          this.$store.dispatch("clearLastFilterAndFilter", {
            filterKey: "fixationsA",
          });
          this.$store.dispatch("clearLastFilterAndFilter", {
            filterKey: "fixationsB",
          });
          this.$store.dispatch("clearLastFilterAndFilter", {
            filterKey: "protectionsA",
          });
          this.$store.dispatch("clearLastFilterAndFilter", {
            filterKey: "protectionsB",
          });
          this.$store.dispatch("clearLastFilterAndFilter", {
            filterKey: "labelsA",
          });
          this.$store.dispatch("clearLastFilterAndFilter", {
            filterKey: "labelsB",
          });

          try {
            this.$refs["side-b-modal"].classList.remove("d-block");
            this.$refs["side-b-modal"].classList.add("d-none");
            // eslint-disable-next-line
          } catch (_) {}
          return (this.configuratorStep += 1);

        default:
          this.$rollbar.warn("bad sideBPick");
      }
    },
    async addToCart() {
      this.triggerClickedAddToCart();

      let { ...body } = this.shopCable;

      // if the product can be matched to a real product number
    // put it into the potential product number prop
    if (
      this.resolvedProductNumber &&
      this.resolvedProductNumber.toString().trim() !== ""
    ) {
      body["artnr_potential"] = this.resolvedProductNumber.toString().trim();
    }

      let { success, id, error } = await this.$shopApiClient.postCable({
        data: body,
      }); //
      if (!id && success === false) {
        this.$rollbar.error("can not create product in backend", error);
        return;
      }

      let { cableLength } = this.$store.state;

      let { /*cart, */ success: success2, error: error2 } =
        await this.$shopApiClient.addToCart({
          id: id,
          quantity: this.quantity,
          length: cableLength,
          type: "cable",
        });

      if (!success2 || error2) {
        this.$rollbar.error("can not add product to cart");
      }

      this.$notify({
        group: "app",
        text: "Kabel in den Warenkorb gelegt",
        type: "success",
      });

      if (process.env.NODE_ENV === "production") window.location.href = "/cart";
    },
    // async addToMyCatalog () {
    //   // eslint-disable-next-line no-unused-vars
    //   let { count, ...body } = Object.assign(
    //     {},
    //     this.shopCable,
    //     { show_in_catalog: 1 }
    //   )

    //   // save independet of cable length
    //   // ToDo: recalculate price to min length
    //   if (this.lengthIndependent) {
    //     body = Object.assign(body, {
    //       length_min: this.$store.getters.minCableLengthTrunk,
    //       length_max: 300,
    //       price_m: this.$store.state.cablePricePerMeter,
    //       price: this.$store.state.baseCablePrice
    //     })
    //   }

    //   if (this.customProductNumber && this.customProductNumber.trim() !== '') {
    //     body['artnr'] = this.customProductNumber
    //   }

    //   let { success, id, error } = await this.$shopApiClient.postCable({ data: body })
    //   if (!id && success === false) {
    //     this.$rollbar.error('can not create product in backend', error)
    //     return
    //   }

    //   this.$store.dispatch('cacheShopIdWithSpecification', id)

    //   this.$modal.hide('save-to-catalog')

    //   let addToMyCatalog = this.$refs['addToMyCatalog']
    //   addToMyCatalog.innerHTML = this.$t('saveToMyCatalogueDone')
    //   addToMyCatalog.classList.add('pointer-events-none')

    //   this.$notify({
    //     group: 'app',
    //     text: 'Kabel in den katalog gelegt',
    //     type:  'success'
    //   })

    // },
    // async addToFavorites () {
    //   // eslint-disable-next-line no-unused-vars
    //   let { count, show_in_catalog, ...body } = this.shopCable

    //   let { success, id, error } = await this.$shopApiClient.postCable({ data: body })
    //   if (!id && success === false) {
    //     this.$rollbar.error('can not create product in backend')
    //     // rollbar
    //     // eslint-disable-next-line
    //     this.$rollbar.error(error)
    //     return
    //   }

    //   let { success: success2, error: error2, favoritesCount } = await this.$shopApiClient.addToFavorites({ id })

    //   if (!success2 || error2 )
    //     this.$rollbar.error('can not add product to cart')

    //   let addToFavorites = this.$refs['addToFavorites']
    //   addToFavorites.innerHTML = this.$t('addToFavoritesDone')
    //   addToFavorites.classList.add('pointer-events-none')

    //   try {
    //     let favoritesCountElement  = document.querySelector('.count')
    //     favoritesCountElement.innerHTML = `(${ favoritesCount })`
    //   } catch(e) {
    //     this.$rollbar.warn('can not set favorites count in template')
    //   }

    //   this.$notify({
    //     group: 'app',
    //     text: 'Kabel gemerkt',
    //     type:  'success'
    //   })
    // },
    async addToProject() {
      if (
        this.currentProjectId === -1 ||
        this.currentProjectId === null ||
        this.currentProjectId == []
      ) {
        try {
          this.$refs.projectSelect.classList.add("is-invalid");
        } catch (_) {
          // continue
        }
        return;
      }

      try {
        this.$refs.projectSelect.classList.remove("is-invalid");
      } catch (_) {
        // continue
      }

      // strip count and set show in catalog to true
      // eslint-disable-next-line no-unused-vars
      let { count, show_in_catalog, project_ids, ...body } = this.shopCable;

      // let the custoemr set a custom product number
      if (this.customProductNumber && this.customProductNumber.trim() !== "") {
        body["artnr"] = this.customProductNumber;
      }

      // always save length indipendent
      if (this.lengthIndependent) {
        body = Object.assign(body, {
          length_min: this.$store.getters.minCableLengthTrunk,
          length_max: 300,
          price_m: this.$store.state.cablePricePerMeter,
        });
      }

      //eslint-disable-next-line
      console.log(this.currentProjectId);

      // single project
      if (this.currentProjectId && !Array.isArray(this.currentProjectId)) {
        body = Object.assign(body, {
          project_ids: [parseInt(this.currentProjectId)],
        });
      }

      // multiple projects (as admin)
      if (this.currentProjectId && Array.isArray(this.currentProjectId)) {
        body = Object.assign(body, {
          project_ids: this.currentProjectId.map((p) => p.id),
        });
      }

      // if the product can be matched to a real product number
      // put it into the potential product number prop
      if (
        this.resolvedProductNumber &&
        this.resolvedProductNumber.trim() !== ""
      ) {
        body["artnr_potential"] = this.resolvedProductNumber;
      }

      body["show_in_catalog"] = 1;

      // save the cable
      let { success, id, error } = await this.$shopApiClient.postCable({
        data: body,
      });
      if (!id && success === false) {
        this.$rollbar.error("can not create product in backend", error);
        return;
      }

      this.$shopApiClient.refreshCustomerFilters();

      Cookie.remove("project_add_product");

      this.$store.dispatch("cacheShopIdWithSpecification", id);

      this.$notify({
        group: "app",
        text: "Kabel ins Projekt gespeichert",
        type: "success",
      });

      if (process.env.NODE_ENV === "production")
        window.location = `/cable/show/${id}`;
    },
    async tryGetPlugImage(plugId) {
      if (!plugId) return null;

      const baseUrl = process.env.NODE_ENV === "production" ? "/cms/cables-vnext" : "";

      // known manual mappings for ambiguous plug names
      const plugImageMap = {
        "sn-ez-flip-dx-blau": "sn-ez-flip_dx_blau",
        "sn ez-flip": "sn-ez-flip_dx_blau",
        "sn ez flip": "sn-ez-flip_dx_blau",
        "sn ezflip": "sn-ez-flip_dx_blau",
        "SN EZ-Flip": "sn-ez-flip_dx_blau",
      };

      const idStr = plugId.toString();

      // build candidate filenames to try (no extension) with preferred ordering
      const candidates = [];

      // explicit map hits first
      if (plugImageMap[idStr]) candidates.push(plugImageMap[idStr]);
      if (plugImageMap[idStr.toLowerCase()])
        candidates.push(plugImageMap[idStr.toLowerCase()]);

      // prefer uppercase + underscore (server assets use this pattern often)
      candidates.push(idStr.toUpperCase().replace(/[\s-]+/g, "_"));
      candidates.push(idStr.replace(/-/g, "_").toUpperCase());

      // then common underscore / case-preserving variants
      candidates.push(idStr.replace(/-/g, "_"));
      candidates.push(idStr.toUpperCase());
      candidates.push(idStr.toLowerCase().replace(/[\s_-]+/g, "_"));

      // hyphen / dash variants
      candidates.push(idStr.replace(/\s+/g, "-"));
      candidates.push(idStr.toLowerCase().replace(/\s+/g, "-"));

      // common suffix variants (lowercase)
      candidates.push(`${idStr.toLowerCase()}_dx_blau`);
      candidates.push(`${idStr.toLowerCase()}_blau`);

      // normalize and dedupe while preserving order
      const uniq = [];
      for (const c of candidates) {
        if (c && !uniq.includes(c)) uniq.push(c);
      }

      const failed = [];
      for (const candidate of uniq) {
        const filename = `${baseUrl}/assets/plugs_datasheet/${candidate}.png`;
        try {
          const plugDataUri = await fetchPngToDataUri(filename);
          return plugDataUri;
        } catch (_err) {
          failed.push(filename);
        }
      }

      // not found — log to rollbar for monitoring
      this.$rollbar.log("[Trunk] can not find plug image after candidates", {
        plugId,
        candidates: uniq,
        failed,
      });
      return null;
    },
    async fetchDataSheetAndMoveForward() {
      this.dataSheet = null;

      // reformat the product picture
      let product = document.getElementById("product");

      // console.log(product.style)
      let viewBox = product.getAttribute("viewBox");
      let width = product.getBBox().width;
      let marginTop = product.style.marginTop;

      product.removeAttribute("style");
      product.setAttribute("viewBox", `20 20 ${width} 180`);
      this.rescaleProductImage = true;
      let customLabels = document.getElementsByClassName("custom-label");
      Array.from(customLabels).forEach((el) => {
        el.style.display = "none";
      });

      let legend = document.getElementById("canvas-legend");
      legend.style.display = "none";

      let whipLegends = document.getElementsByClassName("whip-legends");
      Array.from(whipLegends).forEach(
        (element) => (element.style.display = "none")
      );

      // serialize the formated product picture to dataUri
      let serializedProduct = new XMLSerializer().serializeToString(product);
      serializedProduct = serializedProduct.replace(/<!---->/g, "");
      let base64Product = btoa(serializedProduct);
      this.svg = serializedProduct;
      this.base64 = base64Product;

      let productImageData = "data:image/svg+xml;base64," + base64Product;

      // // reset to product image data
      product.setAttribute("style", "");
      product.style.marginTop = marginTop;
      product.setAttribute("viewBox", viewBox);
      Array.from(customLabels).forEach((el) => {
        el.style["display"] = "block";
      });

      legend.style.display = "inline";
      Array.from(whipLegends).forEach(
        (element) => (element.style.display = "inline")
      );

      // fetch product images (guard partsList entries to avoid undefined plugId)
      let plugADataUri = null;
      try {
        let plugAId = null;
        if (
          this.partsList &&
          Array.isArray(this.partsList.plugsA) &&
          this.partsList.plugsA.length > 0
        ) {
          plugAId = this.partsList.plugsA[0];
        } else if (
          this.remainingPlugsA &&
          Array.isArray(this.remainingPlugsA) &&
          this.remainingPlugsA.length > 0 &&
          this.remainingPlugsA[0].id
        ) {
          plugAId = this.remainingPlugsA[0].id;
        }

        if (plugAId) plugADataUri = await this.tryGetPlugImage(plugAId);
      } catch (err) {
        this.$rollbar.error('[Trunk] error fetching plugA image', err);
      }

      let plugBDataUri = null;
      if (!this.isPigtail) {
        try {
          let plugBId = null;
          if (
            this.partsList &&
            Array.isArray(this.partsList.plugsB) &&
            this.partsList.plugsB.length > 0
          ) {
            plugBId = this.partsList.plugsB[0];
          } else if (
            this.remainingPlugsB &&
            Array.isArray(this.remainingPlugsB) &&
            this.remainingPlugsB.length > 0 &&
            this.remainingPlugsB[0].id
          ) {
            plugBId = this.remainingPlugsB[0].id;
          }

          if (plugBId) plugBDataUri = await this.tryGetPlugImage(plugBId);
        } catch (err) {
          this.$rollbar.error('[Trunk] error fetching plugB image', err);
        }
      }

      //
      this.productProperties = await this.buildProductProperties({
        cable: this.remainingCables[0],
        plugA: this.remainingPlugsA[0],
        plugB: this.remainingPlugsB[0],
        configuratorType: this.$route.name,
      });

      // build the jsreport request object
      let request = {
        template: {
          name: "/configurator/data_sheet_singlepage_v2",
          pdfOperations: [
            {
              templateShortid:
                this.$i18n.locale === "de" ? "HJx7xte2t2" : "H1ex3TG3Fh",
              type: "append",
            },
          ],
        },
        data: {
          isGerman: this.$i18n.locale === "de",
          bPlus:
            this.remainingPlugsA[0]["classBPlus"] === "Grade B+" ||
            this.remainingPlugsB[0]["classBPlus"] === "Grade B+",
          cableProfile: true,
          hundredPercent: true,
          title: this.$t("dataSheet"),
          headerImage: productImageData,
          cableCompositionImage: this.cableCompositionDataUri,
          cableCompositionImageCaption: this.selectedValue(
            "cables",
            "cableType"
          ),
          plugAImage: plugADataUri,
          plugAImageCaption: this.$t("plug-a"),
          plugBImage: plugBDataUri,
          plugBImageCaption: this.$t("plug-b"),
          productType: this.$t(`productNames.${this.$route.name}`),
          productProperties: this.productProperties,
          isPigtail: this.isPigtail,
        },
        options: {
          timeout: 60000,
          "Content-Disposition": "attachment; filename=DataSheet.pdf",
        },
      };

      if (this.shopCable.description.includes("Zug- & Schutz")) {
        if (this.shopCable.description.includes("unverlierbar")) {
          request.template.pdfOperations.push({
            templateShortid: "SkxuqYlht3",
            type: "append",
          });
        } else {
          if (this.$i18n.locale === "de")
            request.template.pdfOperations.push({
              templateShortid: "SkxIuYg3Y2",
              type: "append",
            });
          else
            request.template.pdfOperations.push({
              templateShortid: "HkxVWTz3F2",
              type: "append",
            });
        }
      }

      // init jsreport
      jsreport.serverUrl = process.env.VUE_APP_JSREPORT_SERVER_URL;

      // try to get the report and display it in the dataSheet section
      try {
        this.dataSheetIsLoading = true;

        jsreport.renderAsync(request).then((res) => {
          let blob = new Blob([new Uint8Array(res, 0, res.length)], {
            type: "application/pdf",
          });

          blobToBase64(blob).then(
            (base64Data) => (this.base64Pdf = base64Data)
          ); // add datasheet blob to catalog

          // IE 11
          if (window.navigator.msSaveOrOpenBlob) {
            this.dataSheetBlob = blob;
          } else {
            this.dataSheetBlobUrl = URL.createObjectURL(blob);
            try {
              if (this.$runtimeEnvironment.isMobile) {
                this.$refs.mobileDownloadDataSheetButton.href =
                  this.dataSheetBlobUrl;
                this.$refs.mobileDownloadDataSheetButton.download =
                  this.$t("dataSheet") + ".pdf";
              } else {
                this.$refs.downloadDataSheetButton.href = this.dataSheetBlobUrl;
                this.$refs.downloadDataSheetButton.download =
                  this.$t("dataSheet") + ".pdf";
              }
            } catch (e) {
              this.$rollbar.warn(e);
            }
          }
          this.dataSheetIsLoading = false;
        });
      } catch (err) {
        // console.log(err)
        this.$rollbar.error("Can not render report", err);
        this.dataSheetError = this.$t("jsreport.error-render-datasheet");
      }

      // move forward
      this.configuratorStep = 4;
    },
    needsSpreader,
    async saveRespecification() {
      // eslint-disable-next-line no-unused-vars
      let { count, show_in_catalog, ...body } = this.shopCable;

      let { success, id, error } = await this.$shopApiClient.updateCable({
        data: body,
        id: this.$store.state.respecifyId,
      });
      if (!id && success === false) {
        this.$rollbar.error("can not update product in backend");
        // rollbar
        // eslint-disable-next-line
        this.$rollbar.error(error);
        return;
      }

      let saveRespec = this.$refs["saveRespcification"];
      saveRespec.innerHTML = `<span class="text-saka-orange"><i class="fas fa-check"></i>Als Kabel ${this.$store.state.respecifyId} gespeichert<span>`;
    },
    async loadDefaultData() {
      if (process.env.NODE_ENV === `production`) this.configuratorStep = 0;

      if (!this.$store.state.loadedProduct) {
        this.$store.commit("clearAllFilters");
      }

      await this.$store.dispatch("fetchInitialData", {
        stateKey: "cables",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_cables?single=1",
      });
      await this.$store.dispatch("fetchInitialData", {
        stateKey: "plugs",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_plugs?single=1",
      });
      await this.$store.dispatch("fetchInitialData", {
        stateKey: "cablesPlugsCombinations",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_cables_plugs_default_combos?single=1",
      });
      await this.$store.dispatch("fetchInitialData", {
        stateKey: "bendProtections",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_bendprotections?single=1",
      });
      await this.$store.dispatch("fetchInitialData", {
        stateKey: "plugsBendProtectionsCombinations",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_plugs_bendprotections_default_combos?single=1",
      });
      await this.$store.dispatch("fetchInitialData", {
        stateKey: "spreaders",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_spreaders?single=1",
      });
      await this.$store.dispatch("fetchInitialData", {
        stateKey: "whips",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_whips_v2?single=1",
      });
      await this.$store.dispatch("fetchInitialData", {
        stateKey: "cablesWhipsCombinations",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_cables_whips_default_combos_v2?single=1",
      });
      await this.$store.dispatch("fetchInitialData", {
        stateKey: "plugsWhipsCombinations",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_plugs_whips_default_combos_v2?single=1",
      });
      await this.$store.dispatch("fetchInitialData", {
        stateKey: "fixations",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_fixations?single=1",
      });
      await this.$store.dispatch("fetchInitialData", {
        stateKey: "protections",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_protections?single=1",
      });
      await this.$store.dispatch("fetchInitialData", {
        stateKey: "cablesFixationsCombinations",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_cables_fixations_default_combos?single=1",
      });
      await this.$store.dispatch("fetchInitialData", {
        stateKey: "cablesSpreadersCombinations",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_cables_spreaders_default_combos?single=1",
      });
      await this.$store.dispatch("fetchInitialData", {
        stateKey: "cablesProtectionsCombinations",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_cables_protections_default_combos?single=1",
      });
      await this.$store.dispatch("fetchInitialData", {
        stateKey: "labels",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_labels?single=1",
      });
    },
    async fetchPriceGroup() {
      try {
        const response = await fetch(
          "https://directus-api.sachsenkabel.de/_/items/pricegroups?single=1",
          {}
        );
        const result = await response.json();
        /* eslint-disable no-console */
        // Safe access without optional chaining
        const priceGroupData = result && result.data && result.data.data;
        if (Array.isArray(priceGroupData) && priceGroupData.length > 0) {
          const priceGroup = priceGroupData[0];
          this.name = priceGroup.name;
          this.surchargeDigikey = priceGroup.surcharge;
          this.currency_adjustment_percent =
            priceGroup.currency_adjustment_percent;
          // console.log("Name:", this.name);
          // console.log("currency_adjustment_percent:", this.currency_adjustment_percent);
        } else {
          console.warn("Price group data not found.");
        }
      } catch (err) {
        console.error("API error:", err);
      }
    },
    async loadDataCenterData() {
      if (process.env.NODE_ENV === `production`) this.configuratorStep = 0;

      if (!this.$store.state.loadedProduct) {
        this.$store.commit("clearAllFilters");
      }

      // start mdc
      // let mdcPlug = {
      //   'artikel_id': 'XA04-0013',
      //   'Ausführung': 'MDC',
      //   'Clip': 'ohne',
      //   'Fabrikat': 'US Conec',
      //   'Farbe': 'blau',
      //   'Faser': 'sx',
      //   'Ferrule': 'Keramik',
      //   'Politur': '/UPC',
      //   'Steckertyp': 'MDC',
      //   'Variante': '1',
      //   'Besonderheit Bez. 1': '',
      //   'Grade B+': ''
      // }

      // let mappedMdcAsArray = mapProperties('plugs', [mdcPlug])

      // let mdcAndCablePairs = [{
      //   cableId: 'MA01-0402',
      //   plugId: 'XA04-0013'
      // },
      // {
      //   cableId: 'MA01-0304',
      //   plugId: 'XA04-0013'
      // },
      // ]

      // let mdcAndBendProtectionPair = {
      //   bendProtectionId: 'YA01-0031',
      //   plugId: 'XA04-0013'
      // }

      // let bendProtection = {
      //   'artikel_id': 'YA01-0031',
      //   'Fabrikat': 'US Conec',
      //   'Farbe': 'schwarz',
      //   'Flexibilitaet': 'flexibel'
      // }

      // let mappedBendprotectionsAsArray = mapProperties('bendProtections', [bendProtection])

      // let plugWhipPair = {
      //   plugId: 'XA04-0013',
      //   whipId: 'XC02-0058'
      // }
      // // // end mdc

      await this.$store.dispatch("fetchInitialData", {
        stateKey: "cables",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_cables_datacenter?single=1",
      });
      await this.$store.dispatch("fetchInitialData", {
        stateKey: "plugs",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_plugs_datacenter?single=1",
      });
      await this.$store.dispatch("fetchInitialData", {
        stateKey: "cablesPlugsCombinations",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_cables_plugs_datacenter_combos?single=1",
      });
      await this.$store.dispatch("fetchInitialData", {
        stateKey: "bendProtections",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_bendprotections?single=1",
      });
      await this.$store.dispatch("fetchInitialData", {
        stateKey: "plugsBendProtectionsCombinations",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_plugs_bendprotections_datacenter_combos?single=1",
      });
      await this.$store.dispatch("fetchInitialData", {
        stateKey: "spreaders",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_spreaders?single=1",
      });
      await this.$store.dispatch("fetchInitialData", {
        stateKey: "whips",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_whips_datacenter_v2?single=1",
      });
      await this.$store.dispatch("fetchInitialData", {
        stateKey: "cablesWhipsCombinations",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_cables_whips_datacenter_combos_v2?single=1",
      });
      await this.$store.dispatch("fetchInitialData", {
        stateKey: "plugsWhipsCombinations",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_plugs_whips_datacenter_combos_v2?single=1",
      });
      await this.$store.dispatch("fetchInitialData", {
        stateKey: "fixations",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_fixations?single=1",
      });
      await this.$store.dispatch("fetchInitialData", {
        stateKey: "protections",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_protections?single=1",
      });
      await this.$store.dispatch("fetchInitialData", {
        stateKey: "cablesFixationsCombinations",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_cables_fixations_datacenter_combos?single=1",
      });
      await this.$store.dispatch("fetchInitialData", {
        stateKey: "cablesSpreadersCombinations",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_cables_spreaders_datacenter_combos?single=1",
      });
      await this.$store.dispatch("fetchInitialData", {
        stateKey: "cablesProtectionsCombinations",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_cables_protections_datacenter_combos?single=1",
      });
      await this.$store.dispatch("fetchInitialData", {
        stateKey: "labels",
        url: "https://directus-api.sachsenkabel.de/_/items/trunk_labels_datacenter?single=1",
      });

      // // start mdc
      // this.$store.commit('setState', { stateKey: 'plugs', data: this.$store.state.plugs.concat(mappedMdcAsArray)})
      // this.$store.commit('setState', { stateKey: 'cablesPlugsCombinations', data: this.$store.state.cablesPlugsCombinations.concat(mdcAndCablePairs)})
      // this.$store.commit('setState', { stateKey: 'bendProtections', data: this.$store.state.bendProtections.concat(mappedBendprotectionsAsArray)})
      // this.$store.commit('setState', { stateKey: 'plugsBendProtectionsCombinations', data: this.$store.state.plugsBendProtectionsCombinations.concat([mdcAndBendProtectionPair])})
      // this.$store.commit('setState', { stateKey: 'plugsWhipsCombinations', data: this.$store.state.plugsWhipsCombinations.concat([plugWhipPair])})
      // // end mdc
    },
    trySetModalPosition() {
      this.$nextTick(() => {
        try {
          let inner = document
            .getElementById("configurator-inner")
            .getBoundingClientRect();
          let forwardButton = document
            .getElementById("forward-button")
            .getBoundingClientRect();

          if (inner && forwardButton) {
            this.modalPosition.right = inner.right;
            this.modalPosition.top = inner.top;
            this.modalPosition.height = forwardButton.bottom - inner.top + 24;
          }
        } catch (e) {
          // eslint-disable-next-line
        }
      });
    },
    showSafariModal() {
      this.$modal.show("dialog", {
        title: this.$t("side-b-setup.title"),
        buttons: [
          {
            title: this.$t("side-b-setup.duplicate-settings"),
            handler: () => {
              this.sideBPick = "duplicate";
              this.handleSideBSetup();
              this.$modal.hide("dialog");
            },
          },
          {
            title: this.$t("side-b-setup.individual"),
            handler: () => {
              this.sideBPick = "individual";
              this.handleSideBSetup();
              this.$modal.hide("dialog");
            },
          },
          {
            title: this.$t("side-b-setup.pigtail"),
            handler: () => {
              this.sideBPick = "pigtail";
              this.handleSideBSetup();
              this.$modal.hide("dialog");
            },
          },
        ],
      });
    },
    IEDataSheetDownload() {
      this.triggerClickedDownloadDataSheet();
      window.navigator.msSaveOrOpenBlob(
        this.dataSheetBlob,
        this.$t("dataSheet") + ".pdf"
      );
    },
    setupAndResolveProductNumber() {
      if (this.isPigtail)
        return this.tryResolveProductNumber(
          this.$store.getters.orderedPartsList,
          this.$store.state.whips.find(
            (whip) => whip.id === this.selectedValue("whipsA", "id")
          ).length
        );

      return this.tryResolveProductNumber(
        this.$store.getters.orderedPartsList,
        this.$store.state.whips.find(
          (whip) => whip.id === this.selectedValue("whipsA", "id")
        ).length,
        this.$store.state.whips.find(
          (whip) => whip.id === this.selectedValue("whipsB", "id")
        ).length
      );
    },
    whipSorting(firstWhip, secondWhip) {
      let firstWhipLength = this.$store.state.whips.find(
        (whip) => whip.id === firstWhip
      ).length;
      let secondWhipLength = this.$store.state.whips.find(
        (whip) => whip.id === secondWhip
      ).length;

      if (firstWhipLength < secondWhipLength) return -1;
      if (firstWhipLength == secondWhipLength) return 0;
      return 1;
    },
    handleSwipeRight() {
      // eslint-disable-next-line
      switch (this.configuratorStep) {
        case 0:
          this.$router.push("/");
          break;
        case 1:
        case 2:
        case 3:
          this.configuratorStep -= 1;
          break;
        case 4:
          this.resolvedProductNumber = null;
          this.mobile.displayMode === `productInfo`
            ? (this.mobile.displayMode = `productImage`)
            : (this.configuratorStep = 3);
          break;
        default:
          break;
      }
    },
    async handleSwipeLeft() {
      switch (this.configuratorStep) {
        case 0:
        case 1:
        case 2:
        case 3:
          this.validateAllSelectionsMade();
          break;
        case 4:
          this.mobile.displayMode = "productInfo";
          break;
      }
    },
    enableAppScroll,
    disableAppScroll,
    async loadProjectsAndShowProjectModal() {
      await this.loadProjects();

      this.$modal.show("save-to-project");
    },
    openNewProjectModal() {
      this.$modal.show("add-new-project");
    },
    async addNewProject() {
      if (this.newProjectName === "") {
        return;
      }
      // post project
      let { id } = await this.$shopApiClient.addProjectsAsCustomer(
        this.newProjectName
      );

      if (id) {
        this.$store.dispatch("setState", {
          stateKey: "projects",
          data: this.projects.push({ id, name: this.newProjectName }),
        });

        this.currentProjectId = parseInt(id);
      }
      // close modal
      this.$modal.hide("add-new-project");
    },
    async loadProjects() {
      let { projects } = await this.$shopApiClient.getProjects();
      this.$store.commit("setState", { stateKey: "projects", data: projects });
    },
    summaryByLocale(locale = "de") {
      let cable = `${this.selectedValue("cables", "cableType") || ""} ${
        this.selectedValue("cables", "fiberCount") || ""
      }${
        this.remainingCables.length === 1
          ? this.remainingCables[0].fiberType
          : ""
      } ${
        this.selectedValue("cables", "fiberClass")
          ? "(" + this.selectedValue("cables", "fiberClass") + ")"
          : ""
      }\n${
        this.selectedValue("cables", "manufacturer")
          ? "" + this.selectedValue("cables", "manufacturer")
          : ""
      }${
        this.selectedValue("cables", "cableColor")
          ? ", " +
            this.$t(
              "colorNames." + this.selectedValue("cables", "cableColor"),
              locale
            )
          : ""
      }`;

      this.isDataCenterMode ? (cable += ` (DA)`) : (cable += ` (VA)`);

      if (
        this.remainingCables.length === 1 &&
        this.remainingCables[0].cpr !== "null"
      ) {
        cable = `${cable}
          ${this.$t("cable-cpr")}: ${this.remainingCables[0].cpr}`;
      }

      let plugA = "";
      if (
        (this.selectedValue("plugsA", "plugType") &&
          this.selectedValue("plugsA", "plugType") !== "") ||
        (this.selectedValue("plugsA", "polish") &&
          this.selectedValue("plugsA", "polish") !== "") ||
        (this.selectedValue("plugsA", "plex") &&
          this.selectedValue("plugsA", "plex") !== "") ||
        (this.selectedValue("plugsA", "plex") &&
          this.selectedValue("plugsA", "manufacturer") !== "") ||
        (this.selectedValue("plugsA", "plugColor") &&
          this.selectedValue("plugsA", "plugColor") !== "")
      )
        plugA = `${this.$t("side")} A: ${
          this.calculatePlugCount({
            fiberCount: this.selectedValue("cables", "fiberCount"),
            plugType: this.selectedValue("plugsA", "plugType"),
            plex: this.selectedValue("plugsA", "plex"),
          })
            ? this.calculatePlugCount({
                fiberCount: this.selectedValue("cables", "fiberCount"),
                plugType: this.selectedValue("plugsA", "plugType"),
                plex: this.selectedValue("plugsA", "plex"),
              }) + "x "
            : ""
        } ${this.selectedValue("plugsA", "plugType") || ""} ${
          this.selectedValue("plugsA", "polish") || ""
        } ${
          this.selectedValue("plugsA", "plex") &&
           (this.selectedValue("plugsA", "plex") === "MDC" || this.selectedValue("plugsA", "plex") === "SN EZ-Flip" || this.selectedValue("plugsA", "plex") === "MTP")
    ? ""
    : this.selectedValue("plugsA", "plex")
        } ${this.selectedValue("plugsA", "manufacturer") || ""} ${
          this.selectedValue("plugsA", "plugColor")
            ? this.$t(
                "colorNames." + this.selectedValue("plugsA", "plugColor"),
                locale
              )
            : ""
        }${
          this.selectedValue("plugsA", "clip")
            ? ", Clip: " +
              this.selectedValue("plugsA", "clip")
                .replace("ohne", locale === "en" ? "none" : "ohne")
                .replace("mit", locale === "en" ? "with" : "mit")
            : ""
        }`;

      let bendProtectionA = "";
      if (this.selectedBendProtectionA)
        bendProtectionA = `${this.$t("bend-protection", locale)}: ${
          this.selectedBendProtectionA.colorTop ===
          this.selectedBendProtectionA.colorBottom
            ? this.$t(
                "colorNames." + this.selectedBendProtectionA.colorTop,
                locale
              )
            : this.$t(
                "colorNames." + this.selectedBendProtectionA.colorTop,
                locale
              ) +
              "/" +
              this.$t(
                "colorNames." + this.selectedBendProtectionA.colorBottom,
                locale
              )
        } ${this.selectedBendProtectionA.flexibility}`;

      let whipA = "";
      if (this.selectedValue("whipsA", "id")) {
        try {
          whipA = `, ${this.$t("whip", locale)}: ${
            this.$store.state.whips.filter(
              (whip) => whip.id === this.selectedValue("whipsA", "id")
            )[0].length
          }`;
        } catch (e) {
          this.$rollbar.log(e);
        }
      }

      // if (this.selectedValue('whipsAStepping', 'type') === `tiered`)
      //   whipA += ` ${ this.$t('whipSteppings.tiered') }`

      let protectionA = this.selectedValue("protectionsA", "id")
        ? `\n${this.$t(
            this.$store.state.protections.filter(
              (item) => item.id === this.selectedValue("protectionsA", "id")
            )[0].description,
            locale
          )}`
        : "";

      let fixationA = this.selectedValue("fixationsA", "id")
        ? `\n${
            this.$store.state.fixations.filter(
              (item) => item.id === this.selectedValue("fixationsA", "id")
            )[0].size
          } ${this.$t("inkl. Gegenmutter", locale)}`
        : "";

      let labelA = "";
      try {
        labelA = this.selectedValue("labelsA", "id")
          ? `\n${this.$t(
              "labels." +
                this.$store.state.labels.filter(
                  (item) => item.id === this.selectedValue("labelsA", "id")
                )[0].longDescription,
              locale
            )}`
          : "";
      } catch (e) {
        this.$rollbar.log(e);
      }

      let plugB = "";
      if (
        (this.selectedValue("plugsB", "plugType") &&
          this.selectedValue("plugsB", "plugType") !== "") ||
        (this.selectedValue("plugsB", "polish") &&
          this.selectedValue("plugsB", "polish") !== "") ||
        (this.selectedValue("plugsB", "plex") &&
          this.selectedValue("plugsB", "plex") !== "") ||
        (this.selectedValue("plugsB", "plex") &&
          this.selectedValue("plugsB", "manufacturer") !== "") ||
        (this.selectedValue("plugsB", "plugColor") &&
          this.selectedValue("plugsB", "plugColor") !== "")
      )
        plugB = `${this.$t("side")} B: ${
          this.calculatePlugCount({
            fiberCount: this.selectedValue("cables", "fiberCount"),
            plugType: this.selectedValue("plugsB", "plugType"),
            plex: this.selectedValue("plugsB", "plex"),
          })
            ? this.calculatePlugCount({
                fiberCount: this.selectedValue("cables", "fiberCount"),
                plugType: this.selectedValue("plugsB", "plugType"),
                plex: this.selectedValue("plugsB", "plex"),
              }) + "x "
            : ""
        } ${this.selectedValue("plugsB", "plugType") || ""} ${
          this.selectedValue("plugsB", "polish") || ""
        } ${
          this.selectedValue("plugsB", "plex") &&
          (this.selectedValue("plugsB", "plex") === "MDC" || this.selectedValue("plugsB", "plex") === "SN EZ-Flip" || this.selectedValue("plugsB", "plex") === "MTP")
    ? ""
    : this.selectedValue("plugsB", "plex")
        } ${this.selectedValue("plugsB", "manufacturer") || ""} ${
          this.selectedValue("plugsB", "plugColor")
            ? this.$t(
                "colorNames." + this.selectedValue("plugsB", "plugColor"),
                locale
              )
            : ""
        }${
          this.selectedValue("plugsB", "clip")
            ? ", Clip: " +
              this.selectedValue("plugsB", "clip")
                .replace("ohne", locale === "en" ? "none" : "ohne")
                .replace("mit", locale === "en" ? "with" : "mit")
            : ""
        }`;

      if (this.isPigtail)
        plugB = `${this.$t("side", locale)} B: ${this.$t("open", locale)}`;

      let whipB = "";
      if (this.selectedValue("whipsB", "id")) {
        try {
          whipB = `, ${this.$t("whip", locale)}: ${
            this.$store.state.whips.filter(
              (whip) => whip.id === this.selectedValue("whipsB", "id")
            )[0].length
          }`;
        } catch (e) {
          this.$rollbar.log(e);
        }
      }

      // if (this.selectedValue('whipsBStepping', 'type') === `tiered`)
      //   whipB += ` ${ this.$t('whipSteppings.tiered') }`

      let bendProtectionB = "";
      if (this.selectedBendProtectionB)
        bendProtectionB = `${this.$t("bend-protection", locale)}: ${
          this.selectedBendProtectionB.colorTop ===
          this.selectedBendProtectionB.colorBottom
            ? this.$t(
                "colorNames." + this.selectedBendProtectionB.colorTop,
                locale
              )
            : this.$t(
                "colorNames." + this.selectedBendProtectionB.colorTop,
                locale
              ) +
              "/" +
              this.$t(
                "colorNames." + this.selectedBendProtectionB.colorBottom,
                locale
              )
        } ${this.selectedBendProtectionB.flexibility}`;

      let protectionB = this.selectedValue("protectionsB", "id")
        ? `\n${this.$t(
            this.$store.state.protections.filter(
              (item) => item.id === this.selectedValue("protectionsB", "id")
            )[0].description,
            locale
          )}`
        : "";

      let fixationB = this.selectedValue("fixationsB", "id")
        ? `\n${
            this.$store.state.fixations.filter(
              (item) => item.id === this.selectedValue("fixationsB", "id")
            )[0].size
          } ${this.$t("inkl. Gegenmutter", locale)}`
        : "";

      let labelB = "";
      try {
        labelB = this.selectedValue("labelsB", "id")
          ? `\n${this.$t(
              "labels." +
                this.$store.state.labels.filter(
                  (item) => item.id === this.selectedValue("labelsB", "id")
                )[0].longDescription,
              locale
            )}`
          : "";
      } catch (e) {
        this.$rollbar.log(e);
      }

      return stripIndents`${cable}
                          ${plugA}
                          ${bendProtectionA.trim()}${whipA}${protectionA}${fixationA}${labelA}

                          ${plugB}
                          ${bendProtectionB.trim()}${whipB}${protectionB}${fixationB}${labelB}`;
    },
    async addToMyCatalog() {
      // strip count and set show in catalog to true
      // eslint-disable-next-line no-unused-vars
      let { count, ...body } = Object.assign({}, this.shopCable, {
        show_in_catalog: 1, // override show_in_catalog from the computed prop
        use_pricegroup_new: 0, // old catalog
      });

      // delete body.materialgroup_id
      // delete body.industry_ids
      // delete body.visibility
      // body.use_pricegroup_new = 0

      // save independet of cable length
      // ToDo: recalculate price to min length
      if (this.lengthIndependent) {
        body = Object.assign(body, {
          length_min: 1,
          length_max: 300,
          price_m: this.$store.state.cablePricePerMeter,
        });
      }

      // if the product can be matched to a real product number
      // put it into the product number prop
      if (this.customProductNumber && this.customProductNumber.trim() !== "") {
        body["artnr"] = this.customProductNumber;
      }

      if (
        this.resolvedProductNumber &&
        this.resolvedProductNumber.trim() !== ""
      ) {
        body["artnr_potential"] = this.resolvedProductNumber;
      }

      // save the cable
      let { success, id, error } = await this.$shopApiClient.postCable({
        data: body,
      });
      if (!id && success === false) {
        this.$rollbar.error("can not create product in backend", error);
        return;
      }

      this.$store.dispatch("cacheShopIdWithSpecification", id);

      this.$modal.hide("save-to-catalog");

      let addToMyCatalog = this.$refs["addToMyCatalog"];
      addToMyCatalog.innerHTML = this.$t("saveToMyCatalogueDone");
      addToMyCatalog.classList.add("pointer-events-none");

      this.$notify({
        group: "app",
        text: "Kabel in den Katalog gelegt",
        type: "success",
      });
    },
    async addToFavorites() {
      // eslint-disable-next-line no-unused-vars
      let { count, show_in_catalog, ...body } = this.shopCable;

      // eslint-disable-next-line no-unused-vars
      let { success, id, error } = await this.$shopApiClient.postCable({
        data: body,
      });
      if (!id && success === false) {
        this.$rollbar.error(error);
        return;
      }

      body.use_pricegroup_new = 0; // old catalog

      let {
        success: success2,
        error: error2,
        favoritesCount,
      } = await this.$shopApiClient.addToFavorites({ id });

      if (!success2 || error2) {
        this.$rollbar.error("can not add product to cart");
      }

      let addToFavorites = this.$refs["addToFavorites"];
      addToFavorites.innerHTML = this.$t("addToFavoritesDone");
      addToFavorites.classList.add("pointer-events-none");

      try {
        let favoritesCountElement = document.querySelector(".count");
        favoritesCountElement.innerHTML = `(${favoritesCount})`;
      } catch (e) {
        this.$rollbar.warn("can not set favorites count in template");
      }

      this.$notify({
        group: "app",
        text: "Kabel gemerkt",
        type: "success",
      });
    },
    // Auto-select spreaders by cable color
    syncSpreadersByColor() {
      const cableColor = this.selectedValue('cables', 'cableColor')
      if (!cableColor) return

      // Sync spreaders A
      const validSpreadersA = this.spreadersAByColor
      if (validSpreadersA.length === 1) {
        this.$store.dispatch('setLastFilterAndFilter', {
          filterKey: 'spreadersA',
          propertyName: 'id',
          propertyValue: validSpreadersA[0].id
        })
      } else if (validSpreadersA.length === 0) {
        // Clear invalid selection
        this.$store.dispatch('removeAutoAppliedFiltersAndLastFilterAndFilter', {
          filterKey: 'spreadersA',
          propertyName: 'id'
        })
      }

      // Sync spreaders B
      const validSpreadersB = this.spreadersBByColor
      if (validSpreadersB.length === 1) {
        this.$store.dispatch('setLastFilterAndFilter', {
          filterKey: 'spreadersB',
          propertyName: 'id',
          propertyValue: validSpreadersB[0].id
        })
      } else if (validSpreadersB.length === 0) {
        // Clear invalid selection
        this.$store.dispatch('removeAutoAppliedFiltersAndLastFilterAndFilter', {
          filterKey: 'spreadersB',
          propertyName: 'id'
        })
      }
    }
  },
  mixins: [
    openRegistration,
    buildProductProperties,
    triggerMixin,
    projectsNormalizerMixin,
  ],
  watch: {
    currentProjectId(val) {
      if (val === -1) {
        this.openNewProjectModal();
      }
    },
    // Watch for cable color changes and sync with spreaders
    'filters.cables'(newVal, oldVal) {
      if (newVal.cableColor !== (oldVal && oldVal.cableColor)) {
        // Cable color changed - sync spreaders
        this.syncSpreadersByColor();
      }
    }
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style> 
